var RC;
// mobilecheck 

(window.mobilecheck = function() {
	var t, e = !1;
	return (t =
					navigator.userAgent ||
					navigator.vendor ||
					window.opera), (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
							t
					) ||
					/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
							t.substr(0, 4)
					)) &&
			(e = !0), e;
});

// Vue.min.js lib

(function(t, e) {
	"object" == typeof exports && "undefined" != typeof module ? (module.exports = e()) : "function" == typeof define && define.amd ? define(e) : (t.Vue = e());
})(this, function() {
	"use strict";

	function t(t) {
			return null == t ? "" : "object" == typeof t ? JSON.stringify(t, null, 2) : String(t);
	}

	function e(t) {
			var e = parseFloat(t);
			return isNaN(e) ? t : e;
	}

	function n(t, e) {
			for (
					var n = Object.create(null), r = t.split(","), i = 0; i < r.length; i++
			) n[r[i]] = !0;
			return e ? function(t) {
					return n[t.toLowerCase()];
			} : function(t) {
					return n[t];
			};
	}
	var r = n("slot,component", !0);

	function i(t, e) {
			if (t.length) {
					var n = t.indexOf(e);
					if (n > -1) return t.splice(n, 1);
			}
	}
	var o = Object.prototype.hasOwnProperty;

	function a(t, e) {
			return o.call(t, e);
	}

	function s(t) {
			return "string" == typeof t || "number" == typeof t;
	}

	function c(t) {
			var e = Object.create(null);
			return function(n) {
					return e[n] || (e[n] = t(n));
			};
	}
	var u = /-(\w)/g,
			l = c(function(t) {
					return t.replace(u, function(t, e) {
							return e ? e.toUpperCase() : "";
					});
			}),
			d = c(function(t) {
					return t.charAt(0).toUpperCase() + t.slice(1);
			}),
			p = /([^-])([A-Z])/g,
			f = c(function(t) {
					return t.replace(p, "$1-$2").replace(p, "$1-$2").toLowerCase();
			});

	function h(t, e) {
			function n(n) {
					var r = arguments.length;
					return r ? (r > 1 ? t.apply(e, arguments) : t.call(e, n)) : t.call(e);
			}
			return (n._length = t.length), n;
	}

	function m(t, e) {
			e = e || 0;
			for (var n = t.length - e, r = new Array(n); n--;) r[n] = t[n + e];
			return r;
	}

	function v(t, e) {
			for (var n in e) t[n] = e[n];
			return t;
	}

	function g(t) {
			return null !== t && "object" == typeof t;
	}
	var y = Object.prototype.toString,
			b = "[object Object]";

	function w(t) {
			return y.call(t) === b;
	}

	function _(t) {
			for (var e = {}, n = 0; n < t.length; n++) t[n] && v(e, t[n]);
			return e;
	}

	function x() {}
	var k = function() {
					return !1;
			},
			S = function(t) {
					return t;
			};

	function C(t) {
			return t
					.reduce(function(t, e) {
							return t.concat(e.staticKeys || []);
					}, [])
					.join(",");
	}

	function T(t, e) {
			var n = g(t),
					r = g(e);
			return n && r ? JSON.stringify(t) === JSON.stringify(e) : !n && !r && String(t) === String(e);
	}

	function E(t, e) {
			for (var n = 0; n < t.length; n++)
					if (T(t[n], e)) return n;
			return -1;
	}
	var A = {
			optionMergeStrategies: Object.create(null),
			silent: !1,
			devtools: !0,
			errorHandler: null,
			ignoredElements: [],
			keyCodes: Object.create(null),
			isReservedTag: k,
			isUnknownElement: k,
			getTagNamespace: x,
			parsePlatformTagName: S,
			mustUseProp: k,
			_assetTypes: ["component", "directive", "filter"],
			_lifecycleHooks: [
					"beforeCreate",
					"created",
					"beforeMount",
					"mounted",
					"beforeUpdate",
					"updated",
					"beforeDestroy",
					"destroyed",
					"activated",
					"deactivated"
			],
			_maxUpdateCount: 100
	};

	function $(t) {
			var e = (t + "").charCodeAt(0);
			return 36 === e || 95 === e;
	}

	function j(t, e, n, r) {
			Object.defineProperty(t, e, {
					value: n,
					enumerable: !!r,
					writable: !0,
					configurable: !0
			});
	}
	var I = /[^\w.$]/;

	function N(t) {
			if (!I.test(t)) {
					var e = t.split(".");
					return function(t) {
							for (var n = 0; n < e.length; n++) {
									if (!t) return;
									t = t[e[n]];
							}
							return t;
					};
			}
	}
	var z,
			O = "__proto__" in {},
			L = "undefined" != typeof window,
			P = L && window.navigator.userAgent.toLowerCase(),
			M = P && /msie|trident/.test(P),
			D = P && P.indexOf("msie 9.0") > 0,
			q = P && P.indexOf("edge/") > 0,
			R = P && P.indexOf("android") > 0,
			F = P && /iphone|ipad|ipod|ios/.test(P),
			W = function() {
					return void 0 === z &&
							(z = !L &&
									"undefined" != typeof global &&
									"server" === global.process.env.VUE_ENV), z;
			},
			H = L && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

	function V(t) {
			return /native code/.test(t.toString());
	}
	var B,
			U = (function() {
					var t, e = [],
							n = !1;

					function r() {
							n = !1;
							var t = e.slice(0);
							e.length = 0;
							for (var r = 0; r < t.length; r++)
									t[r]();
					}
					if ("undefined" != typeof Promise && V(Promise)) {
							var i = Promise.resolve(),
									o = function(t) {
											console.error(t);
									};
							t = function() {
									i.then(r).catch(o), F && setTimeout(x);
							};
					} else if (
							"undefined" == typeof MutationObserver ||
							(!V(MutationObserver) &&
									"[object MutationObserverConstructor]" !==
									MutationObserver.toString())
					)
							t = function() {
									setTimeout(r, 0);
							};
					else {
							var a = 1,
									s = new MutationObserver(r),
									c = document.createTextNode(String(a));
							s.observe(c, {
									characterData: !0
							}), (t = function() {
									(a = (a + 1) % 2), (c.data = String(a));
							});
					}
					return function(r, i) {
							var o;
							if (
									(e.push(function() {
											r && r.call(i), o && o(i);
									}), n || ((n = !0), t()), !r && "undefined" != typeof Promise)
							)
									return new Promise(function(t) {
											o = t;
									});
					};
			})();
	B = "undefined" != typeof Set && V(Set) ? Set : (function() {
			function t() {
					this.set = Object.create(null);
			}
			return (t.prototype.has = function(t) {
					return !0 === this.set[t];
			}), (t.prototype.add = function(t) {
					this.set[t] = !0;
			}), (t.prototype.clear = function() {
					this.set = Object.create(null);
			}), t;
	})();
	var J, Q = x,
			G = "undefined" != typeof console;
	(Q = function(t, e) {
			G &&
					!A.silent &&
					console.error("[Vue warn]: " + t + " " + (e ? X(J(e)) : ""));
	}), (J = function(t) {
			if (t.$root === t) return "root instance";
			var e = t._isVue ? t.$options.name || t.$options._componentTag : t.name;
			return (
					(e ? "component <" + e + ">" : "anonymous component") +
					(t._isVue && t.$options.__file ? " at " + t.$options.__file : "")
			);
	});
	var X = function(t) {
					return "anonymous component" === t &&
							(t +=
									' - use the "name" option for better debugging messages.'), "\n(found in " +
							t +
							")";
			},
			Y = 0,
			K = function() {
					(this.id = Y++), (this.subs = []);
			};
	(K.prototype.addSub = function(t) {
			this.subs.push(t);
	}), (K.prototype.removeSub = function(t) {
			i(this.subs, t);
	}), (K.prototype.depend = function() {
			K.target && K.target.addDep(this);
	}), (K.prototype.notify = function() {
			for (var t = this.subs.slice(), e = 0, n = t.length; e < n; e++)
					t[e].update();
	}), (K.target = null);
	var Z = [];
	var tt = Array.prototype,
			et = Object.create(tt);
	[
			"push",
			"pop",
			"shift",
			"unshift",
			"splice",
			"sort",
			"reverse"
	].forEach(function(t) {
			var e = tt[t];
			j(et, t, function() {
					for (
							var n = arguments, r = arguments.length, i = new Array(r); r--;

					) i[r] = n[r];
					var o, a = e.apply(this, i),
							s = this.__ob__;
					switch (t) {
							case "push":
							case "unshift":
									o = i;
									break;
							case "splice":
									o = i.slice(2);
					}
					return o && s.observeArray(o), s.dep.notify(), a;
			});
	});
	var nt = Object.getOwnPropertyNames(et),
			rt = {
					shouldConvert: !0,
					isSettingProps: !1
			},
			it = function(t) {
					((this.value = t), (this.dep = new K()), (this.vmCount = 0), j(
							t,
							"__ob__",
							this
					), Array.isArray(t)) ? ((O ? ot : at)(t, et, nt), this.observeArray(t)) : this.walk(t);
			};

	function ot(t, e) {
			t.__proto__ = e;
	}

	function at(t, e, n) {
			for (var r = 0, i = n.length; r < i; r++) {
					var o = n[r];
					j(t, o, e[o]);
			}
	}

	function st(t, e) {
			var n;
			if (g(t))
					return a(t, "__ob__") && t.__ob__ instanceof it ? (n = t.__ob__) : rt.shouldConvert &&
							!W() &&
							(Array.isArray(t) || w(t)) &&
							Object.isExtensible(t) &&
							!t._isVue &&
							(n = new it(t)), e && n && n.vmCount++, n;
	}

	function ct(t, e, n, r) {
			var i = new K(),
					o = Object.getOwnPropertyDescriptor(t, e);
			if (!o || !1 !== o.configurable) {
					var a = o && o.get,
							s = o && o.set,
							c = st(n);
					Object.defineProperty(t, e, {
							enumerable: !0,
							configurable: !0,
							get: function() {
									var e = a ? a.call(t) : n;
									return K.target &&
											(i.depend(), c && c.dep.depend(), Array.isArray(e) &&
													(function t(e) {
															for (var n = void 0, r = 0, i = e.length; r < i; r++)
																	(n = e[r]) &&
																	n.__ob__ &&
																	n.__ob__.dep.depend(), Array.isArray(n) && t(n);
													})(e)), e;
							},
							set: function(e) {
									var o = a ? a.call(t) : n;
									e === o ||
											(e != e && o != o) ||
											(r && r(), s ? s.call(t, e) : (n = e), (c = st(e)), i.notify());
							}
					});
			}
	}

	function ut(t, e, n) {
			if (Array.isArray(t))
					return (t.length = Math.max(t.length, e)), t.splice(e, 1, n), n;
			if (a(t, e)) t[e] = n;
			else {
					var r = t.__ob__;
					if (t._isVue || (r && r.vmCount))
							Q(
									"Avoid adding reactive properties to a Vue instance or its root $data at runtime - declare it upfront in the data option."
							);
					else {
							if (r) return ct(r.value, e, n), r.dep.notify(), n;
							t[e] = n;
					}
			}
	}

	function lt(t, e) {
			var n = t.__ob__;
			t._isVue || (n && n.vmCount) ? Q(
					"Avoid deleting properties on a Vue instance or its root $data - just set it to null."
			) : a(t, e) && (delete t[e], n && n.dep.notify());
	}
	(it.prototype.walk = function(t) {
			for (var e = Object.keys(t), n = 0; n < e.length; n++)
					ct(t, e[n], t[e[n]]);
	}), (it.prototype.observeArray = function(t) {
			for (var e = 0, n = t.length; e < n; e++)
					st(t[e]);
	});
	var dt = A.optionMergeStrategies;

	function pt(t, e) {
			if (!e) return t;
			for (
					var n, r, i, o = Object.keys(e), s = 0; s < o.length; s++
			)(r = t[(n = o[s])]), (i = e[n]), a(t, n) ? w(r) && w(i) && pt(r, i) : ut(t, n, i);
			return t;
	}

	function ft(t, e) {
			return e ? (t ? t.concat(e) : Array.isArray(e) ? e : [e]) : t;
	}

	function ht(t, e) {
			var n = Object.create(t || null);
			return e ? v(n, e) : n;
	}
	(dt.el = dt.propsData = function(t, e, n, r) {
			return n ||
					Q(
							'option "' +
							r +
							'" can only be used during instance creation with the `new` keyword.'
					), mt(t, e);
	}), (dt.data = function(t, e, n) {
			return n ? t || e ? function() {
					var r = "function" == typeof e ? e.call(n) : e,
							i = "function" == typeof t ? t.call(n) : void 0;
					return r ? pt(r, i) : i;
			} : void 0 : e ? "function" != typeof e ? (Q(
					'The "data" option should be a function that returns a per-instance value in component definitions.',
					n
			), t) : t ? function() {
					return pt(e.call(this), t.call(this));
			} : e : t;
	}), A._lifecycleHooks.forEach(function(t) {
			dt[t] = ft;
	}), A._assetTypes.forEach(function(t) {
			dt[t + "s"] = ht;
	}), (dt.watch = function(t, e) {
			if (!e) return t;
			if (!t) return e;
			var n = {};
			v(n, t);
			for (var r in e) {
					var i = n[r],
							o = e[r];
					i && !Array.isArray(i) && (i = [i]), (n[r] = i ? i.concat(o) : [o]);
			}
			return n;
	}), (dt.props = dt.methods = dt.computed = function(t, e) {
			if (!e) return t;
			if (!t) return e;
			var n = Object.create(null);
			return v(n, t), v(n, e), n;
	});
	var mt = function(t, e) {
			return void 0 === e ? t : e;
	};

	function vt(t, e, n) {
			!(function(t) {
					for (var e in t.components) {
							var n = e.toLowerCase();
							(r(n) || A.isReservedTag(n)) &&
							Q(
									"Do not use built-in or reserved HTML elements as component id: " +
									e
							);
					}
			})(e), (function(t) {
					var e = t.props;
					if (e) {
							var n, r, i = {};
							if (Array.isArray(e))
									for (n = e.length; n--;)
											"string" == typeof(r = e[n]) ? (i[l(r)] = {
													type: null
											}) : Q("props must be strings when using array syntax.");
							else if (w(e))
									for (var o in e)
											(r = e[o]), (i[l(o)] = w(r) ? r : {
													type: r
											});
							t.props = i;
					}
			})(e), (function(t) {
					var e = t.directives;
					if (e)
							for (var n in e) {
									var r = e[n];
									"function" == typeof r && (e[n] = {
											bind: r,
											update: r
									});
							}
			})(e);
			var i = e.extends;
			if ((i && (t = vt(t, "function" == typeof i ? i.options : i, n)), e.mixins))
					for (var o = 0, s = e.mixins.length; o < s; o++) {
							var c = e.mixins[o];
							c.prototype instanceof Ee && (c = c.options), (t = vt(t, c, n));
					}
			var u, d = {};
			for (u in t) p(u);
			for (u in e) a(t, u) || p(u);

			function p(r) {
					var i = dt[r] || mt;
					d[r] = i(t[r], e[r], n, r);
			}
			return d;
	}

	function gt(t, e, n, r) {
			if ("string" == typeof n) {
					var i = t[e];
					if (a(i, n)) return i[n];
					var o = l(n);
					if (a(i, o)) return i[o];
					var s = d(o);
					if (a(i, s)) return i[s];
					var c = i[n] || i[o] || i[s];
					return r &&
							!c &&
							Q("Failed to resolve " + e.slice(0, -1) + ": " + n, t), c;
			}
	}

	function yt(t, e, n, r) {
			var i = e[t],
					o = !a(n, t),
					s = n[t];
			if (
					(_t(Boolean, i.type) &&
							(o && !a(i, "default") ? (s = !1) : _t(String, i.type) ||
									("" !== s && s !== f(t)) ||
									(s = !0)), void 0 === s)
			) {
					s = (function(t, e, n) {
							if (!a(e, "default")) return;
							var r = e.default;
							g(r) &&
									Q(
											'Invalid default value for prop "' +
											n +
											'": Props with type Object/Array must use a factory function to return the default value.',
											t
									);
							if (
									t &&
									t.$options.propsData &&
									void 0 === t.$options.propsData[n] &&
									void 0 !== t[n]
							)
									return t[n];
							return "function" == typeof r && e.type !== Function ? r.call(t) : r;
					})(r, i, t);
					var c = rt.shouldConvert;
					(rt.shouldConvert = !0), st(s), (rt.shouldConvert = c);
			}
			return (function(t, e, n, r, i) {
					if (t.required && i)
							return void Q('Missing required prop: "' + e + '"', r);
					if (null == n && !t.required) return;
					var o = t.type,
							a = !o || !0 === o,
							s = [];
					if (o) {
							Array.isArray(o) || (o = [o]);
							for (var c = 0; c < o.length && !a; c++) {
									var u = bt(n, o[c]);
									s.push(u.expectedType || ""), (a = u.valid);
							}
					}
					if (!a)
							return void Q(
									'Invalid prop: type check failed for prop "' +
									e +
									'". Expected ' +
									s.map(d).join(", ") +
									", got " +
									Object.prototype.toString.call(n).slice(8, -1) +
									".",
									r
							);
					var l = t.validator;
					l &&
							(l(n) ||
									Q(
											'Invalid prop: custom validator check failed for prop "' + e + '".',
											r
									));
			})(i, t, s, r, o), s;
	}

	function bt(t, e) {
			var n = wt(e);
			return {
					valid: "String" === n ? typeof t == (n = "string") : "Number" === n ? typeof t == (n = "number") : "Boolean" === n ? typeof t == (n = "boolean") : "Function" === n ? typeof t == (n = "function") : "Object" === n ? w(t) : "Array" === n ? Array.isArray(t) : t instanceof e,
					expectedType: n
			};
	}

	function wt(t) {
			var e = t && t.toString().match(/^\s*function (\w+)/);
			return e && e[1];
	}

	function _t(t, e) {
			if (!Array.isArray(e)) return wt(e) === wt(t);
			for (var n = 0, r = e.length; n < r; n++)
					if (wt(e[n]) === wt(t)) return !0;
			return !1;
	}
	var xt,
			kt = Object.freeze({
					defineReactive: ct,
					_toString: t,
					toNumber: e,
					makeMap: n,
					isBuiltInTag: r,
					remove: i,
					hasOwn: a,
					isPrimitive: s,
					cached: c,
					camelize: l,
					capitalize: d,
					hyphenate: f,
					bind: h,
					toArray: m,
					extend: v,
					isObject: g,
					isPlainObject: w,
					toObject: _,
					noop: x,
					no: k,
					identity: S,
					genStaticKeys: C,
					looseEqual: T,
					looseIndexOf: E,
					isReserved: $,
					def: j,
					parsePath: N,
					hasProto: O,
					inBrowser: L,
					UA: P,
					isIE: M,
					isIE9: D,
					isEdge: q,
					isAndroid: R,
					isIOS: F,
					isServerRendering: W,
					devtools: H,
					nextTick: U,
					get _Set() {
							return B;
					},
					mergeOptions: vt,
					resolveAsset: gt,
					get warn() {
							return Q;
					},
					get formatComponentName() {
							return J;
					},
					validateProp: yt
			}),
			St = n(
					"Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,require"
			),
			Ct = function(t, e) {
					Q(
							'Property or method "' +
							e +
							'" is not defined on the instance but referenced during render. Make sure to declare reactive data properties in the data option.',
							t
					);
			},
			Tt = "undefined" != typeof Proxy && Proxy.toString().match(/native code/);
	if (Tt) {
			var Et = n("stop,prevent,self,ctrl,shift,alt,meta");
			A.keyCodes = new Proxy(A.keyCodes, {
					set: function(t, e, n) {
							return Et(e) ? (Q(
									"Avoid overwriting built-in modifier in config.keyCodes: ." + e
							), !1) : ((t[e] = n), !0);
					}
			});
	}
	var At = {
					has: function(t, e) {
							var n = e in t,
									r = St(e) || "_" === e.charAt(0);
							return n || r || Ct(t, e), n || !r;
					}
			},
			$t = {
					get: function(t, e) {
							return "string" != typeof e || e in t || Ct(t, e), t[e];
					}
			};
	xt = function(t) {
			if (Tt) {
					var e = t.$options,
							n = e.render && e.render._withStripped ? $t : At;
					t._renderProxy = new Proxy(t, n);
			} else t._renderProxy = t;
	};
	var jt = function(t, e, n, r, i, o, a) {
					(this.tag = t), (this.data = e), (this.children = n), (this.text = r), (this.elm = i), (this.ns = void 0), (this.context = o), (this.functionalContext = void 0), (this.key =
							e &&
							e.key), (this.componentOptions = a), (this.componentInstance = void 0), (this.parent = void 0), (this.raw = !1), (this.isStatic = !1), (this.isRootInsert = !0), (this.isComment = !1), (this.isCloned = !1), (this.isOnce = !1);
			},
			It = {
					child: {}
			};
	(It.child.get = function() {
			return this.componentInstance;
	}), Object.defineProperties(jt.prototype, It);
	var Nt = function() {
			var t = new jt();
			return (t.text = ""), (t.isComment = !0), t;
	};

	function zt(t) {
			return new jt(void 0, void 0, void 0, String(t));
	}

	function Ot(t) {
			var e = new jt(
					t.tag,
					t.data,
					t.children,
					t.text,
					t.elm,
					t.context,
					t.componentOptions
			);
			return (e.ns =
					t.ns), (e.isStatic = t.isStatic), (e.key = t.key), (e.isCloned = !0), e;
	}

	function Lt(t) {
			for (var e = new Array(t.length), n = 0; n < t.length; n++) e[n] = Ot(t[n]);
			return e;
	}
	var Pt = {
					init: function(t, e, n, r) {
							if (!t.componentInstance || t.componentInstance._isDestroyed) {
									var i = (t.componentInstance = (function(t, e, n, r) {
											var i = t.componentOptions,
													o = {
															_isComponent: !0,
															parent: e,
															propsData: i.propsData,
															_componentTag: i.tag,
															_parentVnode: t,
															_parentListeners: i.listeners,
															_renderChildren: i.children,
															_parentElm: n || null,
															_refElm: r || null
													},
													a = t.data.inlineTemplate;
											a && ((o.render = a.render), (o.staticRenderFns = a.staticRenderFns));
											return new i.Ctor(o);
									})(t, ne, n, r));
									i.$mount(e ? t.elm : void 0, e);
							} else if (t.data.keepAlive) {
									var o = t;
									qt(o, o);
							}
					},
					prepatch: qt,
					insert: function(t) {
							t.componentInstance._isMounted ||
									((t.componentInstance._isMounted = !0), re(
											t.componentInstance,
											"mounted"
									));
							t.data.keepAlive &&
									((t.componentInstance._inactive = !1), re(
											t.componentInstance,
											"activated"
									));
					},
					destroy: function(t) {
							t.componentInstance._isDestroyed ||
									(t.data.keepAlive ? ((t.componentInstance._inactive = !0), re(
											t.componentInstance,
											"deactivated"
									)) : t.componentInstance.$destroy());
					}
			},
			Mt = Object.keys(Pt);

	function Dt(t, e, n, r, i) {
			if (t) {
					var o = n.$options._base;
					if ((g(t) && (t = o.extend(t)), "function" == typeof t)) {
							if (!t.cid)
									if (t.resolved) t = t.resolved;
									else if (!(t = (function(t, e, n) {
											{
													if (!t.requested) {
															t.requested = !0;
															var r = (t.pendingCallbacks = [n]),
																	i = !0,
																	o = function(n) {
																			if ((g(n) && (n = e.extend(n)), (t.resolved = n), !i))
																					for (var o = 0, a = r.length; o < a; o++)
																							r[o](n);
																	},
																	a = function(e) {
																			Q(
																					"Failed to resolve async component: " +
																					String(t) +
																					(e ? "\nReason: " + e : "")
																			);
																	},
																	s = t(o, a);
															return s &&
																	"function" == typeof s.then &&
																	!t.resolved &&
																	s.then(o, a), (i = !1), t.resolved;
													}
													t.pendingCallbacks.push(n);
											}
									})(t, o, function() {
											n.$forceUpdate();
									})))
									return;
							Te(t);
							var a = (function(t, e) {
									var n = e.options.props;
									if (!n) return;
									var r = {},
											i = t.attrs,
											o = t.props,
											a = t.domProps;
									if (i || o || a)
											for (var s in n) {
													var c = f(s);
													Rt(r, o, s, c, !0) || Rt(r, i, s, c) || Rt(r, a, s, c);
											}
									return r;
							})((e = e || {}), t);
							if (t.options.functional)
									return (function(t, e, n, r, i) {
											var o = {},
													a = t.options.props;
											if (a)
													for (var s in a) o[s] = yt(s, a, e);
											var c = Object.create(r),
													u = t.options.render.call(
															null,
															function(t, e, n, r) {
																	return Yt(c, t, e, n, r, !0);
															}, {
																	props: o,
																	data: n,
																	parent: r,
																	children: i,
																	slots: function() {
																			return Kt(i, r);
																	}
															}
													);
											u instanceof jt &&
													((u.functionalContext = r), n.slot &&
															((u.data || (u.data = {})).slot = n.slot));
											return u;
									})(t, a, e, n, r);
							var s = e.on;
							(e.on = e.nativeOn), t.options.abstract && (e = {}), (function(t) {
									t.hook || (t.hook = {});
									for (var e = 0; e < Mt.length; e++) {
											var n = Mt[e],
													r = t.hook[n],
													i = Pt[n];
											t.hook[n] = r ? Ft(i, r) : i;
									}
							})(e);
							var c = t.options.name || i;
							return new jt(
									"vue-component-" + t.cid + (c ? "-" + c : ""),
									e,
									void 0,
									void 0,
									void 0,
									n, {
											Ctor: t,
											propsData: a,
											listeners: s,
											tag: i,
											children: r
									}
							);
					}
					Q("Invalid Component definition: " + String(t), n);
			}
	}

	function qt(t, e) {
			var n = e.componentOptions;
			(e.componentInstance = t.componentInstance)._updateFromParent(
					n.propsData,
					n.listeners,
					e,
					n.children
			);
	}

	function Rt(t, e, n, r, i) {
			if (e) {
					if (a(e, n)) return (t[n] = e[n]), i || delete e[n], !0;
					if (a(e, r)) return (t[n] = e[r]), i || delete e[r], !0;
			}
			return !1;
	}

	function Ft(t, e) {
			return function(n, r, i, o) {
					t(n, r, i, o), e(n, r, i, o);
			};
	}

	function Wt(t, e, n, r) {
			r += e;
			var i = t.__injected || (t.__injected = {});
			if (!i[r]) {
					i[r] = !0;
					var o = t[e];
					t[e] = o ? function() {
							o.apply(this, arguments), n.apply(this, arguments);
					} : n;
			}
	}
	var Ht = c(function(t) {
			var e = "~" === t.charAt(0),
					n = "!" === (t = e ? t.slice(1) : t).charAt(0);
			return {
					name: (t = n ? t.slice(1) : t),
					once: e,
					capture: n
			};
	});

	function Vt(t) {
			var e = {
					fn: t,
					invoker: function() {
							var t = arguments,
									n = e.fn;
							if (Array.isArray(n))
									for (var r = 0; r < n.length; r++)
											n[r].apply(null, t);
							else n.apply(null, arguments);
					}
			};
			return e;
	}

	function Bt(t, e, n, r, i) {
			var o, a, s, c;
			for (o in t)(a =
					t[
							o
					]), (s = e[o]), (c = Ht(o)), a ? (s ? a !== s && ((s.fn = a), (t[o] = s)) : (a.invoker || (a = t[o] = Vt(a)), n(c.name, a.invoker, c.once, c.capture))) : Q('Invalid handler for event "' + c.name + '": got ' + String(a), i);
			for (o in e) t[o] || r((c = Ht(o)).name, e[o].invoker, c.capture);
	}

	function Ut(t) {
			return s(t) ? [zt(t)] : Array.isArray(t) ? (function t(e, n) {
					var r = [];
					var i, o, a;
					for (i = 0; i < e.length; i++)
							null != (o = e[i]) &&
							"boolean" != typeof o &&
							((a = r[r.length - 1]), Array.isArray(o) ? r.push.apply(r, t(o, (n || "") + "_" + i)) : s(o) ? a && a.text ? (a.text += String(o)) : "" !== o && r.push(zt(o)) : o.text && a && a.text ? (r[r.length - 1] = zt(a.text + o.text)) : (o.tag &&
									null == o.key &&
									null != n &&
									(o.key =
											"__vlist" + n + "_" + i + "__"), r.push(o)));
					return r;
			})(t) : void 0;
	}

	function Jt(t) {
			return (
					t &&
					t.filter(function(t) {
							return t && t.componentOptions;
					})[0]
			);
	}
	var Qt, Gt = 1,
			Xt = 2;

	function Yt(t, e, n, r, i, o) {
			return (Array.isArray(n) || s(n)) &&
					((i = r), (r = n), (n = void 0)), o && (i = Xt), (function(t, e, n, r, i) {
							if (n && n.__ob__)
									return Q(
											"Avoid using observed data object as vnode data: " +
											JSON.stringify(n) +
											"\nAlways create fresh vnode data objects in each render!",
											t
									), Nt();
							if (!e) return Nt();
							Array.isArray(r) &&
									"function" == typeof r[0] &&
									(((n = n || {}).scopedSlots = {
											default: r[0]
									}), (r.length = 0));
							i === Xt ? (r = Ut(r)) : i === Gt &&
									(r = (function(t) {
											for (var e = 0; e < t.length; e++)
													if (Array.isArray(t[e]))
															return Array.prototype.concat.apply([], t);
											return t;
									})(r));
							var o, a;
							if ("string" == typeof e) {
									var s;
									(a = A.getTagNamespace(e)), (o = A.isReservedTag(e) ? new jt(A.parsePlatformTagName(e), n, r, void 0, void 0, t) : (s = gt(t.$options, "components", e)) ? Dt(s, n, t, r, e) : new jt(e, n, r, void 0, void 0, t));
							} else o = Dt(e, n, t, r);
							return o ? (a &&
									(function t(e, n) {
											e.ns = n;
											if ("foreignObject" === e.tag) return;
											if (e.children)
													for (var r = 0, i = e.children.length; r < i; r++) {
															var o = e.children[r];
															o.tag && !o.ns && t(o, n);
													}
									})(o, a), o) : Nt();
					})(t, e, n, r, i);
	}

	function Kt(t, e) {
			var n = {};
			if (!t) return n;
			for (var r, i, o = [], a = 0, s = t.length; a < s; a++)
					if (
							((i = t[a]).context === e || i.functionalContext === e) &&
							i.data &&
							(r = i.data.slot)
					) {
							var c = n[r] || (n[r] = []);
							"template" === i.tag ? c.push.apply(c, i.children) : c.push(i);
					} else o.push(i);
			return o.length &&
					(1 !== o.length || (" " !== o[0].text && !o[0].isComment)) &&
					(n.default = o), n;
	}

	function Zt(t, e, n) {
			n ? Qt.$once(t, e) : Qt.$on(t, e);
	}

	function te(t, e) {
			Qt.$off(t, e);
	}

	function ee(t, e, n) {
			(Qt = t), Bt(e, n || {}, Zt, te, t);
	}
	var ne = null;

	function re(t, e) {
			var n = t.$options[e];
			if (n)
					for (var r = 0, i = n.length; r < i; r++) n[r].call(t);
			t._hasHookEvent && t.$emit("hook:" + e);
	}
	var ie = [],
			oe = {},
			ae = {},
			se = !1,
			ce = !1,
			ue = 0;

	function le() {
			var t, e, n;
			for (
					(ce = !0), ie.sort(function(t, e) {
							return t.id - e.id;
					}), (ue = 0); ue < ie.length; ue++
			)
					if (
							((e = (t = ie[ue]).id), (oe[e] = null), t.run(), null != oe[e] &&
									((ae[e] = (ae[e] || 0) + 1), ae[e] > A._maxUpdateCount))
					) {
							Q(
									"You may have an infinite update loop " +
									(t.user ? 'in watcher with expression "' + t.expression + '"' : "in a component render function."),
									t.vm
							);
							break;
					}
			for (
					ue = ie.length; ue--;

			)(n = (t = ie[ue]).vm)._watcher === t && n._isMounted && re(n, "updated");
			H &&
					A.devtools &&
					H.emit("flush"), (ie.length = 0), (oe = {}), (ae = {}), (se = ce = !1);
	}
	var de = 0,
			pe = function(t, e, n, r) {
					(this.vm = t), t._watchers.push(this), r ? ((this.deep = !!r.deep), (this.user = !!r.user), (this.lazy = !!r.lazy), (this.sync = !!r.sync)) : (this.deep = this.user = this.lazy = this.sync = !1), (this.cb = n), (this.id = ++de), (this.active = !0), (this.dirty = this.lazy), (this.deps = []), (this.newDeps = []), (this.depIds = new B()), (this.newDepIds = new B()), (this.expression = e.toString()), "function" ==
							typeof e ? (this.getter = e) : ((this.getter = N(e)), this.getter ||
									((this.getter = function() {}), Q(
											'Failed watching path: "' +
											e +
											'" Watcher only accepts simple dot-delimited paths. For full control, use a function instead.',
											t
									))), (this.value = this.lazy ? void 0 : this.get());
			};
	(pe.prototype.get = function() {
			var t;
			(t = this), K.target && Z.push(K.target), (K.target = t);
			var e, n = this.getter.call(this.vm, this.vm);
			return this.deep &&
					((e = n), fe.clear(), (function t(e, n) {
							var r, i, o = Array.isArray(e);
							if ((o || g(e)) && Object.isExtensible(e)) {
									if (e.__ob__) {
											var a = e.__ob__.dep.id;
											if (n.has(a)) return;
											n.add(a);
									}
									if (o)
											for (r = e.length; r--;) t(e[r], n);
									else
											for ((i = Object.keys(e)), (r = i.length); r--;) t(e[i[r]], n);
							}
					})(e, fe)), (K.target = Z.pop()), this.cleanupDeps(), n;
	}), (pe.prototype.addDep = function(t) {
			var e = t.id;
			this.newDepIds.has(e) ||
					(this.newDepIds.add(e), this.newDeps.push(t), this.depIds.has(e) ||
							t.addSub(this));
	}), (pe.prototype.cleanupDeps = function() {
			for (var t = this.deps.length; t--;) {
					var e = this.deps[t];
					this.newDepIds.has(e.id) || e.removeSub(this);
			}
			var n = this.depIds;
			(this.depIds = this.newDepIds), (this.newDepIds = n), this.newDepIds.clear(), (n = this
					.deps), (this.deps = this.newDeps), (this.newDeps = n), (this.newDeps.length = 0);
	}), (pe.prototype.update = function() {
			this.lazy ? (this.dirty = !0) : this.sync ? this.run() : (function(t) {
					var e = t.id;
					if (null == oe[e]) {
							if (((oe[e] = !0), ce)) {
									for (var n = ie.length - 1; n >= 0 && ie[n].id > t.id;)
											n--;
									ie.splice(Math.max(n, ue) + 1, 0, t);
							} else ie.push(t);
							se || ((se = !0), U(le));
					}
			})(this);
	}), (pe.prototype.run = function() {
			if (this.active) {
					var t = this.get();
					if (t !== this.value || g(t) || this.deep) {
							var e = this.value;
							if (((this.value = t), this.user))
									try {
											this.cb.call(this.vm, t, e);
									} catch (t) {
											if (!A.errorHandler)
													throw (Q(
															'Error in watcher "' + this.expression + '"',
															this.vm
													), t);
											A.errorHandler.call(null, t, this.vm);
									} else this.cb.call(this.vm, t, e);
					}
			}
	}), (pe.prototype.evaluate = function() {
			(this.value = this.get()), (this.dirty = !1);
	}), (pe.prototype.depend = function() {
			for (var t = this.deps.length; t--;)
					this.deps[t].depend();
	}), (pe.prototype.teardown = function() {
			if (this.active) {
					this.vm._isBeingDestroyed || i(this.vm._watchers, this);
					for (var t = this.deps.length; t--;)
							this.deps[t].removeSub(this);
					this.active = !1;
			}
	});
	var fe = new B();

	function he(t) {
			t._watchers = [];
			var e = t.$options;
			e.props &&
					(function(t, e) {
							var n = t.$options.propsData || {},
									r = (t.$options._propKeys = Object.keys(e)),
									i = !t.$parent;
							rt.shouldConvert = i;
							for (
									var o = function(i) {
													var o = r[i];
													me[o] &&
															Q(
																	'"' +
																	o +
																	'" is a reserved attribute and cannot be used as component prop.',
																	t
															), ct(t, o, yt(o, e, n, t), function() {
																	t.$parent &&
																			!rt.isSettingProps &&
																			Q(
																					"Avoid mutating a prop directly since the value will be overwritten whenever the parent component re-renders. Instead, use a data or computed property based on the prop's value. Prop being mutated: \"" +
																					o +
																					'"',
																					t
																			);
															});
											},
											a = 0; a < r.length; a++
							)
									o(a);
							rt.shouldConvert = !0;
					})(t, e.props), e.methods &&
					(function(t, e) {
							for (var n in e)
									(t[n] = null == e[n] ? x : h(e[n], t)), null == e[n] &&
									Q(
											'method "' +
											n +
											'" has an undefined value in the component definition. Did you reference the function correctly?',
											t
									);
					})(t, e.methods), e.data ? (function(t) {
							var e = t.$options.data;
							w((e = t._data = "function" == typeof e ? e.call(t) : e || {})) ||
									((e = {}), Q(
											"data functions should return an object:\nhttps://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function",
											t
									));
							var n = Object.keys(e),
									r = t.$options.props,
									i = n.length;
							for (; i--;)
									r && a(r, n[i]) ? Q(
											'The data property "' +
											n[i] +
											'" is already declared as a prop. Use prop default value instead.',
											t
									) : be(t, n[i]);
							st(e, !0);
					})(t) : st((t._data = {}), !0), e.computed &&
					(function(t, e) {
							for (var n in e) {
									n in t &&
											Q(
													'existing instance property "' +
													n +
													'" will be overwritten by a computed property with the same name.',
													t
											);
									var r = e[n];
									"function" == typeof r
											? ((ve.get = ge(r, t)), (ve.set = x)) : ((ve.get = r.get ? !1 !== r.cache ? ge(r.get, t) : h(r.get, t) : x), (ve.set = r.set ? h(r.set, t) : x)), Object.defineProperty(t, n, ve);
							}
					})(t, e.computed), e.watch &&
					(function(t, e) {
							for (var n in e) {
									var r = e[n];
									if (Array.isArray(r))
											for (var i = 0; i < r.length; i++)
													ye(t, n, r[i]);
									else ye(t, n, r);
							}
					})(t, e.watch);
	}
	var me = {
			key: 1,
			ref: 1,
			slot: 1
	};
	var ve = {
			enumerable: !0,
			configurable: !0,
			get: x,
			set: x
	};

	function ge(t, e) {
			var n = new pe(e, t, x, {
					lazy: !0
			});
			return function() {
					return n.dirty && n.evaluate(), K.target && n.depend(), n.value;
			};
	}

	function ye(t, e, n) {
			var r;
			w(n) &&
					((r = n), (n =
							n.handler)), "string" == typeof n && (n = t[n]), t.$watch(e, n, r);
	}

	function be(t, e) {
			$(e) ||
					Object.defineProperty(t, e, {
							configurable: !0,
							enumerable: !0,
							get: function() {
									return t._data[e];
							},
							set: function(n) {
									t._data[e] = n;
							}
					});
	}
	var we, _e, xe, ke, Se, Ce = 0;

	function Te(t) {
			var e = t.options;
			if (t.super) {
					var n = t.super.options,
							r = t.superOptions,
							i = t.extendOptions;
					n !== r &&
							((t.superOptions = n), (i.render = e.render), (i.staticRenderFns =
									e.staticRenderFns), (i._scopeId = e._scopeId), (e = t.options = vt(
									n,
									i
							)).name && (e.components[e.name] = t));
			}
			return e;
	}

	function Ee(t) {
			this instanceof Ee ||
					Q(
							"Vue is a constructor and should be called with the `new` keyword"
					), this._init(t);
	}
	(Ee.prototype._init = function(t) {
			var e, n, r, i = this;
			(i._uid = Ce++), (i._isVue = !0), t && t._isComponent ? ((n = t), ((r = (e = i).$options = Object.create(
											e.constructor.options
									)).parent =
									n.parent), (r.propsData = n.propsData), (r._parentVnode =
									n._parentVnode), (r._parentListeners =
									n._parentListeners), (r._renderChildren =
									n._renderChildren), (r._componentTag =
									n._componentTag), (r._parentElm = n._parentElm), (r._refElm =
									n._refElm), n.render &&
							((r.render = n.render), (r.staticRenderFns = n.staticRenderFns))) : (i.$options = vt(Te(i.constructor), t || {}, i)), xt(
							i
					), (i._self = i), (function(t) {
							var e = t.$options,
									n = e.parent;
							if (n && !e.abstract) {
									for (; n.$options.abstract && n.$parent;)
											n = n.$parent;
									n.$children.push(t);
							}
							(t.$parent = n), (t.$root = n ? n.$root : t), (t.$children = []), (t.$refs = {}), (t._watcher = null), (t._inactive = !1), (t._isMounted = !1), (t._isDestroyed = !1), (t._isBeingDestroyed = !1);
					})(i), (function(t) {
							(t._events = Object.create(null)), (t._hasHookEvent = !1);
							var e = t.$options._parentListeners;
							e && ee(t, e);
					})(i), (function(t) {
							(t.$vnode = null), (t._vnode = null), (t._staticTrees = null);
							var e = t.$options._parentVnode,
									n = e && e.context;
							(t.$slots = Kt(
									t.$options._renderChildren,
									n
							)), (t.$scopedSlots = {}), (t._c = function(e, n, r, i) {
									return Yt(t, e, n, r, i, !1);
							}), (t.$createElement = function(e, n, r, i) {
									return Yt(t, e, n, r, i, !0);
							});
					})(i), re(i, "beforeCreate"), he(i), re(i, "created"), i.$options.el &&
					i.$mount(i.$options.el);
	}), (we = Ee), (_e = {
			get: function() {
					return this._data;
			},
			set: function(t) {
					Q(
							"Avoid replacing instance root $data. Use nested data properties instead.",
							this
					);
			}
	}), Object.defineProperty(we.prototype, "$data", _e), (we.prototype.$set = ut), (we.prototype.$delete = lt), (we.prototype.$watch = function(
			t,
			e,
			n
	) {
			(n = n || {}).user = !0;
			var r = new pe(this, t, e, n);
			return n.immediate && e.call(this, r.value),
					function() {
							r.teardown();
					};
	}), (ke = /^hook:/), ((xe = Ee).prototype.$on = function(t, e) {
			return (this._events[t] || (this._events[t] = [])).push(e), ke.test(t) &&
					(this._hasHookEvent = !0), this;
	}), (xe.prototype.$once = function(t, e) {
			var n = this;

			function r() {
					n.$off(t, r), e.apply(n, arguments);
			}
			return (r.fn = e), n.$on(t, r), n;
	}), (xe.prototype.$off = function(t, e) {
			var n = this;
			if (!arguments.length) return (n._events = Object.create(null)), n;
			var r, i = n._events[t];
			if (!i) return n;
			if (1 === arguments.length) return (n._events[t] = null), n;
			for (var o = i.length; o--;)
					if ((r = i[o]) === e || r.fn === e) {
							i.splice(o, 1);
							break;
					}
			return n;
	}), (xe.prototype.$emit = function(t) {
			var e = this._events[t];
			if (e) {
					e = e.length > 1 ? m(e) : e;
					for (var n = m(arguments, 1), r = 0, i = e.length; r < i; r++)
							e[r].apply(this, n);
			}
			return this;
	}), ((Se = Ee).prototype._mount = function(t, e) {
			var n = this;
			return (n.$el = t), n.$options.render ||
					((n.$options.render = Nt), n.$options.template &&
							"#" !== n.$options.template.charAt(0) ? Q(
									"You are using the runtime-only build of Vue where the template option is not available. Either pre-compile the templates into render functions, or use the compiler-included build.",
									n
							) : Q(
									"Failed to mount component: template or render function not defined.",
									n
							)), re(n, "beforeMount"), (n._watcher = new pe(
							n,
							function() {
									n._update(n._render(), e);
							},
							x
					)), (e = !1), null == n.$vnode &&
					((n._isMounted = !0), re(n, "mounted")), n;
	}), (Se.prototype._update = function(t, e) {
			var n = this;
			n._isMounted && re(n, "beforeUpdate");
			var r = n.$el,
					i = n._vnode,
					o = ne;
			(ne = n), (n._vnode = t), (n.$el = i ? n.__patch__(i, t) : n.__patch__(
					n.$el,
					t,
					e, !1,
					n.$options._parentElm,
					n.$options._refElm
			)), (ne = o), r && (r.__vue__ = null), n.$el &&
					(n.$el.__vue__ = n), n.$vnode &&
					n.$parent &&
					n.$vnode === n.$parent._vnode &&
					(n.$parent.$el = n.$el);
	}), (Se.prototype._updateFromParent = function(t, e, n, r) {
			var i = this,
					o = !(!i.$options._renderChildren && !r);
			if (
					((i.$options._parentVnode = n), (i.$vnode = n), i._vnode &&
							(i._vnode.parent = n), (i.$options._renderChildren = r), t &&
							i.$options.props)
			) {
					(rt.shouldConvert = !1), (rt.isSettingProps = !0);
					for (var a = i.$options._propKeys || [], s = 0; s < a.length; s++) {
							var c = a[s];
							i[c] = yt(c, i.$options.props, t, i);
					}
					(rt.shouldConvert = !0), (rt.isSettingProps = !1), (i.$options.propsData = t);
			}
			if (e) {
					var u = i.$options._parentListeners;
					(i.$options._parentListeners = e), ee(i, e, u);
			}
			o && ((i.$slots = Kt(r, n.context)), i.$forceUpdate());
	}), (Se.prototype.$forceUpdate = function() {
			this._watcher && this._watcher.update();
	}), (Se.prototype.$destroy = function() {
			var t = this;
			if (!t._isBeingDestroyed) {
					re(t, "beforeDestroy"), (t._isBeingDestroyed = !0);
					var e = t.$parent;
					!e ||
							e._isBeingDestroyed ||
							t.$options.abstract ||
							i(e.$children, t), t._watcher && t._watcher.teardown();
					for (var n = t._watchers.length; n--;)
							t._watchers[n].teardown();
					t._data.__ob__ && t._data.__ob__.vmCount--, (t._isDestroyed = !0), re(
							t,
							"destroyed"
					), t.$off(), t.$el && (t.$el.__vue__ = null), t.__patch__(t._vnode, null);
			}
	}), (function(n) {
			function r(t, e, n) {
					if (Array.isArray(t))
							for (var r = 0; r < t.length; r++)
									t[r] && "string" != typeof t[r] && i(t[r], e + "_" + r, n);
					else i(t, e, n);
			}

			function i(t, e, n) {
					(t.isStatic = !0), (t.key = e), (t.isOnce = n);
			}
			(n.prototype.$nextTick = function(t) {
					return U(t, this);
			}), (n.prototype._render = function() {
					var t,
							e = this,
							n = e.$options,
							r = n.render,
							i = n.staticRenderFns,
							o = n._parentVnode;
					if (e._isMounted)
							for (var a in e.$slots) e.$slots[a] = Lt(e.$slots[a]);
					o && o.data.scopedSlots && (e.$scopedSlots = o.data.scopedSlots), i &&
							!e._staticTrees &&
							(e._staticTrees = []), (e.$vnode = o);
					try {
							t = r.call(e._renderProxy, e.$createElement);
					} catch (n) {
							if (!A.errorHandler) throw (Q("Error when rendering " + J(e) + ":"), n);
							A.errorHandler.call(null, n, e), (t = e._vnode);
					}
					return t instanceof jt ||
							(Array.isArray(t) &&
									Q(
											"Multiple root nodes returned from render function. Render function should return a single root node.",
											e
									), (t = Nt())), (t.parent = o), t;
			}), (n.prototype._s = t), (n.prototype._v = zt), (n.prototype._n = e), (n.prototype._e = Nt), (n.prototype._q = T), (n.prototype._i = E), (n.prototype._m = function(
					t,
					e
			) {
					var n = this._staticTrees[t];
					return n && !e ? Array.isArray(n) ? Lt(n) : Ot(n) : (r(
							(n = this._staticTrees[t] = this.$options.staticRenderFns[t].call(
									this._renderProxy
							)),
							"__static__" + t, !1
					), n);
			}), (n.prototype._o = function(t, e, n) {
					return r(t, "__once__" + e + (n ? "_" + n : ""), !0), t;
			}), (n.prototype._f = function(t) {
					return gt(this.$options, "filters", t, !0) || S;
			}), (n.prototype._l = function(t, e) {
					var n, r, i, o, a;
					if (Array.isArray(t) || "string" == typeof t)
							for ((n = new Array(t.length)), (r = 0), (i = t.length); r < i; r++)
									n[r] = e(t[r], r);
					else if ("number" == typeof t)
							for ((n = new Array(t)), (r = 0); r < t; r++)
									n[r] = e(r + 1, r);
					else if (g(t))
							for (
									(o = Object.keys(t)), (n = new Array(o.length)), (r = 0), (i =
											o.length); r < i; r++
							)
									(a = o[r]), (n[r] = e(t[a], a, r));
					return n;
			}), (n.prototype._t = function(t, e, n, r) {
					var i = this.$scopedSlots[t];
					if (i) return (n = n || {}), r && v(n, r), i(n) || e;
					var o = this.$slots[t];
					return o &&
							(o._rendered &&
									Q(
											'Duplicate presence of slot "' +
											t +
											'" found in the same render tree - this will likely cause render errors.',
											this
									), (o._rendered = !0)), o || e;
			}), (n.prototype._b = function(t, e, n, r) {
					if (n)
							if (g(n)) {
									Array.isArray(n) && (n = _(n));
									for (var i in n)
											if ("class" === i || "style" === i) t[i] = n[i];
											else {
													var o = t.attrs && t.attrs.type;
													(r || A.mustUseProp(e, o, i) ? t.domProps || (t.domProps = {}) : t.attrs || (t.attrs = {}))[i] =
													n[i];
											}
							} else
									Q("v-bind without argument expects an Object or Array value", this);
					return t;
			}), (n.prototype._k = function(t, e, n) {
					var r = A.keyCodes[e] || n;
					return Array.isArray(r) ? -1 === r.indexOf(t) : r !== t;
			});
	})(Ee);
	var Ae = [String, RegExp];

	function $e(t) {
			return t && (t.Ctor.options.name || t.tag);
	}

	function je(t, e) {
			return "string" == typeof t ? t.split(",").indexOf(e) > -1 : t.test(e);
	}

	function Ie(t, e) {
			for (var n in t) {
					var r = t[n];
					if (r) {
							var i = $e(r.componentOptions);
							i && !e(i) && (Ne(r), (t[n] = null));
					}
			}
	}

	function Ne(t) {
			t &&
					(t.componentInstance._inactive ||
							re(t.componentInstance, "deactivated"), t.componentInstance.$destroy());
	}
	var ze,
			Oe,
			Le,
			Pe = {
					KeepAlive: {
							name: "keep-alive",
							abstract: !0,
							props: {
									include: Ae,
									exclude: Ae
							},
							created: function() {
									this.cache = Object.create(null);
							},
							destroyed: function() {
									for (var t in this.cache)
											Ne(this.cache[t]);
							},
							watch: {
									include: function(t) {
											Ie(this.cache, function(e) {
													return je(t, e);
											});
									},
									exclude: function(t) {
											Ie(this.cache, function(e) {
													return !je(t, e);
											});
									}
							},
							render: function() {
									var t = Jt(this.$slots.default),
											e = t && t.componentOptions;
									if (e) {
											var n = $e(e);
											if (
													n &&
													((this.include && !je(this.include, n)) ||
															(this.exclude && je(this.exclude, n)))
											)
													return t;
											var r = null == t.key ? e.Ctor.cid + (e.tag ? "::" + e.tag : "") : t.key;
											this.cache[r] ? (t.componentInstance = this.cache[r].componentInstance) : (this.cache[r] = t), (t.data.keepAlive = !0);
									}
									return t;
							}
					}
			};
	(ze = Ee), (Le = {
			get: function() {
					return A;
			},
			set: function() {
					Q("Do not replace the Vue.config object, set individual fields instead.");
			}
	}), Object.defineProperty(ze, "config", Le), (ze.util = kt), (ze.set = ut), (ze.delete = lt), (ze.nextTick = U), (ze.options = Object.create(null)), A._assetTypes.forEach(
			function(t) {
					ze.options[t + "s"] = Object.create(null);
			}
	), (ze.options._base = ze), v(ze.options.components, Pe), (ze.use = function(
			t
	) {
			if (!t.installed) {
					var e = m(arguments, 1);
					return e.unshift(this), "function" == typeof t.install ? t.install.apply(t, e) : t.apply(null, e), (t.installed = !0), this;
			}
	}), (ze.mixin = function(t) {
			this.options = vt(this.options, t);
	}), (function(t) {
			t.cid = 0;
			var e = 1;
			t.extend = function(t) {
					t = t || {};
					var n = this,
							r = n.cid,
							i = t._Ctor || (t._Ctor = {});
					if (i[r]) return i[r];
					var o = t.name || n.options.name;
					/^[a-zA-Z][\w-]*$/.test(o) ||
							Q(
									'Invalid component name: "' +
									o +
									'". Component names can only contain alphanumeric characters and the hyphen, and must start with a letter.'
							);
					var a = function(t) {
							this._init(t);
					};
					return ((a.prototype = Object.create(
							n.prototype
					)).constructor = a), (a.cid = e++), (a.options = vt(
							n.options,
							t
					)), (a.super = n), (a.extend = n.extend), (a.mixin = n.mixin), (a.use =
							n.use), A._assetTypes.forEach(function(t) {
							a[t] = n[t];
					}), o && (a.options.components[o] = a), (a.superOptions =
							n.options), (a.extendOptions = t), (i[r] = a), a;
			};
	})(ze), (Oe = ze), A._assetTypes.forEach(function(t) {
			Oe[t] = function(e, n) {
					return n ? ("component" === t &&
							A.isReservedTag(e) &&
							Q(
									"Do not use built-in or reserved HTML elements as component id: " +
									e
							), "component" === t &&
							w(n) &&
							((n.name = n.name || e), (n = this.options._base.extend(
									n
							))), "directive" === t &&
							"function" == typeof n &&
							(n = {
									bind: n,
									update: n
							}), (this.options[t + "s"][e] = n), n) : this.options[t + "s"][e];
			};
	}), Object.defineProperty(Ee.prototype, "$isServer", {
			get: W
	}), (Ee.version = "2.1.10");
	var Me = n("input,textarea,option,select"),
			De = function(t, e, n) {
					return (
							("value" === n && Me(t) && "button" !== e) ||
							("selected" === n && "option" === t) ||
							("checked" === n && "input" === t) ||
							("muted" === n && "video" === t)
					);
			},
			qe = n("contenteditable,draggable,spellcheck"),
			Re = n(
					"allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"
			),
			Fe = "http://www.w3.org/1999/xlink",
			We = function(t) {
					return ":" === t.charAt(5) && "xlink" === t.slice(0, 5);
			},
			He = function(t) {
					return We(t) ? t.slice(6, t.length) : "";
			},
			Ve = function(t) {
					return null == t || !1 === t;
			};

	function Be(t) {
			for (
					var e = t.data, n = t, r = t; r.componentInstance;

			)(r = r.componentInstance._vnode).data && (e = Ue(r.data, e));
			for (;
					(n = n.parent);) n.data && (e = Ue(e, n.data));
			return (function(t) {
					var e = t.class,
							n = t.staticClass;
					if (n || e) return Je(n, Qe(e));
					return "";
			})(e);
	}

	function Ue(t, e) {
			return {
					staticClass: Je(t.staticClass, e.staticClass),
					class: t.class ? [t.class, e.class] : e.class
			};
	}

	function Je(t, e) {
			return t ? (e ? t + " " + e : t) : e || "";
	}

	function Qe(t) {
			var e = "";
			if (!t) return e;
			if ("string" == typeof t) return t;
			if (Array.isArray(t)) {
					for (var n, r = 0, i = t.length; r < i; r++)
							t[r] && (n = Qe(t[r])) && (e += n + " ");
					return e.slice(0, -1);
			}
			if (g(t)) {
					for (var o in t)
							t[o] && (e += o + " ");
					return e.slice(0, -1);
			}
			return e;
	}
	var Ge = {
					svg: "http://www.w3.org/2000/svg",
					math: "http://www.w3.org/1998/Math/MathML"
			},
			Xe = n(
					"html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template"
			),
			Ye = n(
					"svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", !0
			),
			Ke = function(t) {
					return Xe(t) || Ye(t);
			};

	function Ze(t) {
			return Ye(t) ? "svg" : "math" === t ? "math" : void 0;
	}
	var tn = Object.create(null);

	function en(t) {
			if ("string" == typeof t) {
					var e = t;
					if (!(t = document.querySelector(t)))
							return Q("Cannot find element: " + e), document.createElement("div");
			}
			return t;
	}
	var nn = Object.freeze({
					createElement: function(t, e) {
							var n = document.createElement(t);
							return "select" !== t ? n : (e.data &&
									e.data.attrs &&
									"multiple" in e.data.attrs &&
									n.setAttribute("multiple", "multiple"), n);
					},
					createElementNS: function(t, e) {
							return document.createElementNS(Ge[t], e);
					},
					createTextNode: function(t) {
							return document.createTextNode(t);
					},
					createComment: function(t) {
							return document.createComment(t);
					},
					insertBefore: function(t, e, n) {
							t.insertBefore(e, n);
					},
					removeChild: function(t, e) {
							t.removeChild(e);
					},
					appendChild: function(t, e) {
							t.appendChild(e);
					},
					parentNode: function(t) {
							return t.parentNode;
					},
					nextSibling: function(t) {
							return t.nextSibling;
					},
					tagName: function(t) {
							return t.tagName;
					},
					setTextContent: function(t, e) {
							t.textContent = e;
					},
					setAttribute: function(t, e, n) {
							t.setAttribute(e, n);
					}
			}),
			rn = {
					create: function(t, e) {
							on(e);
					},
					update: function(t, e) {
							t.data.ref !== e.data.ref && (on(t, !0), on(e));
					},
					destroy: function(t) {
							on(t, !0);
					}
			};

	function on(t, e) {
			var n = t.data.ref;
			if (n) {
					var r = t.context,
							o = t.componentInstance || t.elm,
							a = r.$refs;
					e
							? Array.isArray(a[n]) ? i(a[n], o) : a[n] === o && (a[n] = void 0) : t.data.refInFor ? Array.isArray(a[n]) && a[n].indexOf(o) < 0 ? a[n].push(o) : (a[n] = [o]) : (a[n] = o);
			}
	}
	var an = new jt("", {}, []),
			sn = ["create", "activate", "update", "remove", "destroy"];

	function cn(t) {
			return null == t;
	}

	function un(t) {
			return null != t;
	}

	function ln(t, e) {
			return (
					t.key === e.key &&
					t.tag === e.tag &&
					t.isComment === e.isComment &&
					!t.data == !e.data
			);
	}

	function dn(t, e, n) {
			var r, i, o = {};
			for (r = e; r <= n; ++r) un((i = t[r].key)) && (o[i] = r);
			return o;
	}
	var pn = {
			create: fn,
			update: fn,
			destroy: function(t) {
					fn(t, an);
			}
	};

	function fn(t, e) {
			(t.data.directives || e.data.directives) &&
			(function(t, e) {
					var n,
							r,
							i,
							o = t === an,
							a = e === an,
							s = mn(t.data.directives, t.context),
							c = mn(e.data.directives, e.context),
							u = [],
							l = [];
					for (n in c)
							(r = s[n]), (i = c[n]), r ? ((i.oldValue = r.value), vn(i, "update", e, t), i.def &&
									i.def.componentUpdated &&
									l.push(i)) : (vn(i, "bind", e, t), i.def && i.def.inserted && u.push(i));
					if (u.length) {
							var d = function() {
									for (var n = 0; n < u.length; n++)
											vn(u[n], "inserted", e, t);
							};
							o
									? Wt(e.data.hook || (e.data.hook = {}), "insert", d, "dir-insert") : d();
					}
					l.length &&
							Wt(
									e.data.hook || (e.data.hook = {}),
									"postpatch",
									function() {
											for (var n = 0; n < l.length; n++)
													vn(l[n], "componentUpdated", e, t);
									},
									"dir-postpatch"
							);
					if (!o)
							for (n in s) c[n] || vn(s[n], "unbind", t, t, a);
			})(t, e);
	}
	var hn = Object.create(null);

	function mn(t, e) {
			var n, r, i, o = Object.create(null);
			if (!t) return o;
			for (
					n = 0; n < t.length; n++
			)(r = t[n]).modifiers || (r.modifiers = hn), (o[((i = r), i.rawName || i.name + "." + Object.keys(i.modifiers || {}).join("."))] = r), (r.def = gt(e.$options, "directives", r.name, !0));
			return o;
	}

	function vn(t, e, n, r, i) {
			var o = t.def && t.def[e];
			o && o(n.elm, t, n, r, i);
	}
	var gn = [rn, pn];

	function yn(t, e) {
			if (t.data.attrs || e.data.attrs) {
					var n, r, i = e.elm,
							o = t.data.attrs || {},
							a = e.data.attrs || {};
					a.__ob__ && (a = e.data.attrs = v({}, a));
					for (n in a)
							(r = a[n]), o[n] !== r && bn(i, n, r);
					D && a.value !== o.value && bn(i, "value", a.value);
					for (n in o)
							null == a[n] &&
							(We(n) ? i.removeAttributeNS(Fe, He(n)) : qe(n) || i.removeAttribute(n));
			}
	}

	function bn(t, e, n) {
			Re(e) ? Ve(n) ? t.removeAttribute(e) : t.setAttribute(e, e) : qe(e) ? t.setAttribute(e, Ve(n) || "false" === n ? "false" : "true") : We(e) ? Ve(n) ? t.removeAttributeNS(Fe, He(e)) : t.setAttributeNS(Fe, e, n) : Ve(n) ? t.removeAttribute(e) : t.setAttribute(e, n);
	}
	var wn = {
			create: yn,
			update: yn
	};

	function _n(t, e) {
			var n = e.elm,
					r = e.data,
					i = t.data;
			if (r.staticClass || r.class || (i && (i.staticClass || i.class))) {
					var o = Be(e),
							a = n._transitionClasses;
					a && (o = Je(o, Qe(a))), o !== n._prevClass &&
							(n.setAttribute("class", o), (n._prevClass = o));
			}
	}
	var xn, kn = {
			create: _n,
			update: _n
	};

	function Sn(t, e, n, r) {
			if (n) {
					var i = e,
							o = xn;
					e = function(n) {
							Cn(t, e, r, o), 1 === arguments.length ? i(n) : i.apply(null, arguments);
					};
			}
			xn.addEventListener(t, e, r);
	}

	function Cn(t, e, n, r) {
			(r || xn).removeEventListener(t, e, n);
	}

	function Tn(t, e) {
			if (t.data.on || e.data.on) {
					var n = e.data.on || {},
							r = t.data.on || {};
					(xn = e.elm), Bt(n, r, Sn, Cn, e.context);
			}
	}
	var En = {
			create: Tn,
			update: Tn
	};

	function An(t, n) {
			if (t.data.domProps || n.data.domProps) {
					var r,
							i,
							o,
							a,
							s,
							c,
							u,
							l = n.elm,
							d = t.data.domProps || {},
							p = n.data.domProps || {};
					p.__ob__ && (p = n.data.domProps = v({}, p));
					for (r in d)
							null == p[r] && (l[r] = "");
					for (r in p)
							if (
									((i = p[r]), ("textContent" !== r && "innerHTML" !== r) ||
											(n.children && (n.children.length = 0), i !== d[r]))
							)
									if ("value" === r) {
											l._value = i;
											var f = null == i ? "" : String(i);
											(c = n), (u = f), (s = l).composing ||
													("option" !== c.tag &&
															((o = s), (a = u), document.activeElement === o ||
																	o.value === a) &&
															!(function(t, n) {
																	var r = t.elm.value,
																			i = t.elm._vModifiers;
																	if ((i && i.number) || "number" === t.elm.type)
																			return e(r) !== e(n);
																	if (i && i.trim) return r.trim() !== n.trim();
																	return r !== n;
															})(c, u)) ||
													(l.value = f);
									} else l[r] = i;
			}
	}
	var $n = {
					create: An,
					update: An
			},
			jn = c(function(t) {
					var e = {},
							n = /:(.+)/;
					return t.split(/;(?![^(]*\))/g).forEach(function(t) {
							if (t) {
									var r = t.split(n);
									r.length > 1 && (e[r[0].trim()] = r[1].trim());
							}
					}), e;
			});

	function In(t) {
			var e = Nn(t.style);
			return t.staticStyle ? v(t.staticStyle, e) : e;
	}

	function Nn(t) {
			return Array.isArray(t) ? _(t) : "string" == typeof t ? jn(t) : t;
	}
	var zn,
			On = /^--/,
			Ln = /\s*!important$/,
			Pn = function(t, e, n) {
					On.test(e) ? t.style.setProperty(e, n) : Ln.test(n) ? t.style.setProperty(e, n.replace(Ln, ""), "important") : (t.style[Dn(e)] = n);
			},
			Mn = ["Webkit", "Moz", "ms"],
			Dn = c(function(t) {
					if (
							((zn = zn || document.createElement("div")), "filter" !== (t = l(t)) &&
									t in zn.style)
					)
							return t;
					for (
							var e = t.charAt(0).toUpperCase() + t.slice(1), n = 0; n < Mn.length; n++
					) {
							var r = Mn[n] + e;
							if (r in zn.style) return r;
					}
			});

	function qn(t, e) {
			var n = e.data,
					r = t.data;
			if (n.staticStyle || n.style || r.staticStyle || r.style) {
					var i,
							o,
							a = e.elm,
							s = t.data.staticStyle,
							c = t.data.style || {},
							u = s || c,
							l = Nn(e.data.style) || {};
					e.data.style = l.__ob__ ? v({}, l) : l;
					var d = (function(t, e) {
							var n, r = {};
							if (e)
									for (var i = t; i.componentInstance;)
											(i = i.componentInstance._vnode).data &&
											(n = In(i.data)) &&
											v(r, n);
							(n = In(t.data)) && v(r, n);
							for (var o = t;
									(o = o.parent);)
									o.data && (n = In(o.data)) && v(r, n);
							return r;
					})(e, !0);
					for (o in u)
							null == d[o] && Pn(a, o, "");
					for (o in d)
							(i = d[o]) !== u[o] && Pn(a, o, null == i ? "" : i);
			}
	}
	var Rn = {
			create: qn,
			update: qn
	};
	var Fn = L && !D,
			Wn = "transition",
			Hn = "animation",
			Vn = "transition",
			Bn = "transitionend",
			Un = "animation",
			Jn = "animationend";
	Fn &&
			(void 0 === window.ontransitionend &&
					void 0 !== window.onwebkittransitionend &&
					((Vn = "WebkitTransition"), (Bn = "webkitTransitionEnd")), void 0 ===
					window.onanimationend &&
					void 0 !== window.onwebkitanimationend &&
					((Un = "WebkitAnimation"), (Jn = "webkitAnimationEnd")));
	var Qn = L && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout;

	function Gn(t) {
			Qn(function() {
					Qn(t);
			});
	}

	function Xn(t, e) {
			(t._transitionClasses || (t._transitionClasses = []))
			.push(e), (function(t, e) {
					if (e && e.trim())
							if (t.classList)
									e.indexOf(" ") > -1 ? e.split(/\s+/).forEach(function(e) {
											return t.classList.add(e);
									}) : t.classList.add(e);
							else {
									var n = " " + t.getAttribute("class") + " ";
									n.indexOf(" " + e + " ") < 0 &&
											t.setAttribute("class", (n + e).trim());
							}
			})(t, e);
	}

	function Yn(t, e) {
			t._transitionClasses && i(t._transitionClasses, e), (function(t, e) {
					if (e && e.trim())
							if (t.classList)
									e.indexOf(" ") > -1 ? e.split(/\s+/).forEach(function(e) {
											return t.classList.remove(e);
									}) : t.classList.remove(e);
							else {
									for (
											var n = " " + t.getAttribute("class") + " ", r = " " + e + " "; n.indexOf(r) >= 0;

									)
											n = n.replace(r, " ");
									t.setAttribute("class", n.trim());
							}
			})(t, e);
	}

	function Kn(t, e, n) {
			var r = tr(t, e),
					i = r.type,
					o = r.timeout,
					a = r.propCount;
			if (!i) return n();
			var s = i === Wn ? Bn : Jn,
					c = 0,
					u = function() {
							t.removeEventListener(s, l), n();
					},
					l = function(e) {
							e.target === t && ++c >= a && u();
					};
			setTimeout(function() {
					c < a && u();
			}, o + 1), t.addEventListener(s, l);
	}
	var Zn = /\b(transform|all)(,|$)/;

	function tr(t, e) {
			var n,
					r = window.getComputedStyle(t),
					i = r[Vn + "Delay"].split(", "),
					o = r[Vn + "Duration"].split(", "),
					a = er(i, o),
					s = r[Un + "Delay"].split(", "),
					c = r[Un + "Duration"].split(", "),
					u = er(s, c),
					l = 0,
					d = 0;
			return e === Wn ? a > 0 && ((n = Wn), (l = a), (d = o.length)) : e === Hn ? u > 0 && ((n = Hn), (l = u), (d = c.length)) : (d = (n = (l = Math.max(a, u)) > 0 ? (a > u ? Wn : Hn) : null) ? n === Wn ? o.length : c.length : 0), {
					type: n,
					timeout: l,
					propCount: d,
					hasTransform: n === Wn && Zn.test(r[Vn + "Property"])
			};
	}

	function er(t, e) {
			for (; t.length < e.length;) t = t.concat(t);
			return Math.max.apply(
					null,
					e.map(function(e, n) {
							return nr(e) + nr(t[n]);
					})
			);
	}

	function nr(t) {
			return 1e3 * Number(t.slice(0, -1));
	}

	function rr(t, e) {
			var n = t.elm;
			n._leaveCb && ((n._leaveCb.cancelled = !0), n._leaveCb());
			var r = or(t.data.transition);
			if (r && !n._enterCb && 1 === n.nodeType) {
					for (
							var i = r.css,
									o = r.type,
									a = r.enterClass,
									s = r.enterToClass,
									c = r.enterActiveClass,
									u = r.appearClass,
									l = r.appearToClass,
									d = r.appearActiveClass,
									p = r.beforeEnter,
									f = r.enter,
									h = r.afterEnter,
									m = r.enterCancelled,
									v = r.beforeAppear,
									g = r.appear,
									y = r.afterAppear,
									b = r.appearCancelled,
									w = ne,
									_ = ne.$vnode; _ && _.parent;

					)
							w = (_ = _.parent).context;
					var x = !w._isMounted || !t.isRootInsert;
					if (!x || g || "" === g) {
							var k = x ? u : a,
									S = x ? d : c,
									C = x ? l : s,
									T = (x && v) || p,
									E = x && "function" == typeof g ? g : f,
									A = (x && y) || h,
									$ = (x && b) || m,
									j = !1 !== i && !D,
									I = E && (E._length || E.length) > 1,
									N = (n._enterCb = sr(function() {
											j &&
													(Yn(n, C), Yn(
															n,
															S
													)), N.cancelled ? (j && Yn(n, k), $ && $(n)) : A && A(n), (n._enterCb = null);
									}));
							t.data.show ||
									Wt(
											t.data.hook || (t.data.hook = {}),
											"insert",
											function() {
													var e = n.parentNode,
															r = e && e._pending && e._pending[t.key];
													r && r.tag === t.tag && r.elm._leaveCb && r.elm._leaveCb(), E &&
															E(n, N);
											},
											"transition-insert"
									), T && T(n), j &&
									(Xn(n, k), Xn(n, S), Gn(function() {
											Xn(n, C), Yn(n, k), N.cancelled || I || Kn(n, o, N);
									})), t.data.show && (e && e(), E && E(n, N)), j || I || N();
					}
			}
	}

	function ir(t, e) {
			var n = t.elm;
			n._enterCb && ((n._enterCb.cancelled = !0), n._enterCb());
			var r = or(t.data.transition);
			if (!r) return e();
			if (!n._leaveCb && 1 === n.nodeType) {
					var i = r.css,
							o = r.type,
							a = r.leaveClass,
							s = r.leaveToClass,
							c = r.leaveActiveClass,
							u = r.beforeLeave,
							l = r.leave,
							d = r.afterLeave,
							p = r.leaveCancelled,
							f = r.delayLeave,
							h = !1 !== i && !D,
							m = l && (l._length || l.length) > 1,
							v = (n._leaveCb = sr(function() {
									n.parentNode &&
											n.parentNode._pending &&
											(n.parentNode._pending[
													t.key
											] = null), h && (Yn(n, s), Yn(n, c)), v.cancelled ? (h && Yn(n, a), p && p(n)) : (e(), d && d(n)), (n._leaveCb = null);
							}));
					f ? f(g) : g();
			}

			function g() {
					v.cancelled ||
							(t.data.show ||
									((n.parentNode._pending || (n.parentNode._pending = {}))[
											t.key
									] = t), u && u(n), h &&
									(Xn(n, a), Xn(n, c), Gn(function() {
											Xn(n, s), Yn(n, a), v.cancelled || m || Kn(n, o, v);
									})), l && l(n, v), h || m || v());
			}
	}

	function or(t) {
			if (t) {
					if ("object" == typeof t) {
							var e = {};
							return !1 !== t.css && v(e, ar(t.name || "v")), v(e, t), e;
					}
					return "string" == typeof t ? ar(t) : void 0;
			}
	}
	var ar = c(function(t) {
			return {
					enterClass: t + "-enter",
					leaveClass: t + "-leave",
					appearClass: t + "-enter",
					enterToClass: t + "-enter-to",
					leaveToClass: t + "-leave-to",
					appearToClass: t + "-enter-to",
					enterActiveClass: t + "-enter-active",
					leaveActiveClass: t + "-leave-active",
					appearActiveClass: t + "-enter-active"
			};
	});

	function sr(t) {
			var e = !1;
			return function() {
					e || ((e = !0), t());
			};
	}

	function cr(t, e) {
			e.data.show || rr(e);
	}
	var ur = (function(t) {
					var e, r, i = {},
							o = t.modules,
							a = t.nodeOps;
					for (e = 0; e < sn.length; ++e)
							for ((i[sn[e]] = []), (r = 0); r < o.length; ++r)
									void 0 !== o[r][sn[e]] && i[sn[e]].push(o[r][sn[e]]);

					function c(t) {
							var e = a.parentNode(t);
							e && a.removeChild(e, t);
					}
					var u = 0;

					function l(t, e, n, r, o) {
							if (
									((t.isRootInsert = !o), !(function(t, e, n, r) {
											var o = t.data;
											if (un(o)) {
													var a = un(t.componentInstance) && o.keepAlive;
													if (
															(un((o = o.hook)) && un((o = o.init)) && o(t, !1, n, r), un(
																	t.componentInstance
															))
													)
															return d(t, e), a &&
																	(function(t, e, n, r) {
																			for (var o, a = t; a.componentInstance;)
																					if (
																							((a = a.componentInstance._vnode), un((o = a.data)) &&
																									un((o = o.transition)))
																					) {
																							for (o = 0; o < i.activate.length; ++o)
																									i.activate[o](an, a);
																							e.push(a);
																							break;
																					}
																			p(n, t.elm, r);
																	})(t, e, n, r), !0;
											}
									})(t, e, n, r))
							) {
									var s = t.data,
											c = t.children,
											l = t.tag;
									un(l) ? (s && s.pre && u++, u ||
											t.ns ||
											(A.ignoredElements.length && A.ignoredElements.indexOf(l) > -1) ||
											!A.isUnknownElement(l) ||
											Q(
													"Unknown custom element: <" +
													l +
													'> - did you register the component correctly? For recursive components, make sure to provide the "name" option.',
													t.context
											), (t.elm = t.ns ? a.createElementNS(t.ns, l) : a.createElement(l, t)), v(t), f(t, c, e), un(s) && m(t, e), p(
													n,
													t.elm,
													r
											), s && s.pre && u--) : t.isComment ? ((t.elm = a.createComment(t.text)), p(n, t.elm, r)) : ((t.elm = a.createTextNode(t.text)), p(n, t.elm, r));
							}
					}

					function d(t, e) {
							t.data.pendingInsert && e.push.apply(e, t.data.pendingInsert), (t.elm =
									t.componentInstance.$el), h(t) ? (m(t, e), v(t)) : (on(t), e.push(t));
					}

					function p(t, e, n) {
							t && (n ? a.insertBefore(t, e, n) : a.appendChild(t, e));
					}

					function f(t, e, n) {
							if (Array.isArray(e))
									for (var r = 0; r < e.length; ++r)
											l(e[r], n, t.elm, null, !0);
							else s(t.text) && a.appendChild(t.elm, a.createTextNode(t.text));
					}

					function h(t) {
							for (; t.componentInstance;)
									t = t.componentInstance._vnode;
							return un(t.tag);
					}

					function m(t, n) {
							for (var r = 0; r < i.create.length; ++r)
									i.create[r](an, t);
							un((e = t.data.hook)) &&
									(e.create && e.create(an, t), e.insert && n.push(t));
					}

					function v(t) {
							var e;
							un((e = t.context)) &&
									un((e = e.$options._scopeId)) &&
									a.setAttribute(t.elm, e, ""), un((e = ne)) &&
									e !== t.context &&
									un((e = e.$options._scopeId)) &&
									a.setAttribute(t.elm, e, "");
					}

					function g(t, e, n, r, i, o) {
							for (; r <= i; ++r)
									l(n[r], o, t, e);
					}

					function y(t) {
							var e, n, r = t.data;
							if (un(r))
									for (
											un((e = r.hook)) && un((e = e.destroy)) && e(t), (e = 0); e < i.destroy.length;
											++e
									)
											i.destroy[e](t);
							if (un((e = t.children)))
									for (n = 0; n < t.children.length; ++n)
											y(t.children[n]);
					}

					function b(t, e, n, r) {
							for (; n <= r; ++n) {
									var i = e[n];
									un(i) && (un(i.tag) ? (w(i), y(i)) : c(i.elm));
							}
					}

					function w(t, n) {
							if (n || un(t.data)) {
									var r = i.remove.length + 1;
									for (
											n ? (n.listeners += r) : (n = (function(t, e) {
													function n() {
															0 == --n.listeners && c(t);
													}
													return (n.listeners = e), n;
											})(t.elm, r)), un((e = t.componentInstance)) &&
											un((e = e._vnode)) &&
											un(e.data) &&
											w(e, n), (e = 0); e < i.remove.length;
											++e
									)
											i.remove[e](t, n);
									un((e = t.data.hook)) && un((e = e.remove)) ? e(t, n) : n();
							} else c(t.elm);
					}

					function _(t, e, n, r) {
							if (t !== e) {
									if (
											e.isStatic &&
											t.isStatic &&
											e.key === t.key &&
											(e.isCloned || e.isOnce)
									)
											return (e.elm = t.elm), void(e.componentInstance =
													t.componentInstance);
									var o, s = e.data,
											c = un(s);
									c && un((o = s.hook)) && un((o = o.prepatch)) && o(t, e);
									var u = (e.elm = t.elm),
											d = t.children,
											p = e.children;
									if (c && h(e)) {
											for (o = 0; o < i.update.length; ++o)
													i.update[o](t, e);
											un((o = s.hook)) && un((o = o.update)) && o(t, e);
									}
									cn(e.text) ? un(d) && un(p) ? d !== p &&
											(function(t, e, n, r, i) {
													for (
															var o,
																	s,
																	c,
																	u = 0,
																	d = 0,
																	p = e.length - 1,
																	f = e[0],
																	h = e[p],
																	m = n.length - 1,
																	v = n[0],
																	y = n[m],
																	w = !i; u <= p && d <= m;

													)
															cn(f) ? (f = e[++u]) : cn(h) ? (h = e[--p]) : ln(f, v) ? (_(f, v, r), (f = e[++u]), (v = n[++d])) : ln(h, y) ? (_(h, y, r), (h = e[--p]), (y = n[--m])) : ln(f, y) ? (_(f, y, r), w &&
																	a.insertBefore(
																			t,
																			f.elm,
																			a.nextSibling(h.elm)
																	), (f = e[++u]), (y = n[--m])) : ln(h, v) ? (_(h, v, r), w &&
																	a.insertBefore(
																			t,
																			h.elm,
																			f.elm
																	), (h = e[--p]), (v = n[++d])) : (cn(o) && (o = dn(e, u, p)), cn(
																	(s = un(v.key) ? o[v.key] : null)
															) ? (l(v, r, t, f.elm), (v =
																	n[++d])) : ((c = e[s]) ||
																	Q(
																			"It seems there are duplicate keys that is causing an update error. Make sure each v-for item has a unique key."
																	), ln(c, v) ? (_(c, v, r), (e[
																					s
																			] = void 0), w &&
																			a.insertBefore(
																					t,
																					v.elm,
																					f.elm
																			), (v = n[++d])) : (l(v, r, t, f.elm), (v =
																			n[++d]))));
													u > p ? g(t, cn(n[m + 1]) ? null : n[m + 1].elm, n, d, m, r) : d > m && b(0, e, u, p);
											})(u, d, p, n, r) : un(p) ? (un(t.text) && a.setTextContent(u, ""), g(
													u,
													null,
													p,
													0,
													p.length - 1,
													n
											)) : un(d) ? b(0, d, 0, d.length - 1) : un(t.text) && a.setTextContent(u, "") : t.text !== e.text && a.setTextContent(u, e.text), c &&
											un((o = s.hook)) &&
											un((o = o.postpatch)) &&
											o(t, e);
							}
					}

					function x(t, e, n) {
							if (n && t.parent) t.parent.data.pendingInsert = e;
							else
									for (var r = 0; r < e.length; ++r) e[r].data.hook.insert(e[r]);
					}
					var k = !1,
							S = n("attrs,style,class,staticClass,staticStyle,key");
					return function(t, n, r, o, s, c) {
							if (n) {
									var u, p = !1,
											v = [];
									if (t) {
											var g = un(t.nodeType);
											if (!g && ln(t, n)) _(t, n, v, o);
											else {
													if (g) {
															if (
																	(1 === t.nodeType &&
																			t.hasAttribute("server-rendered") &&
																			(t.removeAttribute("server-rendered"), (r = !0)), r)
															) {
																	if (
																			(function t(n, r, i) {
																					if (
																							((o = n), !((a = r).tag ? 0 === a.tag.indexOf("vue-component") ||
																									a.tag.toLowerCase() ===
																									(o.tagName && o.tagName.toLowerCase()) : o.nodeType === (a.isComment ? 8 : 3)))
																					)
																							return !1;
																					var o, a;
																					r.elm = n;
																					var s = r.tag,
																							c = r.data,
																							u = r.children;
																					if (
																							un(c) &&
																							(un((e = c.hook)) && un((e = e.init)) && e(r, !0), un(
																									(e = r.componentInstance)
																							))
																					)
																							return d(r, i), !0;
																					if (un(s)) {
																							if (un(u))
																									if (n.hasChildNodes()) {
																											for (
																													var l = !0, p = n.firstChild, h = 0; h < u.length; h++
																											) {
																													if (!p || !t(p, u[h], i)) {
																															l = !1;
																															break;
																													}
																													p = p.nextSibling;
																											}
																											if (!l || p)
																													return "undefined" == typeof console ||
																															k ||
																															((k = !0), console.warn(
																																	"Parent: ",
																																	n
																															), console.warn(
																																	"Mismatching childNodes vs. VNodes: ",
																																	n.childNodes,
																																	u
																															)), !1;
																									} else f(r, u, i);
																							if (un(c))
																									for (var v in c)
																											if (!S(v)) {
																													m(r, i);
																													break;
																											}
																					} else n.data !== r.text && (n.data = r.text);
																					return !0;
																			})(t, n, v)
																	)
																			return x(n, v, !0), t;
																	Q(
																			"The client-side rendered virtual DOM tree is not matching server-rendered content. This is likely caused by incorrect HTML markup, for example nesting block-level elements inside <p>, or missing <tbody>. Bailing hydration and performing full client-side render."
																	);
															}
															(u = t), (t = new jt(
																	a.tagName(u).toLowerCase(), {}, [],
																	void 0,
																	u
															));
													}
													var w = t.elm,
															C = a.parentNode(w);
													if ((l(n, v, w._leaveCb ? null : C, a.nextSibling(w)), n.parent)) {
															for (var T = n.parent; T;)
																	(T.elm = n.elm), (T = T.parent);
															if (h(n))
																	for (var E = 0; E < i.create.length; ++E)
																			i.create[E](an, n.parent);
													}
													null !== C ? b(0, [t], 0, 0) : un(t.tag) && y(t);
											}
									} else(p = !0), l(n, v, s, c);
									return x(n, v, p), n.elm;
							}
							t && y(t);
					};
			})({
					nodeOps: nn,
					modules: [
							wn,
							kn,
							En,
							$n,
							Rn,
							L ? {
									create: cr,
									activate: cr,
									remove: function(t, e) {
											t.data.show ? e() : ir(t, e);
									}
							} : {}
					].concat(gn)
			}),
			lr = /^input|select|textarea|vue-component-[0-9]+(-[0-9a-zA-Z_-]*)?$/;

	function dr(t, e, n) {
			var r = e.value,
					i = t.multiple;
			if (!i || Array.isArray(r)) {
					for (var o, a, s = 0, c = t.options.length; s < c; s++)
							if (((a = t.options[s]), i))
									(o = E(r, fr(a)) > -1), a.selected !== o && (a.selected = o);
							else if (T(fr(a), r))
							return void(t.selectedIndex !== s && (t.selectedIndex = s));
					i || (t.selectedIndex = -1);
			} else Q('<select multiple v-model="' + e.expression + '"> expects an Array value for its binding, but got ' + Object.prototype.toString.call(r).slice(8, -1), n);
	}

	function pr(t, e) {
			for (var n = 0, r = e.length; n < r; n++)
					if (T(fr(e[n]), t)) return !1;
			return !0;
	}

	function fr(t) {
			return "_value" in t ? t._value : t.value;
	}

	function hr(t) {
			t.target.composing = !0;
	}

	function mr(t) {
			(t.target.composing = !1), vr(t.target, "input");
	}

	function vr(t, e) {
			var n = document.createEvent("HTMLEvents");
			n.initEvent(e, !0, !0), t.dispatchEvent(n);
	}

	function gr(t) {
			return !t.componentInstance || (t.data && t.data.transition) ? t : gr(t.componentInstance._vnode);
	}
	D &&
			document.addEventListener("selectionchange", function() {
					var t = document.activeElement;
					t && t.vmodel && vr(t, "input");
			});
	var yr = {
					model: {
							inserted: function(t, e, n) {
									if (
											(lr.test(n.tag) ||
													Q(
															"v-model is not supported on element type: <" +
															n.tag +
															">. If you are working with contenteditable, it's recommended to wrap a library dedicated for that purpose inside a custom component.",
															n.context
													), "select" === n.tag)
									) {
											var r = function() {
													dr(t, e, n.context);
											};
											r(), (M || q) && setTimeout(r, 0);
									} else
											("textarea" !== n.tag && "text" !== t.type) ||
											((t._vModifiers = e.modifiers), e.modifiers.lazy ||
													(R ||
															(t.addEventListener("compositionstart", hr), t.addEventListener(
																	"compositionend",
																	mr
															)), D && (t.vmodel = !0)));
							},
							componentUpdated: function(t, e, n) {
									"select" === n.tag &&
											(dr(t, e, n.context), (t.multiple ? e.value.some(function(e) {
															return pr(e, t.options);
													}) : e.value !== e.oldValue && pr(e.value, t.options)) &&
													vr(t, "change"));
							}
					},
					show: {
							bind: function(t, e, n) {
									var r = e.value,
											i = (n = gr(n)).data && n.data.transition,
											o = (t.__vOriginalDisplay = "none" === t.style.display ? "" : t.style.display);
									r && i && !D ? ((n.data.show = !0), rr(n, function() {
											t.style.display = o;
									})) : (t.style.display = r ? o : "none");
							},
							update: function(t, e, n) {
									var r = e.value;
									r !== e.oldValue &&
											((n = gr(n)).data && n.data.transition && !D ? ((n.data.show = !0), r ? rr(n, function() {
													t.style.display = t.__vOriginalDisplay;
											}) : ir(n, function() {
													t.style.display = "none";
											})) : (t.style.display = r ? t.__vOriginalDisplay : "none"));
							},
							unbind: function(t, e, n, r, i) {
									i || (t.style.display = t.__vOriginalDisplay);
							}
					}
			},
			br = {
					name: String,
					appear: Boolean,
					css: Boolean,
					mode: String,
					type: String,
					enterClass: String,
					leaveClass: String,
					enterToClass: String,
					leaveToClass: String,
					enterActiveClass: String,
					leaveActiveClass: String,
					appearClass: String,
					appearActiveClass: String,
					appearToClass: String
			};

	function wr(t) {
			var e = t && t.componentOptions;
			return e && e.Ctor.options.abstract ? wr(Jt(e.children)) : t;
	}

	function _r(t) {
			var e = {},
					n = t.$options;
			for (var r in n.propsData) e[r] = t[r];
			var i = n._parentListeners;
			for (var o in i) e[l(o)] = i[o].fn;
			return e;
	}

	function xr(t, e) {
			return /\d-keep-alive$/.test(e.tag) ? t("keep-alive") : null;
	}
	var kr = {
					name: "transition",
					props: br,
					abstract: !0,
					render: function(t) {
							var e = this,
									n = this.$slots.default;
							if (
									n &&
									(n = n.filter(function(t) {
											return t.tag;
									})).length
							) {
									n.length > 1 &&
											Q(
													"<transition> can only be used on a single element. Use <transition-group> for lists.",
													this.$parent
											);
									var r = this.mode;
									r &&
											"in-out" !== r &&
											"out-in" !== r &&
											Q("invalid <transition> mode: " + r, this.$parent);
									var i = n[0];
									if (
											(function(t) {
													for (;
															(t = t.parent);)
															if (t.data.transition) return !0;
											})(this.$vnode)
									)
											return i;
									var o = wr(i);
									if (!o) return i;
									if (this._leaving) return xr(t, i);
									var a,
											c,
											u = "__transition-" + this._uid + "-",
											l = (o.key = null == o.key ? u + o.tag : s(o.key) ? 0 === String(o.key).indexOf(u) ? o.key : u + o.key : o.key),
											d = ((o.data || (o.data = {})).transition = _r(this)),
											p = wr(this._vnode);
									if (
											(o.data.directives &&
													o.data.directives.some(function(t) {
															return "show" === t.name;
													}) &&
													(o.data.show = !0), p &&
													p.data &&
													((a = o), (c = p).key !== a.key || c.tag !== a.tag))
									) {
											var f = p && (p.data.transition = v({}, d));
											if ("out-in" === r)
													return (this._leaving = !0), Wt(
															f,
															"afterLeave",
															function() {
																	(e._leaving = !1), e.$forceUpdate();
															},
															l
													), xr(t, i);
											if ("in-out" === r) {
													var h,
															m = function() {
																	h();
															};
													Wt(d, "afterEnter", m, l), Wt(d, "enterCancelled", m, l), Wt(
															f,
															"delayLeave",
															function(t) {
																	h = t;
															},
															l
													);
											}
									}
									return i;
							}
					}
			},
			Sr = v({
					tag: String,
					moveClass: String
			}, br);

	function Cr(t) {
			t.elm._moveCb && t.elm._moveCb(), t.elm._enterCb && t.elm._enterCb();
	}

	function Tr(t) {
			t.data.newPos = t.elm.getBoundingClientRect();
	}

	function Er(t) {
			var e = t.data.pos,
					n = t.data.newPos,
					r = e.left - n.left,
					i = e.top - n.top;
			if (r || i) {
					t.data.moved = !0;
					var o = t.elm.style;
					(o.transform = o.WebkitTransform =
							"translate(" + r + "px," + i + "px)"), (o.transitionDuration = "0s");
			}
	}
	delete Sr.mode;
	var Ar = {
			Transition: kr,
			TransitionGroup: {
					props: Sr,
					render: function(t) {
							for (
									var e = this.tag || this.$vnode.data.tag || "span",
											n = Object.create(null),
											r = (this.prevChildren = this.children),
											i = this.$slots.default || [],
											o = (this.children = []),
											a = _r(this),
											s = 0; s < i.length; s++
							) {
									var c = i[s];
									if (c.tag)
											if (null != c.key && 0 !== String(c.key).indexOf("__vlist"))
													o.push(c), (n[c.key] = c), ((c.data ||
															(c.data = {})).transition = a);
											else {
													var u = c.componentOptions,
															l = u ? u.Ctor.options.name || u.tag : c.tag;
													Q("<transition-group> children must be keyed: <" + l + ">");
											}
							}
							if (r) {
									for (var d = [], p = [], f = 0; f < r.length; f++) {
											var h = r[f];
											(h.data.transition = a), (h.data.pos = h.elm.getBoundingClientRect()), n[
													h.key
											] ? d.push(h) : p.push(h);
									}
									(this.kept = t(e, null, d)), (this.removed = p);
							}
							return t(e, null, o);
					},
					beforeUpdate: function() {
							this.__patch__(
									this._vnode,
									this.kept, !1, !0
							), (this._vnode = this.kept);
					},
					updated: function() {
							var t = this.prevChildren,
									e = this.moveClass || (this.name || "v") + "-move";
							if (t.length && this.hasMove(t[0].elm, e)) {
									t.forEach(Cr), t.forEach(Tr), t.forEach(Er);
									document.body.offsetHeight;
									t.forEach(function(t) {
											if (t.data.moved) {
													var n = t.elm,
															r = n.style;
													Xn(
															n,
															e
													), (r.transform = r.WebkitTransform = r.transitionDuration =
															""), n.addEventListener(
															Bn, (n._moveCb = function t(r) {
																	(r && !/transform$/.test(r.propertyName)) ||
																	(n.removeEventListener(Bn, t), (n._moveCb = null), Yn(
																			n,
																			e
																	));
															})
													);
											}
									});
							}
					},
					methods: {
							hasMove: function(t, e) {
									if (!Fn) return !1;
									if (null != this._hasMove) return this._hasMove;
									Xn(t, e);
									var n = tr(t);
									return Yn(t, e), (this._hasMove = n.hasTransform);
							}
					}
			}
	};
	(Ee.config.isUnknownElement = function(t) {
			if (!L) return !0;
			if (Ke(t)) return !1;
			if (((t = t.toLowerCase()), null != tn[t])) return tn[t];
			var e = document.createElement(t);
			return t.indexOf("-") > -1 ? (tn[t] =
					e.constructor === window.HTMLUnknownElement ||
					e.constructor === window.HTMLElement) : (tn[t] = /HTMLUnknownElement/.test(e.toString()));
	}), (Ee.config.isReservedTag = Ke), (Ee.config.getTagNamespace = Ze), (Ee.config.mustUseProp = De), v(Ee.options.directives, yr), v(Ee.options.components, Ar), (Ee.prototype.__patch__ = L ? ur : x), (Ee.prototype.$mount = function(
			t,
			e
	) {
			return (t = t && L ? en(t) : void 0), this._mount(t, e);
	}), L && "undefined" != typeof console && console[console.info ? "info" : "log"]("You are running Vue in development mode.\nMake sure to turn on production mode when deploying for production.\nSee more tips at https://vuejs.org/guide/deployment.html"), setTimeout(function() {
			A.devtools &&
					(H ? H.emit("init", Ee) : L &&
							!q &&
							/Chrome\/\d+/.test(window.navigator.userAgent) &&
							console[console.info ? "info" : "log"](
									"Download the Vue Devtools extension for a better development experience:\nhttps://github.com/vuejs/vue-devtools"
							));
	}, 0);
	var $r,
			jr,
			Ir,
			Nr,
			zr = !!L &&
			(($r = "\n"), (jr = "&#10;"), ((Ir = document.createElement(
							"div"
					)).innerHTML =
					'<div a="' + $r + '">'), Ir.innerHTML.indexOf(jr) > 0);
	var Or = n(
					"area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr", !0
			),
			Lr = n("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source", !0),
			Pr = n(
					"address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track", !0
			),
			Mr = new RegExp(
					"^\\s*" +
					/([^\s"'<>/=]+)/.source +
					"(?:\\s*(" +
					/(?:=)/.source +
					")\\s*(?:" + [
							/"([^"]*)"+/.source,
							/'([^']*)'+/.source,
							/([^\s"'=<>`]+)/.source
					].join("|") +
					"))?"
			),
			Dr = "[a-zA-Z_][\\w\\-\\.]*",
			qr = "((?:" + Dr + "\\:)?" + Dr + ")",
			Rr = new RegExp("^<" + qr),
			Fr = /^\s*(\/?)>/,
			Wr = new RegExp("^<\\/" + qr + "[^>]*>"),
			Hr = /^<!DOCTYPE [^>]+>/i,
			Vr = /^<!--/,
			Br = /^<!\[/,
			Ur = !1;
	"x".replace(/x(.)?/g, function(t, e) {
			Ur = "" === e;
	});
	var Jr = n("script,style", !0),
			Qr = {},
			Gr = /&lt;/g,
			Xr = /&gt;/g,
			Yr = /&#10;/g,
			Kr = /&amp;/g,
			Zr = /&quot;/g;

	function ti(t) {
			var e,
					n,
					r,
					i,
					o,
					a = !1,
					s = !1,
					c = !1,
					u = !1,
					l = 0,
					d = 0,
					p = 0,
					f = 0;
			for (
					r = 0; r < t.length; r++
			)
					if (((n = e), (e = t.charCodeAt(r)), a)) 39 === e && 92 !== n && (a = !1);
					else if (s) 34 === e && 92 !== n && (s = !1);
			else if (c) 96 === e && 92 !== n && (c = !1);
			else if (u) 47 === e && 92 !== n && (u = !1);
			else if (
					124 !== e ||
					124 === t.charCodeAt(r + 1) ||
					124 === t.charCodeAt(r - 1) ||
					l ||
					d ||
					p
			) {
					switch (e) {
							case 34:
									s = !0;
									break;
							case 39:
									a = !0;
									break;
							case 96:
									c = !0;
									break;
							case 40:
									p++;
									break;
							case 41:
									p--;
									break;
							case 91:
									d++;
									break;
							case 93:
									d--;
									break;
							case 123:
									l++;
									break;
							case 125:
									l--;
					}
					if (47 === e) {
							for (
									var h = r - 1, m = void 0; h >= 0 && " " === (m = t.charAt(h)); h--
							);
							(m && /[\w$]/.test(m)) || (u = !0);
					}
			} else void 0 === i ? ((f = r + 1), (i = t.slice(0, r).trim())) : v();

			function v() {
					(o || (o = [])).push(t.slice(f, r).trim()), (f = r + 1);
			}
			if ((void 0 === i ? (i = t.slice(0, r).trim()) : 0 !== f && v(), o))
					for (r = 0; r < o.length; r++)
							i = ei(i, o[r]);
			return i;
	}

	function ei(t, e) {
			var n = e.indexOf("(");
			return n < 0 ? '_f("' + e + '")(' + t + ")" : '_f("' + e.slice(0, n) + '")(' + t + "," + e.slice(n + 1);
	}
	var ni,
			ri,
			ii,
			oi,
			ai,
			si,
			ci = /\{\{((?:.|\n)+?)\}\}/g,
			ui = /[-.*+?^${}()|[\]\/\\]/g,
			li = c(function(t) {
					var e = t[0].replace(ui, "\\$&"),
							n = t[1].replace(ui, "\\$&");
					return new RegExp(e + "((?:.|\\n)+?)" + n, "g");
			});

	function di(t, e) {
			var n = e ? li(e) : ci;
			if (n.test(t)) {
					for (var r, i, o = [], a = (n.lastIndex = 0);
							(r = n.exec(t));) {
							(i = r.index) > a && o.push(JSON.stringify(t.slice(a, i)));
							var s = ti(r[1].trim());
							o.push("_s(" + s + ")"), (a = i + r[0].length);
					}
					return a < t.length && o.push(JSON.stringify(t.slice(a))), o.join("+");
			}
	}

	function pi(t) {
			console.error("[Vue parser]: " + t);
	}

	function fi(t, e) {
			return t ? t
					.map(function(t) {
							return t[e];
					})
					.filter(function(t) {
							return t;
					}) : [];
	}

	function hi(t, e, n) {
			(t.props || (t.props = [])).push({
					name: e,
					value: n
			});
	}

	function mi(t, e, n) {
			(t.attrs || (t.attrs = [])).push({
					name: e,
					value: n
			});
	}

	function vi(t, e, n, r, i) {
			var o;
			r &&
					r.capture &&
					(delete r.capture, (e =
							"!" +
							e)), r && r.once && (delete r.once, (e = "~" + e)), r && r.native ? (delete r.native, (o = t.nativeEvents || (t.nativeEvents = {}))) : (o = t.events || (t.events = {}));
			var a = {
							value: n,
							modifiers: r
					},
					s = o[e];
			Array.isArray(s) ? i ? s.unshift(a) : s.push(a) : (o[e] = s ? (i ? [a, s] : [s, a]) : a);
	}

	function gi(t, e, n) {
			var r = yi(t, ":" + e) || yi(t, "v-bind:" + e);
			if (null != r) return ti(r);
			if (!1 !== n) {
					var i = yi(t, e);
					if (null != i) return JSON.stringify(i);
			}
	}

	function yi(t, e) {
			var n;
			if (null != (n = t.attrsMap[e]))
					for (var r = t.attrsList, i = 0, o = r.length; i < o; i++)
							if (r[i].name === e) {
									r.splice(i, 1);
									break;
							}
			return n;
	}

	function bi() {
			return ri.charCodeAt(++oi);
	}

	function wi() {
			return oi >= ni;
	}

	function _i(t) {
			return 34 === t || 39 === t;
	}

	function xi(t) {
			var e = 1;
			for (ai = oi; !wi();)
					if (_i((t = bi()))) ki(t);
					else if ((91 === t && e++, 93 === t && e--, 0 === e)) {
					si = oi;
					break;
			}
	}

	function ki(t) {
			for (var e = t; !wi() && (t = bi()) !== e;);
	}
	var Si,
			Ci,
			Ti,
			Ei,
			Ai,
			$i,
			ji,
			Ii,
			Ni = /^v-|^@|^:/,
			zi = /(.*?)\s+(?:in|of)\s+(.*)/,
			Oi = /\((\{[^}]*\}|[^,]*),([^,]*)(?:,([^,]*))?\)/,
			Li = /^:|^v-bind:/,
			Pi = /^@|^v-on:/,
			Mi = /:(.*)$/,
			Di = /\.[^.]+/g,
			qi = c(function(t) {
					return ((Nr =
							Nr || document.createElement("div")).innerHTML = t), Nr.textContent;
			});

	function Ri(t, e) {
			(Si =
					e.warn ||
					pi), (Ci = e.getTagNamespace || k), (Ti = e.mustUseProp || k), (Ei = e.isPreTag || k), (Ai = fi(e.modules, "preTransformNode")), ($i = fi(e.modules, "transformNode")), (ji = fi(e.modules, "postTransformNode")), (Ii = e.delimiters);
			var n, r, i = [],
					o = !1 !== e.preserveWhitespace,
					a = !1,
					s = !1,
					c = !1;
			return (function(t, e) {
					for (
							var n, r, i = [], o = e.expectHTML, a = e.isUnaryTag || k, s = 0; t;

					) {
							if (((n = t), r && Jr(r))) {
									var c = r.toLowerCase(),
											u =
											Qr[c] ||
											(Qr[c] = new RegExp("([\\s\\S]*?)(</" + c + "[^>]*>)", "i")),
											l = 0,
											d = t.replace(u, function(t, n, r) {
													return (l =
															r.length), "script" !== c && "style" !== c && "noscript" !== c && (n = n.replace(/<!--([\s\S]*?)-->/g, "$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g, "$1")), e.chars && e.chars(n), "";
											});
									(s += t.length - d.length), (t = d), T(c, s - l, s);
							} else {
									var p = t.indexOf("<");
									if (0 === p) {
											if (Vr.test(t)) {
													var f = t.indexOf("--\x3e");
													if (f >= 0) {
															x(f + 3);
															continue;
													}
											}
											if (Br.test(t)) {
													var h = t.indexOf("]>");
													if (h >= 0) {
															x(h + 2);
															continue;
													}
											}
											var m = t.match(Hr);
											if (m) {
													x(m[0].length);
													continue;
											}
											var v = t.match(Wr);
											if (v) {
													var g = s;
													x(v[0].length), T(v[1], g, s);
													continue;
											}
											var y = S();
											if (y) {
													C(y);
													continue;
											}
									}
									var b = void 0,
											w = void 0,
											_ = void 0;
									if (p > 0) {
											for (
													w = t.slice(p); !(Wr.test(w) ||
															Rr.test(w) ||
															Vr.test(w) ||
															Br.test(w) ||
															(_ = w.indexOf("<", 1)) < 0);

											)
													(p += _), (w = t.slice(p));
											(b = t.substring(0, p)), x(p);
									}
									p < 0 && ((b = t), (t = "")), e.chars && b && e.chars(b);
							}
							if (t === n && e.chars) {
									e.chars(t);
									break;
							}
					}

					function x(e) {
							(s += e), (t = t.substring(e));
					}

					function S() {
							var e = t.match(Rr);
							if (e) {
									var n, r, i = {
											tagName: e[1],
											attrs: [],
											start: s
									};
									for (x(e[0].length); !(n = t.match(Fr)) && (r = t.match(Mr));)
											x(r[0].length), i.attrs.push(r);
									if (n) return (i.unarySlash = n[1]), x(n[0].length), (i.end = s), i;
							}
					}

					function C(t) {
							var n = t.tagName,
									s = t.unarySlash;
							o && ("p" === r && Pr(n) && T(r), Lr(n) && r === n && T(n));
							for (
									var c,
											u,
											l = a(n) || ("html" === n && "head" === r) || !!s,
											d = t.attrs.length,
											p = new Array(d),
											f = 0; f < d; f++
							) {
									var h = t.attrs[f];
									Ur &&
											-1 === h[0].indexOf('""') &&
											("" === h[3] && delete h[3], "" === h[4] && delete h[4], "" ===
													h[5] && delete h[5]);
									var m = h[3] || h[4] || h[5] || "";
									p[f] = {
											name: h[1],
											value: ((c = m), (u = e.shouldDecodeNewlines), u &&
													(c = c.replace(Yr, "\n")), c
													.replace(Gr, "<")
													.replace(Xr, ">")
													.replace(Kr, "&")
													.replace(Zr, '"'))
									};
							}
							l ||
									(i.push({
											tag: n,
											lowerCasedTag: n.toLowerCase(),
											attrs: p
									}), (r = n), (s = "")), e.start && e.start(n, p, l, t.start, t.end);
					}

					function T(t, n, o) {
							var a, c;
							if (
									(null == n && (n = s), null == o && (o = s), t &&
											(c = t.toLowerCase()), t)
							)
									for (a = i.length - 1; a >= 0 && i[a].lowerCasedTag !== c; a--);
							else a = 0;
							if (a >= 0) {
									for (var u = i.length - 1; u >= a; u--)
											e.end && e.end(i[u].tag, n, o);
									(i.length = a), (r = a && i[a - 1].tag);
							} else "br" === c ? e.start && e.start(t, [], !0, n, o) : "p" === c && (e.start && e.start(t, [], !1, n, o), e.end && e.end(t, n, o));
					}
					T();
			})(t, {
					expectHTML: e.expectHTML,
					isUnaryTag: e.isUnaryTag,
					shouldDecodeNewlines: e.shouldDecodeNewlines,
					start: function(o, u, d) {
							var p = (r && r.ns) || Ci(o);
							M &&
									"svg" === p &&
									(u = (function(t) {
											for (var e = [], n = 0; n < t.length; n++) {
													var r = t[n];
													Bi.test(r.name) || ((r.name = r.name.replace(Ui, "")), e.push(r));
											}
											return e;
									})(u));
							var f,
									h,
									m,
									v,
									g,
									y,
									b,
									w,
									_,
									x = {
											type: 1,
											tag: o,
											attrsList: u,
											attrsMap: (function(t) {
													for (var e = {}, n = 0, r = t.length; n < r; n++)
															e[t[n].name] &&
															!M &&
															Si("duplicate attribute: " + t[n].name), (e[t[n].name] =
																	t[n].value);
													return e;
											})(u),
											parent: r,
											children: []
									};
							p && (x.ns = p), ("style" !== (f = x).tag &&
											("script" !== f.tag ||
													(f.attrsMap.type && "text/javascript" !== f.attrsMap.type))) ||
									W() ||
									((x.forbidden = !0), Si(
											"Templates should only be responsible for mapping the state to the UI. Avoid placing tags with side-effects in your templates, such as <" +
											o +
											">, as they will not be parsed."
									));
							for (var k = 0; k < Ai.length; k++)
									Ai[k](x, e);
							if (
									(a ||
											(null != yi((h = x), "v-pre") && (h.pre = !0), x.pre &&
													(a = !0)), Ei(x.tag) && (s = !0), a)
							)
									!(function(t) {
											var e = t.attrsList.length;
											if (e)
													for (var n = (t.attrs = new Array(e)), r = 0; r < e; r++)
															n[r] = {
																	name: t.attrsList[r].name,
																	value: JSON.stringify(t.attrsList[r].value)
															};
											else t.pre || (t.plain = !0);
									})(x);
							else {
									!(function(t) {
											var e;
											if ((e = yi(t, "v-for"))) {
													var n = e.match(zi);
													if (!n) return void Si("Invalid v-for expression: " + e);
													t.for = n[2].trim();
													var r = n[1].trim(),
															i = r.match(Oi);
													i
															? ((t.alias = i[1].trim()), (t.iterator1 = i[2].trim()), i[3] &&
																	(t.iterator2 = i[3].trim())) : (t.alias = r);
											}
									})(x), (function(t) {
											var e = yi(t, "v-if");
											if (e)(t.if = e), Fi(t, {
													exp: e,
													block: t
											});
											else {
													null != yi(t, "v-else") && (t.else = !0);
													var n = yi(t, "v-else-if");
													n && (t.elseif = n);
											}
									})(x), null != yi((b = x), "v-once") && (b.once = !0), (y = gi(
													(g = x),
													"key"
											)) &&
											("template" === g.tag &&
													Si(
															"<template> cannot be keyed. Place the key on real elements instead."
													), (g.key = y)), (x.plain = !x.key && !u.length), (v = gi(
													(m = x),
													"ref"
											)) &&
											((m.ref = v), (m.refInFor = (function(t) {
													for (var e = t; e;) {
															if (void 0 !== e.for) return !0;
															e = e.parent;
													}
													return !1;
											})(m))), (function(t) {
													if ("slot" === t.tag)
															(t.slotName = gi(t, "name")), t.key &&
															Si(
																	"`key` does not work on <slot> because slots are abstract outlets and can possibly expand into multiple elements. Use the key on a wrapping element instead."
															);
													else {
															var e = gi(t, "slot");
															e && (t.slotTarget = '""' === e ? '"default"' : e), "template" ===
																	t.tag && (t.slotScope = yi(t, "scope"));
													}
											})(x), (function(t) {
													var e;
													(e = gi(t, "is")) && (t.component = e);
													null != yi(t, "inline-template") && (t.inlineTemplate = !0);
											})(x);
									for (var S = 0; S < $i.length; S++)
											$i[S](x, e);
									!(function(t) {
											var e, n, r, i, o, a, s, c, u = t.attrsList;
											for ((e = 0), (n = u.length); e < n; e++)
													if (((r = i = u[e].name), (o = u[e].value), Ni.test(r)))
															if (
																	((t.hasBindings = !0), (s = Wi(r)) &&
																			(r = r.replace(Di, "")), Li.test(r))
															)
																	(r = r.replace(Li, "")), (o = ti(o)), (c = !1), s &&
																	(s.prop &&
																			((c = !0), "innerHtml" === (r = l(r)) &&
																					(r = "innerHTML")), s.camel && (r = l(r))), c ||
																	Ti(t.tag, t.attrsMap.type, r) ? hi(t, r, o) : mi(t, r, o);
															else if (Pi.test(r))(r = r.replace(Pi, "")), vi(t, r, o, s);
											else {
													var d = (r = r.replace(Ni, "")).match(Mi);
													d &&
															(a = d[1]) &&
															(r = r.slice(
																	0, -(a.length + 1)
															)), (h = r), (m = i), (v = o), (g = a), (y = s), ((f = t)
																	.directives || (f.directives = []))
															.push({
																	name: h,
																	rawName: m,
																	value: v,
																	arg: g,
																	modifiers: y
															}), "model" === r && Ji(t, o);
											} else {
													var p = di(o, Ii);
													p &&
															Si(
																	r +
																	'="' +
																	o +
																	'": Interpolation inside attributes has been removed. Use v-bind or the colon shorthand instead. For example, instead of <div id="{{ val }}">, use <div :id="val">.'
															), mi(t, r, JSON.stringify(o));
											}
											var f, h, m, v, g, y;
									})(x);
							}

							function C(e) {
									c ||
											(("slot" !== e.tag && "template" !== e.tag) ||
													((c = !0), Si(
															"Cannot use <" +
															e.tag +
															"> as component root element because it may contain multiple nodes:\n" +
															t
													)), e.attrsMap.hasOwnProperty("v-for") &&
													((c = !0), Si(
															"Cannot use v-for on stateful component root element because it renders multiple elements:\n" +
															t
													)));
							}
							if (
									(n ? i.length ||
											(n.if && (x.elseif || x.else) ? (C(x), Fi(n, {
															exp: x.elseif,
															block: x
													})) : c ||
													((c = !0), Si(
															"Component template should contain exactly one root element:\n\n" +
															t +
															"\n\nIf you are using v-if on multiple elements, use v-else-if to chain them instead."
													))) : C((n = x)), r && !x.forbidden)
							)
									if (x.elseif || x.else)
											(w = x), (_ = (function(t) {
													var e = t.length;
													for (; e--;) {
															if (1 === t[e].type) return t[e];
															" " !== t[e].text &&
																	Si(
																			'text "' +
																			t[e].text.trim() +
																			'" between v-if and v-else(-if) will be ignored.'
																	), t.pop();
													}
											})(r.children)) && _.if ? Fi(_, {
													exp: w.elseif,
													block: w
											}) : Si(
													"v-" +
													(w.elseif ? 'else-if="' + w.elseif + '"' : "else") +
													" used on element <" +
													w.tag +
													"> without corresponding v-if."
											);
									else if (x.slotScope) {
									r.plain = !1;
									var T = x.slotTarget || "default";
									(r.scopedSlots || (r.scopedSlots = {}))[T] = x;
							} else r.children.push(x), (x.parent = r);
							d || ((r = x), i.push(x));
							for (var E = 0; E < ji.length; E++)
									ji[E](x, e);
					},
					end: function() {
							var t = i[i.length - 1],
									e = t.children[t.children.length - 1];
							e &&
									3 === e.type &&
									" " === e.text &&
									t.children.pop(), (i.length -= 1), (r = i[i.length - 1]), t.pre &&
									(a = !1), Ei(t.tag) && (s = !1);
					},
					chars: function(e) {
							if (r) {
									if (!M || "textarea" !== r.tag || r.attrsMap.placeholder !== e) {
											var n, i = r.children;
											if ((e = s || e.trim() ? qi(e) : o && i.length ? " " : ""))
													!a && " " !== e && (n = di(e, Ii)) ? i.push({
															type: 2,
															expression: n,
															text: e
													}) : (" " === e && " " === i[i.length - 1].text) ||
													r.children.push({
															type: 3,
															text: e
													});
									}
							} else
									c ||
									e !== t ||
									((c = !0), Si(
											"Component template requires a root element, rather than just text:\n\n" +
											t
									));
					}
			}), n;
	}

	function Fi(t, e) {
			t.ifConditions || (t.ifConditions = []), t.ifConditions.push(e);
	}

	function Wi(t) {
			var e = t.match(Di);
			if (e) {
					var n = {};
					return e.forEach(function(t) {
							n[t.slice(1)] = !0;
					}), n;
			}
	}
	var Hi, Vi, Bi = /^xmlns:NS\d+/,
			Ui = /^NS\d+:/;

	function Ji(t, e) {
			for (
					var n = t; n;

			) n.for && n.alias === e && Si("<" + t.tag + ' v-model="' + e + '">: You are binding v-model directly to a v-for iteration alias. This will not be able to modify the v-for source array because writing to the alias is like modifying a function local variable. Consider using an array of objects and use v-model on an object property instead.'), (n = n.parent);
	}
	var Qi = c(function(t) {
			return n(
					"type,tag,attrsList,attrsMap,plain,parent,children,attrs" +
					(t ? "," + t : "")
			);
	});

	function Gi(t, e) {
			t &&
					((Hi = Qi(e.staticKeys || "")), (Vi = e.isReservedTag || k), (function t(
							e
					) {
							e.static = (function(t) {
									if (2 === t.type) return !1;
									if (3 === t.type) return !0;
									return !(!t.pre &&
											(t.hasBindings ||
													t.if ||
													t.for ||
													r(t.tag) ||
													!Vi(t.tag) ||
													(function(t) {
															for (; t.parent;) {
																	if ("template" !== (t = t.parent).tag) return !1;
																	if (t.for) return !0;
															}
															return !1;
													})(t) ||
													!Object.keys(t).every(Hi)));
							})(e);
							if (1 === e.type) {
									if (!Vi(e.tag) &&
											"slot" !== e.tag &&
											null == e.attrsMap["inline-template"]
									)
											return;
									for (var n = 0, i = e.children.length; n < i; n++) {
											var o = e.children[n];
											t(o), o.static || (e.static = !1);
									}
							}
					})(t), Xi(t, !1));
	}

	function Xi(t, e) {
			if (1 === t.type) {
					if (
							((t.static || t.once) && (t.staticInFor = e), t.static &&
									t.children.length &&
									(1 !== t.children.length || 3 !== t.children[0].type))
					)
							return void(t.staticRoot = !0);
					if (((t.staticRoot = !1), t.children))
							for (var n = 0, r = t.children.length; n < r; n++)
									Xi(t.children[n], e || !!t.for);
					t.ifConditions &&
							(function(t, e) {
									for (var n = 1, r = t.length; n < r; n++)
											Xi(t[n].block, e);
							})(t.ifConditions, e);
			}
	}
	var Yi = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/,
			Ki = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/,
			Zi = {
					esc: 27,
					tab: 9,
					enter: 13,
					space: 32,
					up: 38,
					left: 37,
					right: 39,
					down: 40,
					delete: [8, 46]
			},
			to = {
					stop: "$event.stopPropagation();",
					prevent: "$event.preventDefault();",
					self: "if($event.target !== $event.currentTarget)return;",
					ctrl: "if(!$event.ctrlKey)return;",
					shift: "if(!$event.shiftKey)return;",
					alt: "if(!$event.altKey)return;",
					meta: "if(!$event.metaKey)return;"
			};

	function eo(t, e) {
			var n = e ? "nativeOn:{" : "on:{";
			for (var r in t) n += '"' + r + '":' + no(r, t[r]) + ",";
			return n.slice(0, -1) + "}";
	}

	function no(t, e) {
			if (e) {
					if (Array.isArray(e))
							return (
									"[" +
									e
									.map(function(e) {
											return no(t, e);
									})
									.join(",") +
									"]"
							);
					if (e.modifiers) {
							var n = "",
									r = [];
							for (var i in e.modifiers)
									to[i] ? (n += to[i]) : r.push(i);
							return r.length &&
									(n =
											"if(" +
											r.map(ro).join("&&") +
											")return;" +
											n), "function($event){" +
									n +
									(Ki.test(e.value) ? e.value + "($event)" : e.value) +
									"}";
					}
					return Yi.test(e.value) || Ki.test(e.value) ? e.value : "function($event){" + e.value + "}";
			}
			return "function(){}";
	}

	function ro(t) {
			var e = parseInt(t, 10);
			if (e) return "$event.keyCode!==" + e;
			var n = Zi[t];
			return (
					"_k($event.keyCode," +
					JSON.stringify(t) +
					(n ? "," + JSON.stringify(n) : "") +
					")"
			);
	}
	var io,
			oo,
			ao,
			so,
			co,
			uo,
			lo,
			po,
			fo = {
					bind: function(t, e) {
							t.wrapData = function(n) {
									return (
											"_b(" +
											n +
											",'" +
											t.tag +
											"'," +
											e.value +
											(e.modifiers && e.modifiers.prop ? ",true" : "") +
											")"
									);
							};
					},
					cloak: x
			};

	function ho(t, e) {
			var n = uo,
					r = (uo = []),
					i = lo;
			(lo = 0), (po = e), (io = e.warn || pi), (oo = fi(e.modules, "transformCode")), (ao = fi(e.modules, "genData")), (so = e.directives || {}), (co = e.isReservedTag || k);
			var o = t ? mo(t) : '_c("div")';
			return (uo = n), (lo = i), {
					render: "with(this){return " + o + "}",
					staticRenderFns: r
			};
	}

	function mo(t) {
			if (t.staticRoot && !t.staticProcessed) return vo(t);
			if (t.once && !t.onceProcessed) return go(t);
			if (t.for && !t.forProcessed)
					return (u = (c = t).for), (d = c.alias), (p = c.iterator1 ? "," + c.iterator1 : ""), (f = c.iterator2 ? "," + c.iterator2 : ""), (c.forProcessed = !0), "_l((" +
							u +
							"),function(" +
							d +
							p +
							f +
							"){return " +
							mo(c) +
							"})";
			if (t.if && !t.ifProcessed) return yo(t);
			if ("template" !== t.tag || t.slotTarget) {
					if ("slot" === t.tag)
							return (function(t) {
									var e = t.slotName || '"default"',
											n = wo(t),
											r = "_t(" + e + (n ? "," + n : ""),
											i =
											t.attrs &&
											"{" +
											t.attrs
											.map(function(t) {
													return l(t.name) + ":" + t.value;
											})
											.join(",") +
											"}",
											o = t.attrsMap["v-bind"];
									(!i && !o) || n || (r += ",null");
									i && (r += "," + i);
									o && (r += (i ? "" : ",null") + "," + o);
									return r + ")";
							})(t);
					var e;
					if (t.component)
							(o = t.component), (s = (a = t).inlineTemplate ? null : wo(a, !0)), (e =
									"_c(" + o + "," + bo(a) + (s ? "," + s : "") + ")");
					else {
							var n = t.plain ? void 0 : bo(t),
									r = t.inlineTemplate ? null : wo(t, !0);
							e =
									"_c('" + t.tag + "'" + (n ? "," + n : "") + (r ? "," + r : "") + ")";
					}
					for (var i = 0; i < oo.length; i++)
							e = oo[i](t, e);
					return e;
			}
			return wo(t) || "void 0";
			var o, a, s, c, u, d, p, f;
	}

	function vo(t) {
			return (t.staticProcessed = !0), uo.push("with(this){return " + mo(t) + "}"), "_m(" + (uo.length - 1) + (t.staticInFor ? ",true" : "") + ")";
	}

	function go(t) {
			if (((t.onceProcessed = !0), t.if && !t.ifProcessed)) return yo(t);
			if (t.staticInFor) {
					for (var e = "", n = t.parent; n;) {
							if (n.for) {
									e = n.key;
									break;
							}
							n = n.parent;
					}
					return e ? "_o(" + mo(t) + "," + lo++ + (e ? "," + e : "") + ")" : (io("v-once can only be used inside v-for that is keyed. "), mo(t));
			}
			return vo(t);
	}

	function yo(t) {
			return (t.ifProcessed = !0), (function t(e) {
					if (!e.length) return "_e()";
					var n = e.shift();
					return n.exp ? "(" + n.exp + ")?" + r(n.block) + ":" + t(e) : "" + r(n.block);

					function r(t) {
							return t.once ? go(t) : mo(t);
					}
			})(t.ifConditions.slice());
	}

	function bo(t) {
			var e,
					n = "{",
					r = (function(t) {
							var e = t.directives;
							if (!e) return;
							var n, r, i, o, a = "directives:[",
									s = !1;
							for ((n = 0), (r = e.length); n < r; n++) {
									(i = e[n]), (o = !0);
									var c = so[i.name] || fo[i.name];
									c && (o = !!c(t, i, io)), o &&
											((s = !0), (a +=
													'{name:"' +
													i.name +
													'",rawName:"' +
													i.rawName +
													'"' +
													(i.value ? ",value:(" +
															i.value +
															"),expression:" +
															JSON.stringify(i.value) : "") +
													(i.arg ? ',arg:"' + i.arg + '"' : "") +
													(i.modifiers ? ",modifiers:" + JSON.stringify(i.modifiers) : "") +
													"},"));
							}
							if (s) return a.slice(0, -1) + "]";
					})(t);
			r &&
					(n +=
							r +
							","), t.key && (n += "key:" + t.key + ","), t.ref && (n += "ref:" + t.ref + ","), t.refInFor && (n += "refInFor:true,"), t.pre && (n += "pre:true,"), t.component && (n += 'tag:"' + t.tag + '",');
			for (var i = 0; i < ao.length; i++) n += ao[i](t);
			if (
					(t.attrs && (n += "attrs:{" + So(t.attrs) + "},"), t.props &&
							(n += "domProps:{" + So(t.props) + "},"), t.events &&
							(n += eo(t.events) + ","), t.nativeEvents &&
							(n += eo(t.nativeEvents, !0) + ","), t.slotTarget &&
							(n += "slot:" + t.slotTarget + ","), t.scopedSlots &&
							(n += ((e = t.scopedSlots), "scopedSlots:{" +
									Object.keys(e)
									.map(function(t) {
											return (n = t), (r = e[t]), n + ":function(" + String(r.attrsMap.scope) + "){return " + ("template" === r.tag ? wo(r) || "void 0" : mo(r)) + "}";
											var n, r;
									})
									.join(",") +
									"},")), t.inlineTemplate)
			) {
					var o = (function(t) {
							var e = t.children[0];
							(t.children.length > 1 || 1 !== e.type) &&
							io("Inline-template components must have exactly one child element.");
							if (1 === e.type) {
									var n = ho(e, po);
									return (
											"inlineTemplate:{render:function(){" +
											n.render +
											"},staticRenderFns:[" +
											n.staticRenderFns
											.map(function(t) {
													return "function(){" + t + "}";
											})
											.join(",") +
											"]}"
									);
							}
					})(t);
					o && (n += o + ",");
			}
			return (n =
					n.replace(/,$/, "") + "}"), t.wrapData && (n = t.wrapData(n)), n;
	}

	function wo(t, e) {
			var n = t.children;
			if (n.length) {
					var r = n[0];
					if (1 === n.length && r.for && "template" !== r.tag && "slot" !== r.tag)
							return mo(r);
					var i = (function(t) {
							for (var e = 0, n = 0; n < t.length; n++) {
									var r = t[n];
									if (1 === r.type) {
											if (
													_o(r) ||
													(r.ifConditions &&
															r.ifConditions.some(function(t) {
																	return _o(t.block);
															}))
											) {
													e = 2;
													break;
											}
											(xo(r) ||
													(r.ifConditions &&
															r.ifConditions.some(function(t) {
																	return xo(t.block);
															}))) &&
											(e = 1);
									}
							}
							return e;
					})(n);
					return "[" + n.map(ko).join(",") + "]" + (e && i ? "," + i : "");
			}
	}

	function _o(t) {
			return void 0 !== t.for || "template" === t.tag || "slot" === t.tag;
	}

	function xo(t) {
			return !co(t.tag);
	}

	function ko(t) {
			return 1 === t.type ? mo(t) : "_v(" +
					(2 === (e = t).type ? e.expression : Co(JSON.stringify(e.text))) +
					")";
			var e;
	}

	function So(t) {
			for (var e = "", n = 0; n < t.length; n++) {
					var r = t[n];
					e += '"' + r.name + '":' + Co(r.value) + ",";
			}
			return e.slice(0, -1);
	}

	function Co(t) {
			return t.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
	}
	var To = new RegExp(
					"\\b" +
					"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments"
					.split(",")
					.join("\\b|\\b") +
					"\\b"
			),
			Eo = /[A-Za-z_$][\w$]*/,
			Ao = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

	function $o(t) {
			var e = [];
			return t &&
					(function t(e, n) {
							if (1 === e.type) {
									for (var r in e.attrsMap)
											if (Ni.test(r)) {
													var i = e.attrsMap[r];
													i &&
															("v-for" === r ? jo(e, 'v-for="' + i + '"', n) : No(i, r + '="' + i + '"', n));
											}
									if (e.children)
											for (var o = 0; o < e.children.length; o++)
													t(e.children[o], n);
							} else 2 === e.type && No(e.expression, e.text, n);
					})(t, e), e;
	}

	function jo(t, e, n) {
			No(
					t.for || "",
					e,
					n
			), Io(t.alias, "v-for alias", e, n), Io(t.iterator1, "v-for iterator", e, n), Io(t.iterator2, "v-for iterator", e, n);
	}

	function Io(t, e, n, r) {
			"string" != typeof t ||
					Eo.test(t) ||
					r.push("- invalid " + e + ' "' + t + '" in expression: ' + n);
	}

	function No(t, e, n) {
			try {
					new Function("return " + t);
			} catch (i) {
					var r = t.replace(Ao, "").match(To);
					r
							? n.push(
									'- avoid using JavaScript keyword as property name: "' +
									r[0] +
									'" in expression ' +
									e
							) : n.push("- invalid expression: " + e);
			}
	}
	var zo,
			Oo = [{
					staticKeys: ["staticClass"],
					transformNode: function(t, e) {
							var n = e.warn || pi,
									r = yi(t, "class");
							r &&
									di(r, e.delimiters) &&
									n(
											'class="' +
											r +
											'": Interpolation inside attributes has been removed. Use v-bind or the colon shorthand instead. For example, instead of <div class="{{ val }}">, use <div :class="val">.'
									), r && (t.staticClass = JSON.stringify(r));
							var i = gi(t, "class", !1);
							i && (t.classBinding = i);
					},
					genData: function(t) {
							var e = "";
							return t.staticClass &&
									(e += "staticClass:" + t.staticClass + ","), t.classBinding &&
									(e += "class:" + t.classBinding + ","), e;
					}
			}, {
					staticKeys: ["staticStyle"],
					transformNode: function(t, e) {
							var n = e.warn || pi,
									r = yi(t, "style");
							r &&
									(di(r, e.delimiters) &&
											n(
													'style="' +
													r +
													'": Interpolation inside attributes has been removed. Use v-bind or the colon shorthand instead. For example, instead of <div style="{{ val }}">, use <div :style="val">.'
											), (t.staticStyle = JSON.stringify(jn(r))));
							var i = gi(t, "style", !1);
							i && (t.styleBinding = i);
					},
					genData: function(t) {
							var e = "";
							return t.staticStyle &&
									(e += "staticStyle:" + t.staticStyle + ","), t.styleBinding &&
									(e += "style:(" + t.styleBinding + "),"), e;
					}
			}];

	function Lo(t) {
			return (
					1 === t.type &&
					"option" === t.tag &&
					null != t.attrsMap.selected &&
					(zo(
							'<select v-model="' +
							t.parent.attrsMap["v-model"] +
							"\">:\ninline selected attributes on <option> will be ignored when using v-model. Declare initial values in the component's data option instead."
					), !0)
			);
	}

	function Po(t, e) {
			var n = (function(t) {
					if (
							((ni = (ri = t).length), (oi = ai = si = 0), t.indexOf("[") < 0 ||
									t.lastIndexOf("]") < ni - 1)
					)
							return {
									exp: t,
									idx: null
							};
					for (; !wi();)
							_i((ii = bi())) ? ki(ii) : 91 === ii && xi(ii);
					return {
							exp: t.substring(0, ai),
							idx: t.substring(ai + 1, si)
					};
			})(t);
			return null === n.idx ? t + "=" + e : "var $$exp = " +
					n.exp +
					", $$idx = " +
					n.idx +
					";if (!Array.isArray($$exp)){" +
					t +
					"=" +
					e +
					"}else{$$exp.splice($$idx, 1, " +
					e +
					")}";
	}
	var Mo = {
					model: function(t, e, n) {
							zo = n;
							var r = e.value,
									i = e.modifiers,
									o = t.tag,
									a = t.attrsMap.type,
									s = t.attrsMap["v-bind:type"] || t.attrsMap[":type"];
							return "input" === o &&
									s &&
									zo(
											'<input :type="' +
											s +
											'" v-model="' +
											r +
											'">:\nv-model does not support dynamic input types. Use v-if branches instead.'
									), "select" === o ? (function(t, e, n) {
											t.children.some(Lo);
											var r =
													'Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return ' +
													(n && n.number ? "_n(val)" : "val") +
													"})" +
													(null == t.attrsMap.multiple ? "[0]" : ""),
													i = Po(e, r);
											vi(t, "change", i, null, !0);
									})(t, r, i) : "input" === o && "checkbox" === a ? (function(t, e, n) {
											null != t.attrsMap.checked &&
													zo(
															"<" +
															t.tag +
															' v-model="' +
															e +
															"\" checked>:\ninline checked attributes will be ignored when using v-model. Declare initial values in the component's data option instead."
													);
											var r = n && n.number,
													i = gi(t, "value") || "null",
													o = gi(t, "true-value") || "true",
													a = gi(t, "false-value") || "false";
											hi(
													t,
													"checked",
													"Array.isArray(" +
													e +
													")?_i(" +
													e +
													"," +
													i +
													")>-1" +
													("true" === o ? ":(" + e + ")" : ":_q(" + e + "," + o + ")")
											), vi(
													t,
													"click",
													"var $$a=" +
													e +
													",$$el=$event.target,$$c=$$el.checked?(" +
													o +
													"):(" +
													a +
													");if(Array.isArray($$a)){var $$v=" +
													(r ? "_n(" + i + ")" : i) +
													",$$i=_i($$a,$$v);if($$c){$$i<0&&(" +
													e +
													"=$$a.concat($$v))}else{$$i>-1&&(" +
													e +
													"=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{" +
													e +
													"=$$c}",
													null, !0
											);
									})(t, r, i) : "input" === o && "radio" === a ? (function(t, e, n) {
											null != t.attrsMap.checked &&
													zo(
															"<" +
															t.tag +
															' v-model="' +
															e +
															"\" checked>:\ninline checked attributes will be ignored when using v-model. Declare initial values in the component's data option instead."
													);
											var r = n && n.number,
													i = gi(t, "value") || "null";
											hi(
													t,
													"checked",
													"_q(" + e + "," + (i = r ? "_n(" + i + ")" : i) + ")"
											), vi(t, "click", Po(e, i), null, !0);
									})(t, r, i) : (function(t, e, n) {
											"input" === t.tag &&
													t.attrsMap.value &&
													zo(
															"<" +
															t.tag +
															' v-model="' +
															e +
															'" value="' +
															t.attrsMap.value +
															"\">:\ninline value attributes will be ignored when using v-model. Declare initial values in the component's data option instead."
													), "textarea" === t.tag &&
													t.children.length &&
													zo(
															'<textarea v-model="' +
															e +
															"\">:\ninline content inside <textarea> will be ignored when using v-model. Declare initial values in the component's data option instead."
													);
											var r = t.attrsMap.type,
													i = n || {},
													o = i.lazy,
													a = i.number,
													s = i.trim,
													c = o || (M && "range" === r) ? "change" : "input",
													u = !o && "range" !== r,
													l = "input" === t.tag || "textarea" === t.tag,
													d = l ? "$event.target.value" + (s ? ".trim()" : "") : s ? "(typeof $event === 'string' ? $event.trim() : $event)" : "$event",
													p = Po(
															e, (d = a || "number" === r ? "_n(" + d + ")" : d)
													);
											l &&
													u &&
													(p = "if($event.target.composing)return;" + p), "file" ===
													r &&
													zo(
															"<" +
															t.tag +
															' v-model="' +
															e +
															'" type="file">:\nFile inputs are read only. Use a v-on:change listener instead.'
													), hi(
															t,
															"value",
															l ? "_s(" + e + ")" : "(" + e + ")"
													), vi(t, c, p, null, !0), (s || a || "number" === r) &&
													vi(t, "blur", "$forceUpdate()");
									})(t, r, i), !0;
					},
					text: function(t, e) {
							e.value && hi(t, "textContent", "_s(" + e.value + ")");
					},
					html: function(t, e) {
							e.value && hi(t, "innerHTML", "_s(" + e.value + ")");
					}
			},
			Do = Object.create(null),
			qo = {
					expectHTML: !0,
					modules: Oo,
					staticKeys: C(Oo),
					directives: Mo,
					isReservedTag: Ke,
					isUnaryTag: Or,
					mustUseProp: De,
					getTagNamespace: Ze,
					isPreTag: function(t) {
							return "pre" === t;
					}
			};

	function Ro(t, e) {
			return (function(t, e) {
					var n = Ri(t.trim(), e);
					Gi(n, e);
					var r = ho(n, e);
					return {
							ast: n,
							render: r.render,
							staticRenderFns: r.staticRenderFns
					};
			})(t, (e = e ? v(v({}, qo), e) : qo));
	}

	function Fo(t, e, n) {
			var r = (e && e.warn) || Q;
			try {
					new Function("return 1");
			} catch (t) {
					t.toString().match(/unsafe-eval|CSP/) &&
							r(
									"It seems you are using the standalone build of Vue.js in an environment with Content Security Policy that prohibits unsafe-eval. The template compiler cannot work in this environment. Consider relaxing the policy to allow unsafe-eval or pre-compiling your templates into render functions."
							);
			}
			var i = e && e.delimiters ? String(e.delimiters) + t : t;
			if (Do[i]) return Do[i];
			var o = {},
					a = Ro(t, e);
			o.render = Wo(a.render);
			var s = a.staticRenderFns.length;
			o.staticRenderFns = new Array(s);
			for (var c = 0; c < s; c++) o.staticRenderFns[c] = Wo(a.staticRenderFns[c]);
			return (o.render === x ||
							o.staticRenderFns.some(function(t) {
									return t === x;
							})) &&
					r(
							"failed to compile template:\n\n" +
							t +
							"\n\n" +
							$o(a.ast).join("\n") +
							"\n\n",
							n
					), (Do[i] = o);
	}

	function Wo(t) {
			try {
					return new Function(t);
			} catch (t) {
					return x;
			}
	}
	var Ho = c(function(t) {
					var e = en(t);
					return e && e.innerHTML;
			}),
			Vo = Ee.prototype.$mount;
	return (Ee.prototype.$mount = function(t, e) {
			if ((t = t && en(t)) === document.body || t === document.documentElement)
					return Q(
							"Do not mount Vue to <html> or <body> - mount to normal elements instead."
					), this;
			var n = this.$options;
			if (!n.render) {
					var r = n.template;
					if (r)
							if ("string" == typeof r)
									"#" === r.charAt(0) &&
									((r = Ho(r)) ||
											Q("Template element not found or is empty: " + n.template, this));
							else {
									if (!r.nodeType) return Q("invalid template option:" + r, this), this;
									r = r.innerHTML;
							} else
							t &&
							(r = (function(t) {
									{
											if (t.outerHTML) return t.outerHTML;
											var e = document.createElement("div");
											return e.appendChild(t.cloneNode(!0)), e.innerHTML;
									}
							})(t));
					if (r) {
							var i = Fo(
											r, {
													warn: Q,
													shouldDecodeNewlines: zr,
													delimiters: n.delimiters
											},
											this
									),
									o = i.render,
									a = i.staticRenderFns;
							(n.render = o), (n.staticRenderFns = a);
					}
			}
			return Vo.call(this, t, e);
	}), (Ee.compile = Fo), Ee;
});

// Vuex 2.1.1
// https://cdnjs.cloudflare.com/ajax/libs/vuex/2.1.1/vuex.min.js

(function(t, e) {
	"object" == typeof exports && "undefined" != typeof module ? (module.exports = e()) : "function" == typeof define && define.amd ? define(e) : (t.Vuex = e());
})(this, function() {
	"use strict";
	var t = "undefined" != typeof window && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

	function e(e) {
			t &&
					((e._devtoolHook = t), t.emit(
							"vuex:init",
							e
					), t.on("vuex:travel-to-state", function(t) {
							e.replaceState(t);
					}), e.subscribe(function(e, n) {
							t.emit("vuex:mutation", e, n);
					}));
	}
	var n = s(function(t, e) {
					var n = {};
					return a(e).forEach(function(e) {
							var r = e.key,
									i = e.val;
							n[r] = function() {
									var e, n, r = this.$store.state,
											o = this.$store.getters;
									if (t) {
											var a = this.$store._modulesNamespaceMap[t];
											if (!a)
													return (e = "mapState"), (n = t), void console.error(
															"[vuex] module namespace not found in " + e + "(): " + n
													);
											(r = a.state), (o = a.context.getters);
									}
									return "function" == typeof i ? i.call(this, r, o) : r[i];
							};
					}), n;
			}),
			r = s(function(t, e) {
					var n = {};
					return a(e).forEach(function(e) {
							var r = e.key,
									i = e.val;
							(i = t + i), (n[r] = function() {
									for (var t = [], e = arguments.length; e--;)
											t[e] = arguments[e];
									return this.$store.commit.apply(this.$store, [i].concat(t));
							});
					}), n;
			}),
			i = s(function(t, e) {
					var n = {};
					return a(e).forEach(function(e) {
							var r = e.key,
									i = e.val;
							(i = t + i), (n[r] = function() {
									return i in this.$store.getters ||
											console.error("[vuex] unknown getter: " + i), this.$store.getters[
													i
											];
							});
					}), n;
			}),
			o = s(function(t, e) {
					var n = {};
					return a(e).forEach(function(e) {
							var r = e.key,
									i = e.val;
							(i = t + i), (n[r] = function() {
									for (var t = [], e = arguments.length; e--;)
											t[e] = arguments[e];
									return this.$store.dispatch.apply(this.$store, [i].concat(t));
							});
					}), n;
			});

	function a(t) {
			return Array.isArray(t) ? t.map(function(t) {
					return {
							key: t,
							val: t
					};
			}) : Object.keys(t).map(function(e) {
					return {
							key: e,
							val: t[e]
					};
			});
	}

	function s(t) {
			return function(e, n) {
					return "string" != typeof e ? ((n = e), (e = "")) : "/" !== e.charAt(e.length - 1) && (e += "/"), t(e, n);
			};
	}

	function c(t, e) {
			Object.keys(t).forEach(function(n) {
					return e(t[n], n);
			});
	}

	function u(t, e) {
			if (!t) throw new Error("[vuex] " + e);
	}
	var l = function(t, e) {
					(this.runtime = e), (this._children = Object.create(
							null
					)), (this._rawModule = t);
			},
			d = {
					state: {},
					namespaced: {}
			};
	(d.state.get = function() {
			return this._rawModule.state || {};
	}), (d.namespaced.get = function() {
			return !!this._rawModule.namespaced;
	}), (l.prototype.addChild = function(t, e) {
			this._children[t] = e;
	}), (l.prototype.removeChild = function(t) {
			delete this._children[t];
	}), (l.prototype.getChild = function(t) {
			return this._children[t];
	}), (l.prototype.update = function(t) {
			(this._rawModule.namespaced = t.namespaced), t.actions &&
					(this._rawModule.actions = t.actions), t.mutations &&
					(this._rawModule.mutations = t.mutations), t.getters &&
					(this._rawModule.getters = t.getters);
	}), (l.prototype.forEachChild = function(t) {
			c(this._children, t);
	}), (l.prototype.forEachGetter = function(t) {
			this._rawModule.getters && c(this._rawModule.getters, t);
	}), (l.prototype.forEachAction = function(t) {
			this._rawModule.actions && c(this._rawModule.actions, t);
	}), (l.prototype.forEachMutation = function(t) {
			this._rawModule.mutations && c(this._rawModule.mutations, t);
	}), Object.defineProperties(l.prototype, d);
	var p,
			f = function(t) {
					var e = this;
					(this.root = new l(t, !1)), t.modules &&
							c(t.modules, function(t, n) {
									e.register([n], t, !1);
							});
			};
	(f.prototype.get = function(t) {
			return t.reduce(function(t, e) {
					return t.getChild(e);
			}, this.root);
	}), (f.prototype.getNamespace = function(t) {
			var e = this.root;
			return t.reduce(function(t, n) {
					return t + ((e = e.getChild(n)).namespaced ? n + "/" : "");
			}, "");
	}), (f.prototype.update = function(t) {
			!(function t(e, n) {
					e.update(n);
					if (n.modules)
							for (var r in n.modules) {
									if (!e.getChild(r))
											return void console.warn(
													"[vuex] trying to add a new module '" +
													r +
													"' on hot reloading, manual reload is needed"
											);
									t(e.getChild(r), n.modules[r]);
							}
			})(this.root, t);
	}), (f.prototype.register = function(t, e, n) {
			var r = this;
			void 0 === n && (n = !0);
			var i = this.get(t.slice(0, -1)),
					o = new l(e, n);
			i.addChild(t[t.length - 1], o), e.modules &&
					c(e.modules, function(e, i) {
							r.register(t.concat(i), e, n);
					});
	}), (f.prototype.unregister = function(t) {
			var e = this.get(t.slice(0, -1)),
					n = t[t.length - 1];
			e.getChild(n).runtime && e.removeChild(n);
	});
	var h = function(t) {
					var n = this;
					void 0 === t && (t = {}), u(
							p,
							"must call Vue.use(Vuex) before creating a store instance."
					), u(
							"undefined" != typeof Promise,
							"vuex requires a Promise polyfill in this browser."
					);
					var r = t.state;
					void 0 === r && (r = {});
					var i = t.plugins;
					void 0 === i && (i = []);
					var o = t.strict;
					void 0 === o &&
							(o = !1), (this._committing = !1), (this._actions = Object.create(
									null
							)), (this._mutations = Object.create(
									null
							)), (this._wrappedGetters = Object.create(null)), (this._modules = new f(
									t
							)), (this._modulesNamespaceMap = Object.create(
									null
							)), (this._subscribers = []), (this._watcherVM = new p());
					var a = this,
							s = this.dispatch,
							c = this.commit;
					(this.dispatch = function(t, e) {
							return s.call(a, t, e);
					}), (this.commit = function(t, e, n) {
							return c.call(a, t, e, n);
					}), (this.strict = o), y(this, r, [], this._modules.root), g(
							this,
							r
					), i.concat(e).forEach(function(t) {
							return t(n);
					});
			},
			m = {
					state: {}
			};

	function v(t) {
			(t._actions = Object.create(
					null
			)), (t._mutations = Object.create(null)), (t._wrappedGetters = Object.create(null)), (t._modulesNamespaceMap = Object.create(null));
			var e = t.state;
			y(t, e, [], t._modules.root, !0), g(t, e);
	}

	function g(t, e) {
			var n = t._vm;
			t.getters = {};
			var r = {};
			c(t._wrappedGetters, function(e, n) {
					(r[n] = function() {
							return e(t);
					}), Object.defineProperty(t.getters, n, {
							get: function() {
									return t._vm[n];
							},
							enumerable: !0
					});
			});
			var i, o = p.config.silent;
			(p.config.silent = !0), (t._vm = new p({
					data: {
							state: e
					},
					computed: r
			})), (p.config.silent = o), t.strict &&
					(i = t)._vm.$watch(
							"state",
							function() {
									u(
											i._committing,
											"Do not mutate vuex store state outside mutation handlers."
									);
							}, {
									deep: !0,
									sync: !0
							}
					), n &&
					(t._withCommit(function() {
							n.state = null;
					}), p.nextTick(function() {
							return n.$destroy();
					}));
	}

	function y(t, e, n, r, i) {
			var o = !n.length,
					a = t._modules.getNamespace(n);
			if ((a && (t._modulesNamespaceMap[a] = r), !o && !i)) {
					var s = b(e, n.slice(0, -1)),
							c = n[n.length - 1];
					t._withCommit(function() {
							p.set(s, c, r.state);
					});
			}
			var u,
					l,
					d,
					f,
					h = (r.context = ((u = t), (f = {
							dispatch: (d = "" === (l = a)) ? u.dispatch : function(t, e, n) {
									var r = w(t, e, n),
											i = r.payload,
											o = r.options,
											a = r.type;
									if ((o && o.root) || ((a = l + a), u._actions[a]))
											return u.dispatch(a, i);
									console.error(
											"[vuex] unknown local action type: " +
											r.type +
											", global type: " +
											a
									);
							},
							commit: d ? u.commit : function(t, e, n) {
									var r = w(t, e, n),
											i = r.payload,
											o = r.options,
											a = r.type;
									(o && o.root) || ((a = l + a), u._mutations[a]) ? u.commit(a, i, o): console.error(
											"[vuex] unknown local mutation type: " +
											r.type +
											", global type: " +
											a
									);
							}
					}), Object.defineProperty(f, "getters", {
							get: d ? function() {
									return u.getters;
							} : function() {
									return (t = u), (n = {}), (r = (e = l).length), Object.keys(
											t.getters
									).forEach(function(i) {
											if (i.slice(0, r) === e) {
													var o = i.slice(r);
													Object.defineProperty(n, o, {
															get: function() {
																	return t.getters[i];
															},
															enumerable: !0
													});
											}
									}), n;
									var t, e, n, r;
							}
					}), f));
			r.forEachMutation(function(e, r) {
					var i, o, s, c;
					(o =
							a +
							r), (s = e), (c = n), ((i = t)._mutations[o] || (i._mutations[o] = [])).push(function(t) {
							s(b(i.state, c), t);
					});
			}), r.forEachAction(function(e, r) {
					var i, o, s, c, u;
					(o =
							a +
							r), (s = e), (c = h), (u = n), ((i = t)._actions[o] || (i._actions[o] = [])).push(function(t, e) {
							var n,
									r = s({
													dispatch: c.dispatch,
													commit: c.commit,
													getters: c.getters,
													state: b(i.state, u),
													rootGetters: i.getters,
													rootState: i.state
											},
											t,
											e
									);
							return ((n = r) && "function" == typeof n.then) ||
									(r = Promise.resolve(r)), i._devtoolHook ? r.catch(function(t) {
											throw (i._devtoolHook.emit("vuex:error", t), t);
									}) : r;
					});
			}), r.forEachGetter(function(e, r) {
					!(function(t, e, n, r, i) {
							if (t._wrappedGetters[e])
									return void console.error("[vuex] duplicate getter key: " + e);
							t._wrappedGetters[e] = function(t) {
									return n(b(t.state, i), r.getters, t.state, t.getters);
							};
					})(t, a + r, e, h, n);
			}), r.forEachChild(function(r, o) {
					y(t, e, n.concat(o), r, i);
			});
	}

	function b(t, e) {
			return e.length ? e.reduce(function(t, e) {
					return t[e];
			}, t) : t;
	}

	function w(t, e, n) {
			var r;
			return null !== (r = t) &&
					"object" == typeof r &&
					t.type &&
					((n = e), (e = t), (t = t.type)), {
							type: t,
							payload: e,
							options: n
					};
	}

	function _(t) {
			p
					? console.error(
							"[vuex] already installed. Vue.use(Vuex) should be called only once."
					) : (function(t) {
							if (Number(t.version.split(".")[0]) >= 2) {
									var e = t.config._lifecycleHooks.indexOf("init") > -1;
									t.mixin(e ? {
											init: r
									} : {
											beforeCreate: r
									});
							} else {
									var n = t.prototype._init;
									t.prototype._init = function(t) {
											void 0 === t && (t = {}), (t.init = t.init ? [r].concat(t.init) : r), n.call(this, t);
									};
							}

							function r() {
									var t = this.$options;
									t.store ? (this.$store = t.store) : t.parent && t.parent.$store && (this.$store = t.parent.$store);
							}
					})((p = t));
	}
	return (m.state.get = function() {
			return this._vm.$data.state;
	}), (m.state.set = function(t) {
			u(!1, "Use store.replaceState() to explicit replace store state.");
	}), (h.prototype.commit = function(t, e, n) {
			var r = this,
					i = w(t, e, n),
					o = i.type,
					a = i.payload,
					s = i.options,
					c = {
							type: o,
							payload: a
					},
					u = this._mutations[o];
			u
					? (this._withCommit(function() {
									u.forEach(function(t) {
											t(a);
									});
							}), this._subscribers.forEach(function(t) {
									return t(c, r.state);
							}), s &&
							s.silent &&
							console.warn(
									"[vuex] mutation type: " +
									o +
									". Silent option has been removed. Use the filter functionality in the vue-devtools"
							)) : console.error("[vuex] unknown mutation type: " + o);
	}), (h.prototype.dispatch = function(t, e) {
			var n = w(t, e),
					r = n.type,
					i = n.payload,
					o = this._actions[r];
			if (o)
					return o.length > 1 ? Promise.all(
							o.map(function(t) {
									return t(i);
							})
					) : o[0](i);
			console.error("[vuex] unknown action type: " + r);
	}), (h.prototype.subscribe = function(t) {
			var e = this._subscribers;
			return e.indexOf(t) < 0 && e.push(t),
					function() {
							var n = e.indexOf(t);
							n > -1 && e.splice(n, 1);
					};
	}), (h.prototype.watch = function(t, e, n) {
			var r = this;
			return u(
					"function" == typeof t,
					"store.watch only accepts a function."
			), this._watcherVM.$watch(
					function() {
							return t(r.state, r.getters);
					},
					e,
					n
			);
	}), (h.prototype.replaceState = function(t) {
			var e = this;
			this._withCommit(function() {
					e._vm.state = t;
			});
	}), (h.prototype.registerModule = function(t, e) {
			"string" == typeof t && (t = [t]), u(
					Array.isArray(t),
					"module path must be a string or an Array."
			), this._modules.register(t, e), y(
					this,
					this.state,
					t,
					this._modules.get(t)
			), g(this, this.state);
	}), (h.prototype.unregisterModule = function(t) {
			var e = this;
			"string" == typeof t && (t = [t]), u(
					Array.isArray(t),
					"module path must be a string or an Array."
			), this._modules.unregister(t), this._withCommit(function() {
					var n = b(e.state, t.slice(0, -1));
					p.delete(n, t[t.length - 1]);
			}), v(this);
	}), (h.prototype.hotUpdate = function(t) {
			this._modules.update(t), v(this);
	}), (h.prototype._withCommit = function(t) {
			var e = this._committing;
			(this._committing = !0), t(), (this._committing = e);
	}), Object.defineProperties(h.prototype, m), "undefined" != typeof window && window.Vue && _(window.Vue), {
			Store: h,
			install: _,
			version: "2.1.1",
			mapState: n,
			mapMutations: r,
			mapGetters: i,
			mapActions: o
	};
});

// original code, possibly written by developers before Diff

((RC = RC || {}).floatingLabels = (function(t, e) {
	return {
			floatMyLabels: function(t) {
					for (var n = [].concat(t).length, r = 0; r < n; r++)
							e(t).on("blur change", function() {
									e(this).val().length > 0 ? e(this).addClass("filled") : e(this).removeClass("filled");
							});
			}
	};
})(0, jQuery));


/*!
* clipboard.js v2.0.4
* https://zenorocha.github.io/clipboard.js
* 
* Licensed MIT © Zeno Rocha
*/

(function(t) {
	if ("object" == typeof exports && "undefined" != typeof module)
			module.exports = t();
	else if ("function" == typeof define && define.amd) define([], t);
	else {
			("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).Clipboard = t();
	}
})(function() {
	return (function t(e, n, r) {
			function i(a, s) {
					if (!n[a]) {
							if (!e[a]) {
									var c = "function" == typeof require && require;
									if (!s && c) return c(a, !0);
									if (o) return o(a, !0);
									var u = new Error("Cannot find module '" + a + "'");
									throw ((u.code = "MODULE_NOT_FOUND"), u);
							}
							var l = (n[a] = {
									exports: {}
							});
							e[a][0].call(
									l.exports,
									function(t) {
											var n = e[a][1][t];
											return i(n || t);
									},
									l,
									l.exports,
									t,
									e,
									n,
									r
							);
					}
					return n[a].exports;
			}
			for (
					var o = "function" == typeof require && require, a = 0; a < r.length; a++
			) i(r[a]);
			return i;
	})({
			1: [
					function(t, e, n) {
							var r = 9;
							if (Element && !Element.prototype.matches) {
									var i = Element.prototype;
									i.matches =
											i.matchesSelector ||
											i.mozMatchesSelector ||
											i.msMatchesSelector ||
											i.oMatchesSelector ||
											i.webkitMatchesSelector;
							}
							e.exports = function(t, e) {
									for (; t && t.nodeType !== r;) {
											if (t.matches(e)) return t;
											t = t.parentNode;
									}
							};
					}, {}
			],
			2: [
					function(t, e, n) {
							var r = t("./closest");
							e.exports = function(t, e, n, i, o) {
									var a = function(t, e, n, i) {
											return function(n) {
													(n.delegateTarget = r(n.target, e)), n.delegateTarget &&
															i.call(t, n);
											};
									}.apply(this, arguments);
									return t.addEventListener(n, a, o), {
											destroy: function() {
													t.removeEventListener(n, a, o);
											}
									};
							};
					}, {
							"./closest": 1
					}
			],
			3: [
					function(t, e, n) {
							(n.node = function(t) {
									return void 0 !== t && t instanceof HTMLElement && 1 === t.nodeType;
							}), (n.nodeList = function(t) {
									var e = Object.prototype.toString.call(t);
									return (
											void 0 !== t &&
											("[object NodeList]" === e || "[object HTMLCollection]" === e) &&
											"length" in t &&
											(0 === t.length || n.node(t[0]))
									);
							}), (n.string = function(t) {
									return "string" == typeof t || t instanceof String;
							}), (n.fn = function(t) {
									return "[object Function]" === Object.prototype.toString.call(t);
							});
					}, {}
			],
			4: [
					function(t, e, n) {
							var r = t("./is"),
									i = t("delegate");
							e.exports = function(t, e, n) {
									if (!t && !e && !n) throw new Error("Missing required arguments");
									if (!r.string(e))
											throw new TypeError("Second argument must be a String");
									if (!r.fn(n))
											throw new TypeError("Third argument must be a Function");
									if (r.node(t))
											return (o = t), (a = e), (s = n), o.addEventListener(a, s), {
													destroy: function() {
															o.removeEventListener(a, s);
													}
											};
									var o, a, s, c, u, l, d, p, f;
									if (r.nodeList(t))
											return (c = t), (u = e), (l = n), Array.prototype.forEach.call(
													c,
													function(t) {
															t.addEventListener(u, l);
													}
											), {
													destroy: function() {
															Array.prototype.forEach.call(c, function(t) {
																	t.removeEventListener(u, l);
															});
													}
											};
									if (r.string(t))
											return (d = t), (p = e), (f = n), i(document.body, d, p, f);
									throw new TypeError(
											"First argument must be a String, HTMLElement, HTMLCollection, or NodeList"
									);
							};
					}, {
							"./is": 3,
							delegate: 2
					}
			],
			5: [
					function(t, e, n) {
							e.exports = function(t) {
									var e;
									if ("SELECT" === t.nodeName) t.focus(), (e = t.value);
									else if ("INPUT" === t.nodeName || "TEXTAREA" === t.nodeName)
											t.focus(), t.setSelectionRange(0, t.value.length), (e = t.value);
									else {
											t.hasAttribute("contenteditable") && t.focus();
											var n = window.getSelection(),
													r = document.createRange();
											r.selectNodeContents(t), n.removeAllRanges(), n.addRange(
													r
											), (e = n.toString());
									}
									return e;
							};
					}, {}
			],
			6: [
					function(t, e, n) {
							function r() {}
							(r.prototype = {
									on: function(t, e, n) {
											var r = this.e || (this.e = {});
											return (r[t] || (r[t] = [])).push({
													fn: e,
													ctx: n
											}), this;
									},
									once: function(t, e, n) {
											function r() {
													i.off(t, r), e.apply(n, arguments);
											}
											var i = this;
											return (r._ = e), this.on(t, r, n);
									},
									emit: function(t) {
											for (
													var e = [].slice.call(arguments, 1),
															n = ((this.e || (this.e = {}))[t] || []).slice(),
															r = 0,
															i = n.length; r < i; r++
											)
													n[r].fn.apply(n[r].ctx, e);
											return this;
									},
									off: function(t, e) {
											var n = this.e || (this.e = {}),
													r = n[t],
													i = [];
											if (r && e)
													for (var o = 0, a = r.length; o < a; o++)
															r[o].fn !== e && r[o].fn._ !== e && i.push(r[o]);
											return i.length ? (n[t] = i) : delete n[t], this;
									}
							}), (e.exports = r);
					}, {}
			],
			7: [
					function(t, e, n) {
							!(function(r, i) {
									if (void 0 !== n) i(e, t("select"));
									else {
											var o = {
													exports: {}
											};
											i(o, r.select), (r.clipboardAction = o.exports);
									}
							})(this, function(t, e) {
									"use strict";
									var n,
											r = (n = e) && n.__esModule ? n : {
													default: n
											},
											i = "function" == typeof Symbol &&
											"symbol" == typeof Symbol.iterator ? function(t) {
													return typeof t;
											} : function(t) {
													return t &&
															"function" == typeof Symbol &&
															t.constructor === Symbol &&
															t !== Symbol.prototype ? "symbol" : typeof t;
											},
											o = (function() {
													function t(t, e) {
															for (var n = 0; n < e.length; n++) {
																	var r = e[n];
																	(r.enumerable =
																			r.enumerable || !1), (r.configurable = !0), "value" in
																	r && (r.writable = !0), Object.defineProperty(
																			t,
																			r.key,
																			r
																	);
															}
													}
													return function(e, n, r) {
															return n && t(e.prototype, n), r && t(e, r), e;
													};
											})(),
											a = (function() {
													function t(e) {
															(function(t, e) {
																	if (!(t instanceof e))
																			throw new TypeError("Cannot call a class as a function");
															})(this, t), this.resolveOptions(e), this.initSelection();
													}
													return o(t, [{
															key: "resolveOptions",
															value: function() {
																	var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
																	(this.action = t.action), (this.emitter =
																			t.emitter), (this.target = t.target), (this.text =
																			t.text), (this.trigger =
																			t.trigger), (this.selectedText = "");
															}
													}, {
															key: "initSelection",
															value: function() {
																	this.text ? this.selectFake() : this.target && this.selectTarget();
															}
													}, {
															key: "selectFake",
															value: function() {
																	var t = this,
																			e =
																			"rtl" == document.documentElement.getAttribute("dir");
																	this.removeFake(), (this.fakeHandlerCallback = function() {
																			return t.removeFake();
																	}), (this.fakeHandler =
																			document.body.addEventListener(
																					"click",
																					this.fakeHandlerCallback
																			) || !0), (this.fakeElem = document.createElement(
																			"textarea"
																	)), (this.fakeElem.style.fontSize =
																			"12pt"), (this.fakeElem.style.border =
																			"0"), (this.fakeElem.style.padding =
																			"0"), (this.fakeElem.style.margin =
																			"0"), (this.fakeElem.style.position =
																			"absolute"), (this.fakeElem.style[
																					e ? "right" : "left"
																			] =
																			"-9999px");
																	var n =
																			window.pageYOffset ||
																			document.documentElement.scrollTop;
																	this.fakeElem.addEventListener(
																			"focus",
																			window.scrollTo(0, n)
																	), (this.fakeElem.style.top =
																			n + "px"), this.fakeElem.setAttribute(
																			"readonly",
																			""
																	), (this.fakeElem.value = this.text), document.body.appendChild(
																			this.fakeElem
																	), (this.selectedText = (0, r.default)(
																			this.fakeElem
																	)), this.copyText();
															}
													}, {
															key: "removeFake",
															value: function() {
																	this.fakeHandler &&
																			(document.body.removeEventListener(
																					"click",
																					this.fakeHandlerCallback
																			), (this.fakeHandler = null), (this.fakeHandlerCallback = null)), this
																			.fakeElem &&
																			(document.body.removeChild(
																					this.fakeElem
																			), (this.fakeElem = null));
															}
													}, {
															key: "selectTarget",
															value: function() {
																	(this.selectedText = (0, r.default)(
																			this.target
																	)), this.copyText();
															}
													}, {
															key: "copyText",
															value: function() {
																	var t = void 0;
																	try {
																			t = document.execCommand(this.action);
																	} catch (e) {
																			t = !1;
																	}
																	this.handleResult(t);
															}
													}, {
															key: "handleResult",
															value: function(t) {
																	this.emitter.emit(t ? "success" : "error", {
																			action: this.action,
																			text: this.selectedText,
																			trigger: this.trigger,
																			clearSelection: this.clearSelection.bind(this)
																	});
															}
													}, {
															key: "clearSelection",
															value: function() {
																	this.target &&
																			this.target.blur(), window
																			.getSelection()
																			.removeAllRanges();
															}
													}, {
															key: "destroy",
															value: function() {
																	this.removeFake();
															}
													}, {
															key: "action",
															set: function() {
																	var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "copy";
																	if (
																			((this._action = t), "copy" !== this._action &&
																					"cut" !== this._action)
																	)
																			throw new Error(
																					'Invalid "action" value, use either "copy" or "cut"'
																			);
															},
															get: function() {
																	return this._action;
															}
													}, {
															key: "target",
															set: function(t) {
																	if (void 0 !== t) {
																			if (!t ||
																					"object" !== (void 0 === t ? "undefined" : i(t)) ||
																					1 !== t.nodeType
																			)
																					throw new Error(
																							'Invalid "target" value, use a valid Element'
																					);
																			if (
																					"copy" === this.action &&
																					t.hasAttribute("disabled")
																			)
																					throw new Error(
																							'Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute'
																					);
																			if (
																					"cut" === this.action &&
																					(t.hasAttribute("readonly") ||
																							t.hasAttribute("disabled"))
																			)
																					throw new Error(
																							'Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes'
																					);
																			this._target = t;
																	}
															},
															get: function() {
																	return this._target;
															}
													}]), t;
											})();
									t.exports = a;
							});
					}, {
							select: 5
					}
			],
			8: [
					function(t, e, n) {
							!(function(r, i) {
									if (void 0 !== n)
											i(
													e,
													t("./clipboard-action"),
													t("tiny-emitter"),
													t("good-listener")
											);
									else {
											var o = {
													exports: {}
											};
											i(
													o,
													r.clipboardAction,
													r.tinyEmitter,
													r.goodListener
											), (r.clipboard = o.exports);
									}
							})(this, function(t, e, n, r) {
									"use strict";

									function i(t) {
											return t && t.__esModule ? t : {
													default: t
											};
									}

									function o(t, e) {
											var n = "data-clipboard-" + t;
											if (e.hasAttribute(n)) return e.getAttribute(n);
									}
									var a = i(e),
											s = i(n),
											c = i(r),
											u = (function() {
													function t(t, e) {
															for (var n = 0; n < e.length; n++) {
																	var r = e[n];
																	(r.enumerable =
																			r.enumerable || !1), (r.configurable = !0), "value" in
																	r && (r.writable = !0), Object.defineProperty(
																			t,
																			r.key,
																			r
																	);
															}
													}
													return function(e, n, r) {
															return n && t(e.prototype, n), r && t(e, r), e;
													};
											})(),
											l = (function(t) {
													function e(t, n) {
															!(function(t, e) {
																	if (!(t instanceof e))
																			throw new TypeError("Cannot call a class as a function");
															})(this, e);
															var r = (function(t, e) {
																	if (!t)
																			throw new ReferenceError(
																					"this hasn't been initialised - super() hasn't been called"
																			);
																	return !e ||
																			("object" != typeof e && "function" != typeof e) ? t : e;
															})(
																	this, (e.__proto__ || Object.getPrototypeOf(e)).call(this)
															);
															return r.resolveOptions(n), r.listenClick(t), r;
													}
													return (function(t, e) {
															if ("function" != typeof e && null !== e)
																	throw new TypeError(
																			"Super expression must either be null or a function, not " +
																			typeof e
																	);
															(t.prototype = Object.create(e && e.prototype, {
																	constructor: {
																			value: t,
																			enumerable: !1,
																			writable: !0,
																			configurable: !0
																	}
															})), e &&
																	(Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : (t.__proto__ = e));
													})(e, s.default), u(e, [{
															key: "resolveOptions",
															value: function() {
																	var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
																	(this.action = "function" == typeof t.action ? t.action : this.defaultAction), (this.target = "function" ==
																			typeof t.target ? t.target : this.defaultTarget), (this.text = "function" ==
																			typeof t.text ? t.text : this.defaultText);
															}
													}, {
															key: "listenClick",
															value: function(t) {
																	var e = this;
																	this.listener = (0, c.default)(t, "click", function(t) {
																			return e.onClick(t);
																	});
															}
													}, {
															key: "onClick",
															value: function(t) {
																	var e = t.delegateTarget || t.currentTarget;
																	this.clipboardAction &&
																			(this.clipboardAction = null), (this.clipboardAction = new a.default({
																					action: this.action(e),
																					target: this.target(e),
																					text: this.text(e),
																					trigger: e,
																					emitter: this
																			}));
															}
													}, {
															key: "defaultAction",
															value: function(t) {
																	return o("action", t);
															}
													}, {
															key: "defaultTarget",
															value: function(t) {
																	var e = o("target", t);
																	if (e) return document.querySelector(e);
															}
													}, {
															key: "defaultText",
															value: function(t) {
																	return o("text", t);
															}
													}, {
															key: "destroy",
															value: function() {
																	this.listener.destroy(), this.clipboardAction &&
																			(this.clipboardAction.destroy(), (this.clipboardAction = null));
															}
													}]), e;
											})();
									t.exports = l;
							});
					}, {
							"./clipboard-action": 7,
							"good-listener": 4,
							"tiny-emitter": 6
					}
			]
	}, {}, [8])(8);
}), 

// es6 promise
// https://cdn.jsdelivr.net/npm/es6-promise/dist/es6-promise.min.js
(function(t, e) {
	"object" == typeof exports && "undefined" != typeof module ? (module.exports = e()) : "function" == typeof define && define.amd ? define(e) : (t.ES6Promise = e());
})(this, function() {
	"use strict";

	function t(t) {
			return "function" == typeof t;
	}

	function e() {
			var t = setTimeout;
			return function() {
					return t(n, 1);
			};
	}

	function n() {
			for (var t = 0; t < S; t += 2) {
					(0, z[t])(z[t + 1]), (z[t] = void 0), (z[t + 1] = void 0);
			}
			S = 0;
	}

	function r(t, e) {
			var n = arguments,
					r = this,
					i = new this.constructor(o);
			void 0 === i[L] && v(i);
			var a, s = r._state;
			return s ? ((a = n[s - 1]), E(function() {
					return m(s, i, a, r._result);
			})) : p(r, i, t, e), i;
	}

	function i(t) {
			if (t && "object" == typeof t && t.constructor === this) return t;
			var e = new this(o);
			return c(e, t), e;
	}

	function o() {}

	function a(t) {
			try {
					return t.then;
			} catch (t) {
					return (q.error = t), q;
			}
	}

	function s(e, n, o) {
			var a, s, u, f;
			n.constructor === e.constructor && o === r && n.constructor.resolve === i ? ((u = e), (f = n)._state === M ? l(u, f._result) : f._state === D ? d(u, f._result) : p(
					f,
					void 0,
					function(t) {
							return c(u, t);
					},
					function(t) {
							return d(u, t);
					}
			)) : o === q ? d(e, q.error) : void 0 === o ? l(e, n) : t(o) ? ((a = n), (s = o), E(function(t) {
					var e = !1,
							n = (function(t, e, n, r) {
									try {
											t.call(e, n, r);
									} catch (t) {
											return t;
									}
							})(
									s,
									a,
									function(n) {
											e || ((e = !0), a !== n ? c(t, n) : l(t, n));
									},
									function(n) {
											e || ((e = !0), d(t, n));
									},
									t._label
							);
					!e && n && ((e = !0), d(t, n));
			}, e)) : l(e, n);
	}

	function c(t, e) {
			var n;
			t === e ? d(t, new TypeError("You cannot resolve a promise with itself")) : "function" == typeof(n = e) || ("object" == typeof n && null !== n) ? s(t, e, a(e)) : l(t, e);
	}

	function u(t) {
			t._onerror && t._onerror(t._result), f(t);
	}

	function l(t, e) {
			t._state === P &&
					((t._result = e), (t._state = M), 0 !== t._subscribers.length && E(f, t));
	}

	function d(t, e) {
			t._state === P && ((t._state = D), (t._result = e), E(u, t));
	}

	function p(t, e, n, r) {
			var i = t._subscribers,
					o = i.length;
			(t._onerror = null), (i[o] = e), (i[o + M] = n), (i[o + D] = r), 0 === o && t._state && E(f, t);
	}

	function f(t) {
			var e = t._subscribers,
					n = t._state;
			if (0 !== e.length) {
					for (
							var r = void 0, i = void 0, o = t._result, a = 0; a < e.length; a += 3
					)
							(r = e[a]), (i = e[a + n]), r ? m(n, r, i, o) : i(o);
					t._subscribers.length = 0;
			}
	}

	function h() {
			this.error = null;
	}

	function m(e, n, r, i) {
			var o = t(r),
					a = void 0,
					s = void 0,
					u = void 0,
					p = void 0;
			if (o) {
					if (
							((a = (function(t, e) {
									try {
											return t(e);
									} catch (t) {
											return (R.error = t), R;
									}
							})(r, i)) === R ? ((p = !0), (s = a.error), (a = null)) : (u = !0), n === a)
					)
							return void d(
									n,
									new TypeError("A promises callback cannot return that same promise.")
							);
			} else(a = i), (u = !0);
			n._state !== P ||
					(o && u ? c(n, a) : p ? d(n, s) : e === M ? l(n, a) : e === D && d(n, a));
	}

	function v(t) {
			(t[
					L
			] = F++), (t._state = void 0), (t._result = void 0), (t._subscribers = []);
	}

	function g(t, e) {
			(this._instanceConstructor = t), (this.promise = new t(o)), this.promise[L] || v(this.promise), k(e) ? ((this._input = e), (this.length = e.length), (this._remaining = e.length), (this._result = new Array(this.length)), 0 === this.length ? l(this.promise, this._result) : ((this.length = this.length || 0), this._enumerate(), 0 === this._remaining && l(this.promise, this._result))) : d(this.promise, new Error("Array Methods must be provided an Array"));
	}

	function y(t) {
			(this[
					L
			] = F++), (this._result = this._state = void 0), (this._subscribers = []), o !==
					t &&
					("function" != typeof t &&
							(function() {
									throw new TypeError(
											"You must pass a resolver function as the first argument to the promise constructor"
									);
							})(), this instanceof y ? (function(t, e) {
									try {
											e(
													function(e) {
															c(t, e);
													},
													function(e) {
															d(t, e);
													}
											);
									} catch (e) {
											d(t, e);
									}
							})(this, t) : (function() {
									throw new TypeError(
											"Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function."
									);
							})());
	}
	var b,
			w,
			_,
			x,
			k = Array.isArray ? Array.isArray : function(t) {
					return "[object Array]" === Object.prototype.toString.call(t);
			},
			S = 0,
			C = void 0,
			T = void 0,
			E = function(t, e) {
					(z[S] = t), (z[S + 1] = e), 2 === (S += 2) && (T ? T(n) : O());
			},
			A = "undefined" != typeof window ? window : void 0,
			$ = A || {},
			j = $.MutationObserver || $.WebKitMutationObserver,
			I =
			"undefined" == typeof self &&
			"undefined" != typeof process &&
			"[object process]" === {}.toString.call(process),
			N =
			"undefined" != typeof Uint8ClampedArray &&
			"undefined" != typeof importScripts &&
			"undefined" != typeof MessageChannel,
			z = new Array(1e3),
			O = void 0;
	O = I ? function() {
			return process.nextTick(n);
	} : j ? ((w = 0), (_ = new j(n)), (x = document.createTextNode(
			""
	)), _.observe(x, {
			characterData: !0
	}), function() {
			x.data = w = ++w % 2;
	}) : N ? (((b = new MessageChannel()).port1.onmessage = n), function() {
			return b.port2.postMessage(0);
	}) : void 0 === A && "function" == typeof require ? (function() {
			try {
					var t = require("vertx");
					return void 0 !== (C = t.runOnLoop || t.runOnContext) ? function() {
							C(n);
					} : e();
			} catch (t) {
					return e();
			}
	})() : e();
	var L = Math.random().toString(36).substring(16),
			P = void 0,
			M = 1,
			D = 2,
			q = new h(),
			R = new h(),
			F = 0;
	return (g.prototype._enumerate = function() {
			for (
					var t = this.length, e = this._input, n = 0; this._state === P && n < t; n++
			)
					this._eachEntry(e[n], n);
	}), (g.prototype._eachEntry = function(t, e) {
			var n = this._instanceConstructor,
					c = n.resolve;
			if (c === i) {
					var u = a(t);
					if (u === r && t._state !== P) this._settledAt(t._state, e, t._result);
					else if ("function" != typeof u) this._remaining--, (this._result[e] = t);
					else if (n === y) {
							var l = new n(o);
							s(l, t, u), this._willSettleAt(l, e);
					} else
							this._willSettleAt(
									new n(function(e) {
											return e(t);
									}),
									e
							);
			} else this._willSettleAt(c(t), e);
	}), (g.prototype._settledAt = function(t, e, n) {
			var r = this.promise;
			r._state === P &&
					(this._remaining--, t === D ? d(r, n) : (this._result[e] = n)), 0 ===
					this._remaining && l(r, this._result);
	}), (g.prototype._willSettleAt = function(t, e) {
			var n = this;
			p(
					t,
					void 0,
					function(t) {
							return n._settledAt(M, e, t);
					},
					function(t) {
							return n._settledAt(D, e, t);
					}
			);
	}), (y.all = function(t) {
			return new g(this, t).promise;
	}), (y.race = function(t) {
			var e = this;
			return new e(
					k(t) ? function(n, r) {
							for (var i = t.length, o = 0; o < i; o++)
									e.resolve(t[o]).then(n, r);
					} : function(t, e) {
							return e(new TypeError("You must pass an array to race."));
					}
			);
	}), (y.resolve = i), (y.reject = function(t) {
			var e = new this(o);
			return d(e, t), e;
	}), (y._setScheduler = function(t) {
			T = t;
	}), (y._setAsap = function(t) {
			E = t;
	}), (y._asap = E), (y.prototype = {
			constructor: y,
			then: r,
			catch: function(t) {
					return this.then(null, t);
			}
	}), (y.polyfill = function() {
			var t = void 0;
			if ("undefined" != typeof global) t = global;
			else if ("undefined" != typeof self) t = self;
			else
					try {
							t = Function("return this")();
					} catch (t) {
							throw new Error(
									"polyfill failed because global object is unavailable in this environment"
							);
					}
			var e = t.Promise;
			if (e) {
					var n = null;
					try {
							n = Object.prototype.toString.call(e.resolve());
					} catch (t) {}
					if ("[object Promise]" === n && !e.cast) return;
			}
			t.Promise = y;
	}), (y.Promise = y), y;
});

// call ES6Promise.polyfill
ES6Promise.polyfill(); 

// Hammer.JS v.2.0.8
// https://hammerjs.github.io/dist/hammer.min.js

(function(t, e, n, r) {
			"use strict";

			function i(t, e, n) {
					return setTimeout(u(t, n), e);
			}

			function o(t, e, n) {
					return !!Array.isArray(t) && (a(t, n[e], n), !0);
			}

			function a(t, e, n) {
					var i;
					if (t)
							if (t.forEach) t.forEach(e, n);
							else if (t.length !== r)
							for (i = 0; i < t.length;)
									e.call(n, t[i], i, t), i++;
					else
							for (i in t) t.hasOwnProperty(i) && e.call(n, t[i], i, t);
			}

			function s(e, n, r) {
					var i = "DEPRECATED METHOD: " + n + "\n" + r + " AT \n";
					return function() {
							var n = new Error("get-stack-trace"),
									r = n && n.stack ? n.stack
									.replace(/^[^\(]+?[\n$]/gm, "")
									.replace(/^\s+at\s+/gm, "")
									.replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace",
									o = t.console && (t.console.warn || t.console.log);
							return o && o.call(t.console, i, r), e.apply(this, arguments);
					};
			}

			function c(t, e, n) {
					var r, i = e.prototype;
					((r = t.prototype = Object.create(i)).constructor = t), (r._super = i), n &&
							Y(r, n);
			}

			function u(t, e) {
					return function() {
							return t.apply(e, arguments);
					};
			}

			function l(t, e) {
					return typeof t == tt ? t.apply((e && e[0]) || r, e) : t;
			}

			function d(t, e) {
					return t === r ? e : t;
			}

			function p(t, e, n) {
					a(v(e), function(e) {
							t.addEventListener(e, n, !1);
					});
			}

			function f(t, e, n) {
					a(v(e), function(e) {
							t.removeEventListener(e, n, !1);
					});
			}

			function h(t, e) {
					for (; t;) {
							if (t == e) return !0;
							t = t.parentNode;
					}
					return !1;
			}

			function m(t, e) {
					return t.indexOf(e) > -1;
			}

			function v(t) {
					return t.trim().split(/\s+/g);
			}

			function g(t, e, n) {
					if (t.indexOf && !n) return t.indexOf(e);
					for (var r = 0; r < t.length;) {
							if ((n && t[r][n] == e) || (!n && t[r] === e)) return r;
							r++;
					}
					return -1;
			}

			function y(t) {
					return Array.prototype.slice.call(t, 0);
			}

			function b(t, e, n) {
					for (var r = [], i = [], o = 0; o < t.length;) {
							var a = e ? t[o][e] : t[o];
							g(i, a) < 0 && r.push(t[o]), (i[o] = a), o++;
					}
					return n &&
							(r = e ? r.sort(function(t, n) {
									return t[e] > n[e];
							}) : r.sort()), r;
			}

			function w(t, e) {
					for (var n, i, o = e[0].toUpperCase() + e.slice(1), a = 0; a < K.length;) {
							if ((i = (n = K[a]) ? n + o : e) in t) return i;
							a++;
					}
					return r;
			}

			function _(e) {
					var n = e.ownerDocument || e;
					return n.defaultView || n.parentWindow || t;
			}

			function x(t, e) {
					var n = this;
					(this.manager = t), (this.callback = e), (this.element =
							t.element), (this.target =
							t.options.inputTarget), (this.domHandler = function(e) {
							l(t.options.enable, [t]) && n.handler(e);
					}), this.init();
			}

			function k(t, e, n) {
					var i = n.pointers.length,
							o = n.changedPointers.length,
							a = e & pt && i - o == 0,
							s = e & (ht | mt) && i - o == 0;
					(n.isFirst = !!a), (n.isFinal = !!s), a &&
							(t.session = {}), (n.eventType = e), (function(t, e) {
									var n = t.session,
											i = e.pointers,
											o = i.length;
									n.firstInput || (n.firstInput = S(e)), o > 1 && !n.firstMultiple ? (n.firstMultiple = S(e)) : 1 === o && (n.firstMultiple = !1);
									var a = n.firstInput,
											s = n.firstMultiple,
											c = s ? s.center : a.center,
											u = (e.center = C(i));
									(e.timeStamp = rt()), (e.deltaTime =
											e.timeStamp - a.timeStamp), (e.angle = $(c, u)), (e.distance = A(
											c,
											u
									)), (l = n), (d = e), (p =
											d.center), (f = l.offsetDelta || {}), (m = l.prevDelta || {}), (v = l.prevInput || {}), (d.eventType !==
											pt &&
											v.eventType !== ht) ||
									((m = l.prevDelta = {
											x: v.deltaX || 0,
											y: v.deltaY || 0
									}), (f = l.offsetDelta = {
											x: p.x,
											y: p.y
									})), (d.deltaX =
											m.x + (p.x - f.x)), (d.deltaY =
											m.y + (p.y - f.y)), (e.offsetDirection = E(e.deltaX, e.deltaY));
									var l, d, p, f, m, v;
									var g = T(e.deltaTime, e.deltaX, e.deltaY);
									(e.overallVelocityX = g.x), (e.overallVelocityY =
											g.y), (e.overallVelocity = nt(g.x) > nt(g.y) ? g.x : g.y), (e.scale = s ? ((w = s.pointers), (_ = i), A(_[0], _[1], Ct) / A(w[0], w[1], Ct)) : 1), (e.rotation = s ? ((y = s.pointers), (b = i), $(b[1], b[0], Ct) + $(y[1], y[0], Ct)) : 0), (e.maxPointers = n.prevInput ? e.pointers.length > n.prevInput.maxPointers ? e.pointers.length : n.prevInput.maxPointers : e.pointers.length), (function(t, e) {
											var n, i, o, a, s = t.lastInterval || e,
													c = e.timeStamp - s.timeStamp;
											if (e.eventType != mt && (c > dt || s.velocity === r)) {
													var u = e.deltaX - s.deltaX,
															l = e.deltaY - s.deltaY,
															d = T(c, u, l);
													(i = d.x), (o = d.y), (n = nt(d.x) > nt(d.y) ? d.x : d.y), (a = E(
															u,
															l
													)), (t.lastInterval = e);
											} else
													(n = s.velocity), (i = s.velocityX), (o = s.velocityY), (a =
															s.direction);
											(e.velocity = n), (e.velocityX = i), (e.velocityY = o), (e.direction = a);
									})(n, e);
									var y, b;
									var w, _;
									var x = t.element;
									h(e.srcEvent.target, x) && (x = e.srcEvent.target), (e.target = x);
							})(t, n), t.emit("hammer.input", n), t.recognize(
									n
							), (t.session.prevInput = n);
			}

			function S(t) {
					for (var e = [], n = 0; n < t.pointers.length;)
							(e[n] = {
									clientX: et(t.pointers[n].clientX),
									clientY: et(t.pointers[n].clientY)
							}), n++;
					return {
							timeStamp: rt(),
							pointers: e,
							center: C(e),
							deltaX: t.deltaX,
							deltaY: t.deltaY
					};
			}

			function C(t) {
					var e = t.length;
					if (1 === e) return {
							x: et(t[0].clientX),
							y: et(t[0].clientY)
					};
					for (var n = 0, r = 0, i = 0; e > i;)
							(n += t[i].clientX), (r += t[i].clientY), i++;
					return {
							x: et(n / e),
							y: et(r / e)
					};
			}

			function T(t, e, n) {
					return {
							x: e / t || 0,
							y: n / t || 0
					};
			}

			function E(t, e) {
					return t === e ? vt : nt(t) >= nt(e) ? (0 > t ? gt : yt) : 0 > e ? bt : wt;
			}

			function A(t, e, n) {
					n || (n = St);
					var r = e[n[0]] - t[n[0]],
							i = e[n[1]] - t[n[1]];
					return Math.sqrt(r * r + i * i);
			}

			function $(t, e, n) {
					n || (n = St);
					var r = e[n[0]] - t[n[0]],
							i = e[n[1]] - t[n[1]];
					return 180 * Math.atan2(i, r) / Math.PI;
			}

			function j() {
					(this.evEl = Et), (this.evWin = At), (this.pressed = !1), x.apply(
							this,
							arguments
					);
			}

			function I() {
					(this.evEl = It), (this.evWin = Nt), x.apply(
							this,
							arguments
					), (this.store = this.manager.session.pointerEvents = []);
			}

			function N() {
					(this.evTarget = Ot), (this.evWin = Lt), (this.started = !1), x.apply(
							this,
							arguments
					);
			}

			function z() {
					(this.evTarget = Mt), (this.targetIds = {}), x.apply(this, arguments);
			}

			function O() {
					x.apply(this, arguments);
					var t = u(this.handler, this);
					(this.touch = new z(this.manager, t)), (this.mouse = new j(
							this.manager,
							t
					)), (this.primaryTouch = null), (this.lastTouches = []);
			}

			function L(t) {
					var e = t.changedPointers[0];
					if (e.identifier === this.primaryTouch) {
							var n = {
									x: e.clientX,
									y: e.clientY
							};
							this.lastTouches.push(n);
							var r = this.lastTouches;
							setTimeout(function() {
									var t = r.indexOf(n);
									t > -1 && r.splice(t, 1);
							}, Dt);
					}
			}

			function P(t, e) {
					(this.manager = t), this.set(e);
			}

			function M(t) {
					(this.options = Y({},
							this.defaults,
							t || {}
					)), (this.id = at++), (this.manager = null), (this.options.enable = d(
							this.options.enable, !0
					)), (this.state = Qt), (this.simultaneous = {}), (this.requireFail = []);
			}

			function D(t) {
					return t & Zt ? "cancel" : t & Yt ? "end" : t & Xt ? "move" : t & Gt ? "start" : "";
			}

			function q(t) {
					return t == wt ? "down" : t == bt ? "up" : t == gt ? "left" : t == yt ? "right" : "";
			}

			function R(t, e) {
					var n = e.manager;
					return n ? n.get(t) : t;
			}

			function F() {
					M.apply(this, arguments);
			}

			function W() {
					F.apply(this, arguments), (this.pX = null), (this.pY = null);
			}

			function H() {
					F.apply(this, arguments);
			}

			function V() {
					M.apply(this, arguments), (this._timer = null), (this._input = null);
			}

			function B() {
					F.apply(this, arguments);
			}

			function U() {
					F.apply(this, arguments);
			}

			function J() {
					M.apply(
							this,
							arguments
					), (this.pTime = !1), (this.pCenter = !1), (this._timer = null), (this._input = null), (this.count = 0);
			}

			function Q(t, e) {
					return ((e = e || {}).recognizers = d(
							e.recognizers,
							Q.defaults.preset
					)), new G(t, e);
			}

			function G(t, e) {
					var n;
					(this.options = Y({}, Q.defaults, e || {})), (this.options.inputTarget =
							this.options.inputTarget ||
							t), (this.handlers = {}), (this.session = {}), (this.recognizers = []), (this.oldCssProps = {}), (this.element = t), (this.input = new((n = this)
							.options.inputClass || (ct ? I : ut ? z : st ? O : j))(
							n,
							k
					)), (this.touchAction = new P(this, this.options.touchAction)), X(
							this, !0
					), a(
							this.options.recognizers,
							function(t) {
									var e = this.add(new t[0](t[1]));
									t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3]);
							},
							this
					);
			}

			function X(t, e) {
					var n, r = t.element;
					r.style &&
							(a(t.options.cssProps, function(i, o) {
									(n = w(
											r.style,
											o
									)), e ? ((t.oldCssProps[n] = r.style[n]), (r.style[n] = i)) : (r.style[n] = t.oldCssProps[n] || "");
							}), e || (t.oldCssProps = {}));
			}
			var Y,
					K = ["", "webkit", "Moz", "MS", "ms", "o"],
					Z = e.createElement("div"),
					tt = "function",
					et = Math.round,
					nt = Math.abs,
					rt = Date.now;
			Y = "function" != typeof Object.assign ? function(t) {
					if (t === r || null === t)
							throw new TypeError("Cannot convert undefined or null to object");
					for (var e = Object(t), n = 1; n < arguments.length; n++) {
							var i = arguments[n];
							if (i !== r && null !== i)
									for (var o in i)
											i.hasOwnProperty(o) && (e[o] = i[o]);
					}
					return e;
			} : Object.assign;
			var it = s(
							function(t, e, n) {
									for (var i = Object.keys(e), o = 0; o < i.length;)
											(!n || (n && t[i[o]] === r)) && (t[i[o]] = e[i[o]]), o++;
									return t;
							},
							"extend",
							"Use `assign`."
					),
					ot = s(
							function(t, e) {
									return it(t, e, !0);
							},
							"merge",
							"Use `assign`."
					),
					at = 1,
					st = "ontouchstart" in t,
					ct = w(t, "PointerEvent") !== r,
					ut =
					st && /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),
					lt = "touch",
					dt = 25,
					pt = 1,
					ft = 2,
					ht = 4,
					mt = 8,
					vt = 1,
					gt = 2,
					yt = 4,
					bt = 8,
					wt = 16,
					_t = gt | yt,
					xt = bt | wt,
					kt = _t | xt,
					St = ["x", "y"],
					Ct = ["clientX", "clientY"];
			x.prototype = {
					handler: function() {},
					init: function() {
							this.evEl && p(this.element, this.evEl, this.domHandler), this.evTarget &&
									p(this.target, this.evTarget, this.domHandler), this.evWin &&
									p(_(this.element), this.evWin, this.domHandler);
					},
					destroy: function() {
							this.evEl && f(this.element, this.evEl, this.domHandler), this.evTarget &&
									f(this.target, this.evTarget, this.domHandler), this.evWin &&
									f(_(this.element), this.evWin, this.domHandler);
					}
			};
			var Tt = {
							mousedown: pt,
							mousemove: ft,
							mouseup: ht
					},
					Et = "mousedown",
					At = "mousemove mouseup";
			c(j, x, {
					handler: function(t) {
							var e = Tt[t.type];
							e & pt && 0 === t.button && (this.pressed = !0), e & ft &&
									1 !== t.which &&
									(e = ht), this.pressed &&
									(e & ht && (this.pressed = !1), this.callback(this.manager, e, {
											pointers: [t],
											changedPointers: [t],
											pointerType: "mouse",
											srcEvent: t
									}));
					}
			});
			var $t = {
							pointerdown: pt,
							pointermove: ft,
							pointerup: ht,
							pointercancel: mt,
							pointerout: mt
					},
					jt = {
							2: lt,
							3: "pen",
							4: "mouse",
							5: "kinect"
					},
					It = "pointerdown",
					Nt = "pointermove pointerup pointercancel";
			t.MSPointerEvent &&
					!t.PointerEvent &&
					((It = "MSPointerDown"), (Nt =
							"MSPointerMove MSPointerUp MSPointerCancel")), c(I, x, {
							handler: function(t) {
									var e = this.store,
											n = !1,
											r = t.type.toLowerCase().replace("ms", ""),
											i = $t[r],
											o = jt[t.pointerType] || t.pointerType,
											a = o == lt,
											s = g(e, t.pointerId, "pointerId");
									i & pt && (0 === t.button || a) ? 0 > s && (e.push(t), (s = e.length - 1)) : i & (ht | mt) && (n = !0), 0 > s ||
											((e[s] = t), this.callback(this.manager, i, {
													pointers: e,
													changedPointers: [t],
													pointerType: o,
													srcEvent: t
											}), n && e.splice(s, 1));
							}
					});
			var zt = {
							touchstart: pt,
							touchmove: ft,
							touchend: ht,
							touchcancel: mt
					},
					Ot = "touchstart",
					Lt = "touchstart touchmove touchend touchcancel";
			c(N, x, {
					handler: function(t) {
							var e = zt[t.type];
							if ((e === pt && (this.started = !0), this.started)) {
									var n = function(t, e) {
											var n = y(t.touches),
													r = y(t.changedTouches);
											return e & (ht | mt) && (n = b(n.concat(r), "identifier", !0)), [
													n,
													r
											];
									}.call(this, t, e);
									e & (ht | mt) &&
											n[0].length - n[1].length == 0 &&
											(this.started = !1), this.callback(this.manager, e, {
													pointers: n[0],
													changedPointers: n[1],
													pointerType: lt,
													srcEvent: t
											});
							}
					}
			});
			var Pt = {
							touchstart: pt,
							touchmove: ft,
							touchend: ht,
							touchcancel: mt
					},
					Mt = "touchstart touchmove touchend touchcancel";
			c(z, x, {
					handler: function(t) {
							var e = Pt[t.type],
									n = function(t, e) {
											var n = y(t.touches),
													r = this.targetIds;
											if (e & (pt | ft) && 1 === n.length)
													return (r[n[0].identifier] = !0), [n, n];
											var i, o, a = y(t.changedTouches),
													s = [],
													c = this.target;
											if (
													((o = n.filter(function(t) {
															return h(t.target, c);
													})), e === pt)
											)
													for (i = 0; i < o.length;)
															(r[o[i].identifier] = !0), i++;
											for (i = 0; i < a.length;)
													r[a[i].identifier] && s.push(a[i]), e & (ht | mt) &&
													delete r[a[i].identifier], i++;
											return s.length ? [b(o.concat(s), "identifier", !0), s] : void 0;
									}.call(this, t, e);
							n &&
									this.callback(this.manager, e, {
											pointers: n[0],
											changedPointers: n[1],
											pointerType: lt,
											srcEvent: t
									});
					}
			});
			var Dt = 2500,
					qt = 25;
			c(O, x, {
					handler: function(t, e, n) {
							var r = n.pointerType == lt,
									i = "mouse" == n.pointerType;
							if (!(i && n.sourceCapabilities && n.sourceCapabilities.firesTouchEvents)) {
									if (r)
											(function(t, e) {
													t & pt ? ((this.primaryTouch = e.changedPointers[0].identifier), L.call(
															this,
															e
													)) : t & (ht | mt) && L.call(this, e);
											}.call(this, e, n));
									else if (
											i &&
											function(t) {
													for (
															var e = t.srcEvent.clientX, n = t.srcEvent.clientY, r = 0; r < this.lastTouches.length; r++
													) {
															var i = this.lastTouches[r],
																	o = Math.abs(e - i.x),
																	a = Math.abs(n - i.y);
															if (qt >= o && qt >= a) return !0;
													}
													return !1;
											}.call(this, n)
									)
											return;
									this.callback(t, e, n);
							}
					},
					destroy: function() {
							this.touch.destroy(), this.mouse.destroy();
					}
			});
			var Rt = w(Z.style, "touchAction"),
					Ft = Rt !== r,
					Wt = "auto",
					Ht = "manipulation",
					Vt = "none",
					Bt = "pan-x",
					Ut = "pan-y",
					Jt = (function() {
							if (!Ft) return !1;
							var e = {},
									n = t.CSS && t.CSS.supports;
							return [
									"auto",
									"manipulation",
									"pan-y",
									"pan-x",
									"pan-x pan-y",
									"none"
							].forEach(function(r) {
									e[r] = !n || t.CSS.supports("touch-action", r);
							}), e;
					})();
			P.prototype = {
					set: function(t) {
							"compute" == t && (t = this.compute()), Ft &&
									this.manager.element.style &&
									Jt[t] &&
									(this.manager.element.style[
											Rt
									] = t), (this.actions = t.toLowerCase().trim());
					},
					update: function() {
							this.set(this.manager.options.touchAction);
					},
					compute: function() {
							var t = [];
							return a(this.manager.recognizers, function(e) {
									l(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()));
							}), (function(t) {
									if (m(t, Vt)) return Vt;
									var e = m(t, Bt),
											n = m(t, Ut);
									return e && n ? Vt : e || n ? (e ? Bt : Ut) : m(t, Ht) ? Ht : Wt;
							})(t.join(" "));
					},
					preventDefaults: function(t) {
							var e = t.srcEvent,
									n = t.offsetDirection;
							if (!this.manager.session.prevented) {
									var r = this.actions,
											i = m(r, Vt) && !Jt[Vt],
											o = m(r, Ut) && !Jt[Ut],
											a = m(r, Bt) && !Jt[Bt];
									if (i) {
											var s = 1 === t.pointers.length,
													c = t.distance < 2,
													u = t.deltaTime < 250;
											if (s && c && u) return;
									}
									return a && o ? void 0 : i || (o && n & _t) || (a && n & xt) ? this.preventSrc(e) : void 0;
							}
							e.preventDefault();
					},
					preventSrc: function(t) {
							(this.manager.session.prevented = !0), t.preventDefault();
					}
			};
			var Qt = 1,
					Gt = 2,
					Xt = 4,
					Yt = 8,
					Kt = Yt,
					Zt = 16;
			(M.prototype = {
					defaults: {},
					set: function(t) {
							return Y(this.options, t), this.manager &&
									this.manager.touchAction.update(), this;
					},
					recognizeWith: function(t) {
							if (o(t, "recognizeWith", this)) return this;
							var e = this.simultaneous;
							return e[(t = R(t, this)).id] ||
									((e[t.id] = t), t.recognizeWith(this)), this;
					},
					dropRecognizeWith: function(t) {
							return o(t, "dropRecognizeWith", this) ? this : ((t = R(t, this)), delete this.simultaneous[t.id], this);
					},
					requireFailure: function(t) {
							if (o(t, "requireFailure", this)) return this;
							var e = this.requireFail;
							return -1 === g(e, (t = R(t, this))) &&
									(e.push(t), t.requireFailure(this)), this;
					},
					dropRequireFailure: function(t) {
							if (o(t, "dropRequireFailure", this)) return this;
							t = R(t, this);
							var e = g(this.requireFail, t);
							return e > -1 && this.requireFail.splice(e, 1), this;
					},
					hasRequireFailures: function() {
							return this.requireFail.length > 0;
					},
					canRecognizeWith: function(t) {
							return !!this.simultaneous[t.id];
					},
					emit: function(t) {
							function e(e) {
									n.manager.emit(e, t);
							}
							var n = this,
									r = this.state;
							Yt > r && e(n.options.event + D(r)), e(
											n.options.event
									), t.additionalEvent && e(t.additionalEvent), r >= Yt &&
									e(n.options.event + D(r));
					},
					tryEmit: function(t) {
							return this.canEmit() ? this.emit(t) : void(this.state = 32);
					},
					canEmit: function() {
							for (var t = 0; t < this.requireFail.length;) {
									if (!(this.requireFail[t].state & (32 | Qt))) return !1;
									t++;
							}
							return !0;
					},
					recognize: function(t) {
							var e = Y({}, t);
							return l(this.options.enable, [this, e]) ? (this.state & (Kt | Zt | 32) &&
									(this.state = Qt), (this.state = this.process(e)), void(this
											.state &
											(Gt | Xt | Yt | Zt) && this.tryEmit(e))) : (this.reset(), void(this.state = 32));
					},
					process: function(t) {},
					getTouchAction: function() {},
					reset: function() {}
			}), c(F, M, {
					defaults: {
							pointers: 1
					},
					attrTest: function(t) {
							var e = this.options.pointers;
							return 0 === e || t.pointers.length === e;
					},
					process: function(t) {
							var e = this.state,
									n = t.eventType,
									r = e & (Gt | Xt),
									i = this.attrTest(t);
							return r && (n & mt || !i) ? e | Zt : r || i ? (n & ht ? e | Yt : e & Gt ? e | Xt : Gt) : 32;
					}
			}), c(W, F, {
					defaults: {
							event: "pan",
							threshold: 10,
							pointers: 1,
							direction: kt
					},
					getTouchAction: function() {
							var t = this.options.direction,
									e = [];
							return t & _t && e.push(Ut), t & xt && e.push(Bt), e;
					},
					directionTest: function(t) {
							var e = this.options,
									n = !0,
									r = t.distance,
									i = t.direction,
									o = t.deltaX,
									a = t.deltaY;
							return i & e.direction ||
									(e.direction & _t ? ((i = 0 === o ? vt : 0 > o ? gt : yt), (n =
											o != this.pX), (r = Math.abs(t.deltaX))) : ((i = 0 === a ? vt : 0 > a ? bt : wt), (n =
											a != this.pY), (r = Math.abs(t.deltaY)))), (t.direction = i), n &&
									r > e.threshold &&
									i & e.direction;
					},
					attrTest: function(t) {
							return (
									F.prototype.attrTest.call(this, t) &&
									(this.state & Gt || (!(this.state & Gt) && this.directionTest(t)))
							);
					},
					emit: function(t) {
							(this.pX = t.deltaX), (this.pY = t.deltaY);
							var e = q(t.direction);
							e && (t.additionalEvent = this.options.event + e), this._super.emit.call(
									this,
									t
							);
					}
			}), c(H, F, {
					defaults: {
							event: "pinch",
							threshold: 0,
							pointers: 2
					},
					getTouchAction: function() {
							return [Vt];
					},
					attrTest: function(t) {
							return (
									this._super.attrTest.call(this, t) &&
									(Math.abs(t.scale - 1) > this.options.threshold || this.state & Gt)
							);
					},
					emit: function(t) {
							if (1 !== t.scale) {
									var e = t.scale < 1 ? "in" : "out";
									t.additionalEvent = this.options.event + e;
							}
							this._super.emit.call(this, t);
					}
			}), c(V, M, {
					defaults: {
							event: "press",
							pointers: 1,
							time: 251,
							threshold: 9
					},
					getTouchAction: function() {
							return [Wt];
					},
					process: function(t) {
							var e = this.options,
									n = t.pointers.length === e.pointers,
									r = t.distance < e.threshold,
									o = t.deltaTime > e.time;
							if (((this._input = t), !r || !n || (t.eventType & (ht | mt) && !o)))
									this.reset();
							else if (t.eventType & pt)
									this.reset(), (this._timer = i(
											function() {
													(this.state = Kt), this.tryEmit();
											},
											e.time,
											this
									));
							else if (t.eventType & ht) return Kt;
							return 32;
					},
					reset: function() {
							clearTimeout(this._timer);
					},
					emit: function(t) {
							this.state === Kt &&
									(t && t.eventType & ht ? this.manager.emit(this.options.event + "up", t) : ((this._input.timeStamp = rt()), this.manager.emit(
											this.options.event,
											this._input
									)));
					}
			}), c(B, F, {
					defaults: {
							event: "rotate",
							threshold: 0,
							pointers: 2
					},
					getTouchAction: function() {
							return [Vt];
					},
					attrTest: function(t) {
							return (
									this._super.attrTest.call(this, t) &&
									(Math.abs(t.rotation) > this.options.threshold || this.state & Gt)
							);
					}
			}), c(U, F, {
					defaults: {
							event: "swipe",
							threshold: 10,
							velocity: 0.3,
							direction: _t | xt,
							pointers: 1
					},
					getTouchAction: function() {
							return W.prototype.getTouchAction.call(this);
					},
					attrTest: function(t) {
							var e, n = this.options.direction;
							return n & (_t | xt) ? (e = t.overallVelocity) : n & _t ? (e = t.overallVelocityX) : n & xt && (e = t.overallVelocityY), this._super.attrTest.call(
											this,
											t
									) &&
									n & t.offsetDirection &&
									t.distance > this.options.threshold &&
									t.maxPointers == this.options.pointers &&
									nt(e) > this.options.velocity &&
									t.eventType & ht;
					},
					emit: function(t) {
							var e = q(t.offsetDirection);
							e && this.manager.emit(this.options.event + e, t), this.manager.emit(
									this.options.event,
									t
							);
					}
			}), c(J, M, {
					defaults: {
							event: "tap",
							pointers: 1,
							taps: 1,
							interval: 300,
							time: 250,
							threshold: 9,
							posThreshold: 10
					},
					getTouchAction: function() {
							return [Ht];
					},
					process: function(t) {
							var e = this.options,
									n = t.pointers.length === e.pointers,
									r = t.distance < e.threshold,
									o = t.deltaTime < e.time;
							if ((this.reset(), t.eventType & pt && 0 === this.count))
									return this.failTimeout();
							if (r && o && n) {
									if (t.eventType != ht) return this.failTimeout();
									var a = !this.pTime || t.timeStamp - this.pTime < e.interval,
											s = !this.pCenter || A(this.pCenter, t.center) < e.posThreshold;
									if (
											((this.pTime = t.timeStamp), (this.pCenter = t.center), s && a ? (this.count += 1) : (this.count = 1), (this._input = t), 0 === this.count % e.taps)
									)
											return this.hasRequireFailures() ? ((this._timer = i(
													function() {
															(this.state = Kt), this.tryEmit();
													},
													e.interval,
													this
											)), Gt) : Kt;
							}
							return 32;
					},
					failTimeout: function() {
							return (this._timer = i(
									function() {
											this.state = 32;
									},
									this.options.interval,
									this
							)), 32;
					},
					reset: function() {
							clearTimeout(this._timer);
					},
					emit: function() {
							this.state == Kt &&
									((this._input.tapCount = this.count), this.manager.emit(
											this.options.event,
											this._input
									));
					}
			}), (Q.VERSION = "2.0.8"), (Q.defaults = {
					domEvents: !1,
					touchAction: "compute",
					enable: !0,
					inputTarget: null,
					inputClass: null,
					preset: [
							[B, {
									enable: !1
							}],
							[H, {
											enable: !1
									},
									["rotate"]
							],
							[U, {
									direction: _t
							}],
							[W, {
											direction: _t
									},
									["swipe"]
							],
							[J],
							[J, {
											event: "doubletap",
											taps: 2
									},
									["tap"]
							],
							[V]
					],
					cssProps: {
							userSelect: "none",
							touchSelect: "none",
							touchCallout: "none",
							contentZooming: "none",
							userDrag: "none",
							tapHighlightColor: "rgba(0,0,0,0)"
					}
			});
			(G.prototype = {
					set: function(t) {
							return Y(this.options, t), t.touchAction &&
									this.touchAction.update(), t.inputTarget &&
									(this.input.destroy(), (this.input.target =
											t.inputTarget), this.input.init()), this;
					},
					stop: function(t) {
							this.session.stopped = t ? 2 : 1;
					},
					recognize: function(t) {
							var e = this.session;
							if (!e.stopped) {
									this.touchAction.preventDefaults(t);
									var n, r = this.recognizers,
											i = e.curRecognizer;
									(!i || (i && i.state & Kt)) && (i = e.curRecognizer = null);
									for (var o = 0; o < r.length;)
											(n = r[o]), 2 === e.stopped || (i && n != i && !n.canRecognizeWith(i)) ? n.reset() : n.recognize(t), !i &&
											n.state & (Gt | Xt | Yt) &&
											(i = e.curRecognizer = n), o++;
							}
					},
					get: function(t) {
							if (t instanceof M) return t;
							for (var e = this.recognizers, n = 0; n < e.length; n++)
									if (e[n].options.event == t) return e[n];
							return null;
					},
					add: function(t) {
							if (o(t, "add", this)) return this;
							var e = this.get(t.options.event);
							return e && this.remove(e), this.recognizers.push(
									t
							), (t.manager = this), this.touchAction.update(), t;
					},
					remove: function(t) {
							if (o(t, "remove", this)) return this;
							if ((t = this.get(t))) {
									var e = this.recognizers,
											n = g(e, t); - 1 !== n && (e.splice(n, 1), this.touchAction.update());
							}
							return this;
					},
					on: function(t, e) {
							if (t !== r && e !== r) {
									var n = this.handlers;
									return a(v(t), function(t) {
											(n[t] = n[t] || []), n[t].push(e);
									}), this;
							}
					},
					off: function(t, e) {
							if (t !== r) {
									var n = this.handlers;
									return a(v(t), function(t) {
											e ? n[t] && n[t].splice(g(n[t], e), 1) : delete n[t];
									}), this;
							}
					},
					emit: function(t, n) {
							var r, i, o;
							this.options.domEvents &&
									((r = t), (i = n), (o = e.createEvent("Event")).initEvent(
											r, !0, !0
									), (o.gesture = i), i.target.dispatchEvent(o));
							var a = this.handlers[t] && this.handlers[t].slice();
							if (a && a.length) {
									(n.type = t), (n.preventDefault = function() {
											n.srcEvent.preventDefault();
									});
									for (var s = 0; s < a.length;)
											a[s](n), s++;
							}
					},
					destroy: function() {
							this.element &&
									X(
											this, !1
									), (this.handlers = {}), (this.session = {}), this.input.destroy(), (this.element = null);
					}
			}), Y(Q, {
							INPUT_START: pt,
							INPUT_MOVE: ft,
							INPUT_END: ht,
							INPUT_CANCEL: mt,
							STATE_POSSIBLE: Qt,
							STATE_BEGAN: Gt,
							STATE_CHANGED: Xt,
							STATE_ENDED: Yt,
							STATE_RECOGNIZED: Kt,
							STATE_CANCELLED: Zt,
							STATE_FAILED: 32,
							DIRECTION_NONE: vt,
							DIRECTION_LEFT: gt,
							DIRECTION_RIGHT: yt,
							DIRECTION_UP: bt,
							DIRECTION_DOWN: wt,
							DIRECTION_HORIZONTAL: _t,
							DIRECTION_VERTICAL: xt,
							DIRECTION_ALL: kt,
							Manager: G,
							Input: x,
							TouchAction: P,
							TouchInput: z,
							MouseInput: j,
							PointerEventInput: I,
							TouchMouseInput: O,
							SingleTouchInput: N,
							Recognizer: M,
							AttrRecognizer: F,
							Tap: J,
							Pan: W,
							Swipe: U,
							Pinch: H,
							Rotate: B,
							Press: V,
							on: p,
							off: f,
							each: a,
							merge: ot,
							extend: it,
							assign: Y,
							inherit: c,
							bindFn: u,
							prefixed: w
					}), ((void 0 !== t ? t : "undefined" != typeof self ? self : {}).Hammer = Q), "function" ==
					typeof define && define.amd ? define(function() {
							return Q;
					}) : "undefined" != typeof module && module.exports ? (module.exports = Q) : (t.Hammer = Q);
	})(window, document);
	
	(function(t) {
			"function" != typeof t.matches &&
					(t.matches =
							t.msMatchesSelector ||
							t.mozMatchesSelector ||
							t.webkitMatchesSelector ||
							function(t) {
									for (
											var e = (this.document || this.ownerDocument).querySelectorAll(t),
													n = 0; e[n] && e[n] !== this;

									)
											++n;
									return Boolean(e[n]);
							}), "function" != typeof t.closest &&
					(t.closest = function(t) {
							for (var e = this; e && 1 === e.nodeType;) {
									if (e.matches(t)) return e;
									e = e.parentNode;
							}
							return null;
					});
	})(window.Element.prototype), 
	// string.prototype.includes Polyfill 
	String.prototype.includes ||
	(function() {
			"use strict";
			var t = {}.toString,
					e = (function() {
							try {
									var t = {},
											e = Object.defineProperty,
											n = e(t, t, t) && e;
							} catch (t) {}
							return n;
					})(),
					n = "".indexOf,
					r = function(e) {
							if (null == this) throw TypeError();
							var r = String(this);
							if (e && "[object RegExp]" == t.call(e)) throw TypeError();
							var i = r.length,
									o = String(e),
									a = o.length,
									s = arguments.length > 1 ? arguments[1] : void 0,
									c = s ? Number(s) : 0;
							return c != c && (c = 0), !(a + Math.min(Math.max(c, 0), i) > i) &&
									-1 != n.call(r, o, c);
					};
			e
					? e(String.prototype, "includes", {
							value: r,
							configurable: !0,
							writable: !0
					}) : (String.prototype.includes = r);
	})();

//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

!function() {
	function t(t) {
			return function(e, n, r, i) {
					n = b(n, i, 4);
					var o = !T(e) && y.keys(e),
							a = (o || e).length,
							s = t > 0 ? 0 : a - 1;
					return arguments.length < 3 &&
							((r = e[o ? o[s] : s]), (s += t)), (function(e, n, r, i, o, a) {
									for (; o >= 0 && a > o; o += t) {
											var s = i ? i[o] : o;
											r = n(r, e[s], s, e);
									}
									return r;
							})(e, n, r, o, s, a);
			};
	}

	function e(t) {
			return function(e, n, r) {
					n = w(n, r);
					for (var i = C(e), o = t > 0 ? 0 : i - 1; o >= 0 && i > o; o += t)
							if (n(e[o], o, e)) return o;
					return -1;
			};
	}

	function n(t, e, n) {
			return function(r, i, o) {
					var a = 0,
							s = C(r);
					if ("number" == typeof o)
							t > 0 ? (a = o >= 0 ? o : Math.max(o + s, a)) : (s = o >= 0 ? Math.min(o + 1, s) : o + s + 1);
					else if (n && o && s) return (o = n(r, i)), r[o] === i ? o : -1;
					if (i != i) return (o = e(l.call(r, a, s), y.isNaN)), o >= 0 ? o + a : -1;
					for (o = t > 0 ? a : s - 1; o >= 0 && s > o; o += t)
							if (r[o] === i) return o;
					return -1;
			};
	}

	function r(t, e) {
			var n = I.length,
					r = t.constructor,
					i = (y.isFunction(r) && r.prototype) || s,
					o = "constructor";
			for (y.has(t, o) && !y.contains(e, o) && e.push(o); n--;)
					(o = I[n]), o in t && t[o] !== i[o] && !y.contains(e, o) && e.push(o);
	}
	var i = this,
			o = i._,
			a = Array.prototype,
			s = Object.prototype,
			c = Function.prototype,
			u = a.push,
			l = a.slice,
			d = s.toString,
			p = s.hasOwnProperty,
			f = Array.isArray,
			h = Object.keys,
			m = c.bind,
			v = Object.create,
			g = function() {},
			y = function(t) {
					return t instanceof y ? t : this instanceof y ? void(this._wrapped = t) : new y(t);
			};
	"undefined" != typeof exports
			? ("undefined" != typeof module &&
					module.exports &&
					(exports = module.exports = y), (exports._ = y)) : (i._ = y), (y.VERSION = "1.8.3");
	var b = function(t, e, n) {
					if (void 0 === e) return t;
					switch (null == n ? 3 : n) {
							case 1:
									return function(n) {
											return t.call(e, n);
									};
							case 2:
									return function(n, r) {
											return t.call(e, n, r);
									};
							case 3:
									return function(n, r, i) {
											return t.call(e, n, r, i);
									};
							case 4:
									return function(n, r, i, o) {
											return t.call(e, n, r, i, o);
									};
					}
					return function() {
							return t.apply(e, arguments);
					};
			},
			w = function(t, e, n) {
					return null == t ? y.identity : y.isFunction(t) ? b(t, e, n) : y.isObject(t) ? y.matcher(t) : y.property(t);
			};
	y.iteratee = function(t, e) {
			return w(t, e, 1 / 0);
	};
	var _ = function(t, e) {
					return function(n) {
							var r = arguments.length;
							if (2 > r || null == n) return n;
							for (var i = 1; r > i; i++)
									for (var o = arguments[i], a = t(o), s = a.length, c = 0; s > c; c++) {
											var u = a[c];
											(e && void 0 !== n[u]) || (n[u] = o[u]);
									}
							return n;
					};
			},
			x = function(t) {
					if (!y.isObject(t)) return {};
					if (v) return v(t);
					g.prototype = t;
					var e = new g();
					return (g.prototype = null), e;
			},
			k = function(t) {
					return function(e) {
							return null == e ? void 0 : e[t];
					};
			},
			S = Math.pow(2, 53) - 1,
			C = k("length"),
			T = function(t) {
					var e = C(t);
					return "number" == typeof e && e >= 0 && S >= e;
			};
	(y.each = y.forEach = function(t, e, n) {
			var r, i;
			if (((e = b(e, n)), T(t)))
					for ((r = 0), (i = t.length); i > r; r++)
							e(t[r], r, t);
			else {
					var o = y.keys(t);
					for ((r = 0), (i = o.length); i > r; r++)
							e(t[o[r]], o[r], t);
			}
			return t;
	}), (y.map = y.collect = function(t, e, n) {
			e = w(e, n);
			for (
					var r = !T(t) && y.keys(t), i = (r || t).length, o = Array(i), a = 0; i > a; a++
			) {
					var s = r ? r[a] : a;
					o[a] = e(t[s], s, t);
			}
			return o;
	}), (y.reduce = y.foldl = y.inject = t(1)), (y.reduceRight = y.foldr = t(-1)), (y.find = y.detect = function(t, e, n) {
			var r;
			return void 0 !== (r = T(t) ? y.findIndex(t, e, n) : y.findKey(t, e, n)) &&
					-1 !== r ? t[r] : void 0;
	}), (y.filter = y.select = function(t, e, n) {
			var r = [];
			return (e = w(e, n)), y.each(t, function(t, n, i) {
					e(t, n, i) && r.push(t);
			}), r;
	}), (y.reject = function(t, e, n) {
			return y.filter(t, y.negate(w(e)), n);
	}), (y.every = y.all = function(t, e, n) {
			e = w(e, n);
			for (var r = !T(t) && y.keys(t), i = (r || t).length, o = 0; i > o; o++) {
					var a = r ? r[o] : o;
					if (!e(t[a], a, t)) return !1;
			}
			return !0;
	}), (y.some = y.any = function(t, e, n) {
			e = w(e, n);
			for (var r = !T(t) && y.keys(t), i = (r || t).length, o = 0; i > o; o++) {
					var a = r ? r[o] : o;
					if (e(t[a], a, t)) return !0;
			}
			return !1;
	}), (y.contains = y.includes = y.include = function(t, e, n, r) {
			return T(t) || (t = y.values(t)), ("number" != typeof n || r) &&
					(n = 0), y.indexOf(t, e, n) >= 0;
	}), (y.invoke = function(t, e) {
			var n = l.call(arguments, 2),
					r = y.isFunction(e);
			return y.map(t, function(t) {
					var i = r ? e : t[e];
					return null == i ? i : i.apply(t, n);
			});
	}), (y.pluck = function(t, e) {
			return y.map(t, y.property(e));
	}), (y.where = function(t, e) {
			return y.filter(t, y.matcher(e));
	}), (y.findWhere = function(t, e) {
			return y.find(t, y.matcher(e));
	}), (y.max = function(t, e, n) {
			var r, i, o = -1 / 0,
					a = -1 / 0;
			if (null == e && null != t)
					for (var s = 0, c = (t = T(t) ? t : y.values(t)).length; c > s; s++)
							(r = t[s]), r > o && (o = r);
			else
					(e = w(e, n)), y.each(t, function(t, n, r) {
							((i = e(t, n, r)) > a || (i === -1 / 0 && o === -1 / 0)) &&
							((o = t), (a = i));
					});
			return o;
	}), (y.min = function(t, e, n) {
			var r, i, o = 1 / 0,
					a = 1 / 0;
			if (null == e && null != t)
					for (var s = 0, c = (t = T(t) ? t : y.values(t)).length; c > s; s++)
							(r = t[s]), o > r && (o = r);
			else
					(e = w(e, n)), y.each(t, function(t, n, r) {
							(i = e(
									t,
									n,
									r
							)), (a > i || (1 / 0 === i && 1 / 0 === o)) && ((o = t), (a = i));
					});
			return o;
	}), (y.shuffle = function(t) {
			for (
					var e, n = T(t) ? t : y.values(t), r = n.length, i = Array(r), o = 0; r > o; o++
			)
					(e = y.random(0, o)), e !== o && (i[o] = i[e]), (i[e] = n[o]);
			return i;
	}), (y.sample = function(t, e, n) {
			return null == e || n ? (T(t) || (t = y.values(t)), t[y.random(t.length - 1)]) : y.shuffle(t).slice(0, Math.max(0, e));
	}), (y.sortBy = function(t, e, n) {
			return (e = w(e, n)), y.pluck(
					y
					.map(t, function(t, n, r) {
							return {
									value: t,
									index: n,
									criteria: e(t, n, r)
							};
					})
					.sort(function(t, e) {
							var n = t.criteria,
									r = e.criteria;
							if (n !== r) {
									if (n > r || void 0 === n) return 1;
									if (r > n || void 0 === r) return -1;
							}
							return t.index - e.index;
					}),
					"value"
			);
	});
	var E = function(t) {
			return function(e, n, r) {
					var i = {};
					return (n = w(n, r)), y.each(e, function(r, o) {
							var a = n(r, o, e);
							t(i, r, a);
					}), i;
			};
	};
	(y.groupBy = E(function(t, e, n) {
			y.has(t, n) ? t[n].push(e) : (t[n] = [e]);
	})), (y.indexBy = E(function(t, e, n) {
			t[n] = e;
	})), (y.countBy = E(function(t, e, n) {
			y.has(t, n) ? t[n]++ : (t[n] = 1);
	})), (y.toArray = function(t) {
			return t ? y.isArray(t) ? l.call(t) : T(t) ? y.map(t, y.identity) : y.values(t) : [];
	}), (y.size = function(t) {
			return null == t ? 0 : T(t) ? t.length : y.keys(t).length;
	}), (y.partition = function(t, e, n) {
			e = w(e, n);
			var r = [],
					i = [];
			return y.each(t, function(t, n, o) {
					(e(t, n, o) ? r : i).push(t);
			}), [r, i];
	}), (y.first = y.head = y.take = function(t, e, n) {
			return null == t ? void 0 : null == e || n ? t[0] : y.initial(t, t.length - e);
	}), (y.initial = function(t, e, n) {
			return l.call(t, 0, Math.max(0, t.length - (null == e || n ? 1 : e)));
	}), (y.last = function(t, e, n) {
			return null == t ? void 0 : null == e || n ? t[t.length - 1] : y.rest(t, Math.max(0, t.length - e));
	}), (y.rest = y.tail = y.drop = function(t, e, n) {
			return l.call(t, null == e || n ? 1 : e);
	}), (y.compact = function(t) {
			return y.filter(t, y.identity);
	});
	var A = function(t, e, n, r) {
			for (var i = [], o = 0, a = r || 0, s = C(t); s > a; a++) {
					var c = t[a];
					if (T(c) && (y.isArray(c) || y.isArguments(c))) {
							e || (c = A(c, e, n));
							var u = 0,
									l = c.length;
							for (i.length += l; l > u;)
									i[o++] = c[u++];
					} else n || (i[o++] = c);
			}
			return i;
	};
	(y.flatten = function(t, e) {
			return A(t, e, !1);
	}), (y.without = function(t) {
			return y.difference(t, l.call(arguments, 1));
	}), (y.uniq = y.unique = function(t, e, n, r) {
			y.isBoolean(e) || ((r = n), (n = e), (e = !1)), null != n && (n = w(n, r));
			for (var i = [], o = [], a = 0, s = C(t); s > a; a++) {
					var c = t[a],
							u = n ? n(c, a, t) : c;
					e
							? ((a && o === u) || i.push(c), (o = u)) : n ? y.contains(o, u) || (o.push(u), i.push(c)) : y.contains(i, c) || i.push(c);
			}
			return i;
	}), (y.union = function() {
			return y.uniq(A(arguments, !0, !0));
	}), (y.intersection = function(t) {
			for (var e = [], n = arguments.length, r = 0, i = C(t); i > r; r++) {
					var o = t[r];
					if (!y.contains(e, o)) {
							for (var a = 1; n > a && y.contains(arguments[a], o); a++);
							a === n && e.push(o);
					}
			}
			return e;
	}), (y.difference = function(t) {
			var e = A(arguments, !0, !0, 1);
			return y.filter(t, function(t) {
					return !y.contains(e, t);
			});
	}), (y.zip = function() {
			return y.unzip(arguments);
	}), (y.unzip = function(t) {
			for (
					var e = (t && y.max(t, C).length) || 0, n = Array(e), r = 0; e > r; r++
			)
					n[r] = y.pluck(t, r);
			return n;
	}), (y.object = function(t, e) {
			for (var n = {}, r = 0, i = C(t); i > r; r++)
					e ? (n[t[r]] = e[r]) : (n[t[r][0]] = t[r][1]);
			return n;
	}), (y.findIndex = e(1)), (y.findLastIndex = e(-1)), (y.sortedIndex = function(t, e, n, r) {
			for (var i = (n = w(n, r, 1))(e), o = 0, a = C(t); a > o;) {
					var s = Math.floor((o + a) / 2);
					n(t[s]) < i ? (o = s + 1) : (a = s);
			}
			return o;
	}), (y.indexOf = n(1, y.findIndex, y.sortedIndex)), (y.lastIndexOf = n(-1,
			y.findLastIndex
	)), (y.range = function(t, e, n) {
			null == e && ((e = t || 0), (t = 0)), (n = n || 1);
			for (
					var r = Math.max(Math.ceil((e - t) / n), 0), i = Array(r), o = 0; r > o; o++, (t += n)
			)
					i[o] = t;
			return i;
	});
	var $ = function(t, e, n, r, i) {
			if (!(r instanceof e)) return t.apply(n, i);
			var o = x(t.prototype),
					a = t.apply(o, i);
			return y.isObject(a) ? a : o;
	};
	(y.bind = function(t, e) {
			if (m && t.bind === m) return m.apply(t, l.call(arguments, 1));
			if (!y.isFunction(t))
					throw new TypeError("Bind must be called on a function");
			var n = l.call(arguments, 2),
					r = function() {
							return $(t, r, e, this, n.concat(l.call(arguments)));
					};
			return r;
	}), (y.partial = function(t) {
			var e = l.call(arguments, 1),
					n = function() {
							for (var r = 0, i = e.length, o = Array(i), a = 0; i > a; a++)
									o[a] = e[a] === y ? arguments[r++] : e[a];
							for (; r < arguments.length;)
									o.push(arguments[r++]);
							return $(t, n, this, this, o);
					};
			return n;
	}), (y.bindAll = function(t) {
			var e, n, r = arguments.length;
			if (1 >= r) throw new Error("bindAll must be passed function names");
			for (e = 1; r > e; e++)
					(n = arguments[e]), (t[n] = y.bind(t[n], t));
			return t;
	}), (y.memoize = function(t, e) {
			var n = function(r) {
					var i = n.cache,
							o = "" + (e ? e.apply(this, arguments) : r);
					return y.has(i, o) || (i[o] = t.apply(this, arguments)), i[o];
			};
			return (n.cache = {}), n;
	}), (y.delay = function(t, e) {
			var n = l.call(arguments, 2);
			return setTimeout(function() {
					return t.apply(null, n);
			}, e);
	}), (y.defer = y.partial(y.delay, y, 1)), (y.throttle = function(t, e, n) {
			var r, i, o, a = null,
					s = 0;
			n || (n = {});
			var c = function() {
					(s = !1 === n.leading ? 0 : y.now()), (a = null), (o = t.apply(
							r,
							i
					)), a || (r = i = null);
			};
			return function() {
					var u = y.now();
					s || !1 !== n.leading || (s = u);
					var l = e - (u - s);
					return (r = this), (i = arguments), 0 >= l || l > e ? (a && (clearTimeout(a), (a = null)), (s = u), (o = t.apply(
							r,
							i
					)), a || (r = i = null)) : a || !1 === n.trailing || (a = setTimeout(c, l)), o;
			};
	}), (y.debounce = function(t, e, n) {
			var r,
					i,
					o,
					a,
					s,
					c = function() {
							var u = y.now() - a;
							e > u && u >= 0 ? (r = setTimeout(c, e - u)) : ((r = null), n || ((s = t.apply(o, i)), r || (o = i = null)));
					};
			return function() {
					(o = this), (i = arguments), (a = y.now());
					var u = n && !r;
					return r || (r = setTimeout(c, e)), u &&
							((s = t.apply(o, i)), (o = i = null)), s;
			};
	}), (y.wrap = function(t, e) {
			return y.partial(e, t);
	}), (y.negate = function(t) {
			return function() {
					return !t.apply(this, arguments);
			};
	}), (y.compose = function() {
			var t = arguments,
					e = t.length - 1;
			return function() {
					for (var n = e, r = t[e].apply(this, arguments); n--;)
							r = t[n].call(this, r);
					return r;
			};
	}), (y.after = function(t, e) {
			return function() {
					return --t < 1 ? e.apply(this, arguments) : void 0;
			};
	}), (y.before = function(t, e) {
			var n;
			return function() {
					return --t > 0 && (n = e.apply(this, arguments)), 1 >= t && (e = null), n;
			};
	}), (y.once = y.partial(y.before, 2));
	var j = !{
					toString: null
			}.propertyIsEnumerable("toString"),
			I = [
					"valueOf",
					"isPrototypeOf",
					"toString",
					"propertyIsEnumerable",
					"hasOwnProperty",
					"toLocaleString"
			];
	(y.keys = function(t) {
			if (!y.isObject(t)) return [];
			if (h) return h(t);
			var e = [];
			for (var n in t)
					y.has(t, n) && e.push(n);
			return j && r(t, e), e;
	}), (y.allKeys = function(t) {
			if (!y.isObject(t)) return [];
			var e = [];
			for (var n in t)
					e.push(n);
			return j && r(t, e), e;
	}), (y.values = function(t) {
			for (var e = y.keys(t), n = e.length, r = Array(n), i = 0; n > i; i++)
					r[i] = t[e[i]];
			return r;
	}), (y.mapObject = function(t, e, n) {
			e = w(e, n);
			for (var r, i = y.keys(t), o = i.length, a = {}, s = 0; o > s; s++)
					(r = i[s]), (a[r] = e(t[r], r, t));
			return a;
	}), (y.pairs = function(t) {
			for (var e = y.keys(t), n = e.length, r = Array(n), i = 0; n > i; i++)
					r[i] = [e[i], t[e[i]]];
			return r;
	}), (y.invert = function(t) {
			for (var e = {}, n = y.keys(t), r = 0, i = n.length; i > r; r++)
					e[t[n[r]]] = n[r];
			return e;
	}), (y.functions = y.methods = function(t) {
			var e = [];
			for (var n in t)
					y.isFunction(t[n]) && e.push(n);
			return e.sort();
	}), (y.extend = _(y.allKeys)), (y.extendOwn = y.assign = _(
			y.keys
	)), (y.findKey = function(t, e, n) {
			e = w(e, n);
			for (var r, i = y.keys(t), o = 0, a = i.length; a > o; o++)
					if (((r = i[o]), e(t[r], r, t))) return r;
	}), (y.pick = function(t, e, n) {
			var r, i, o = {},
					a = t;
			if (null == a) return o;
			y.isFunction(e) ? ((i = y.allKeys(a)), (r = b(e, n))) : ((i = A(arguments, !1, !1, 1)), (r = function(t, e, n) {
					return e in n;
			}), (a = Object(a)));
			for (var s = 0, c = i.length; c > s; s++) {
					var u = i[s],
							l = a[u];
					r(l, u, a) && (o[u] = l);
			}
			return o;
	}), (y.omit = function(t, e, n) {
			if (y.isFunction(e)) e = y.negate(e);
			else {
					var r = y.map(A(arguments, !1, !1, 1), String);
					e = function(t, e) {
							return !y.contains(r, e);
					};
			}
			return y.pick(t, e, n);
	}), (y.defaults = _(y.allKeys, !0)), (y.create = function(t, e) {
			var n = x(t);
			return e && y.extendOwn(n, e), n;
	}), (y.clone = function(t) {
			return y.isObject(t) ? (y.isArray(t) ? t.slice() : y.extend({}, t)) : t;
	}), (y.tap = function(t, e) {
			return e(t), t;
	}), (y.isMatch = function(t, e) {
			var n = y.keys(e),
					r = n.length;
			if (null == t) return !r;
			for (var i = Object(t), o = 0; r > o; o++) {
					var a = n[o];
					if (e[a] !== i[a] || !(a in i)) return !1;
			}
			return !0;
	});
	var N = function(t, e, n, r) {
			if (t === e) return 0 !== t || 1 / t == 1 / e;
			if (null == t || null == e) return t === e;
			t instanceof y && (t = t._wrapped), e instanceof y && (e = e._wrapped);
			var i = d.call(t);
			if (i !== d.call(e)) return !1;
			switch (i) {
					case "[object RegExp]":
					case "[object String]":
							return "" + t == "" + e;
					case "[object Number]":
							return +t != +t ? +e != +e : 0 == +t ? 1 / +t == 1 / e : +t == +e;
					case "[object Date]":
					case "[object Boolean]":
							return +t == +e;
			}
			var o = "[object Array]" === i;
			if (!o) {
					if ("object" != typeof t || "object" != typeof e) return !1;
					var a = t.constructor,
							s = e.constructor;
					if (
							a !== s &&
							!(y.isFunction(a) &&
									a instanceof a &&
									y.isFunction(s) &&
									s instanceof s) &&
							"constructor" in t &&
							"constructor" in e
					)
							return !1;
			}
			(n = n || []), (r = r || []);
			for (var c = n.length; c--;)
					if (n[c] === t) return r[c] === e;
			if ((n.push(t), r.push(e), o)) {
					if ((c = t.length) !== e.length) return !1;
					for (; c--;)
							if (!N(t[c], e[c], n, r)) return !1;
			} else {
					var u, l = y.keys(t);
					if (((c = l.length), y.keys(e).length !== c)) return !1;
					for (; c--;)
							if (((u = l[c]), !y.has(e, u) || !N(t[u], e[u], n, r))) return !1;
			}
			return n.pop(), r.pop(), !0;
	};
	(y.isEqual = function(t, e) {
			return N(t, e);
	}), (y.isEmpty = function(t) {
			return (
					null == t ||
					(T(t) && (y.isArray(t) || y.isString(t) || y.isArguments(t)) ? 0 === t.length : 0 === y.keys(t).length)
			);
	}), (y.isElement = function(t) {
			return !(!t || 1 !== t.nodeType);
	}), (y.isArray =
			f ||
			function(t) {
					return "[object Array]" === d.call(t);
			}), (y.isObject = function(t) {
			var e = typeof t;
			return "function" === e || ("object" === e && !!t);
	}), y.each(
					["Arguments", "Function", "String", "Number", "Date", "RegExp", "Error"],
					function(t) {
							y["is" + t] = function(e) {
									return d.call(e) === "[object " + t + "]";
							};
					}
			), y.isArguments(arguments) ||
			(y.isArguments = function(t) {
					return y.has(t, "callee");
			}), "function" != typeof /./ &&
			"object" != typeof Int8Array &&
			(y.isFunction = function(t) {
					return "function" == typeof t || !1;
			}), (y.isFinite = function(t) {
					return isFinite(t) && !isNaN(parseFloat(t));
			}), (y.isNaN = function(t) {
					return y.isNumber(t) && t !== +t;
			}), (y.isBoolean = function(t) {
					return !0 === t || !1 === t || "[object Boolean]" === d.call(t);
			}), (y.isNull = function(t) {
					return null === t;
			}), (y.isUndefined = function(t) {
					return void 0 === t;
			}), (y.has = function(t, e) {
					return null != t && p.call(t, e);
			}), (y.noConflict = function() {
					return (i._ = o), this;
			}), (y.identity = function(t) {
					return t;
			}), (y.constant = function(t) {
					return function() {
							return t;
					};
			}), (y.noop = function() {}), (y.property = k), (y.propertyOf = function(t) {
					return null == t ? function() {} : function(e) {
							return t[e];
					};
			}), (y.matcher = y.matches = function(t) {
					return (t = y.extendOwn({}, t)),
							function(e) {
									return y.isMatch(e, t);
							};
			}), (y.times = function(t, e, n) {
					var r = Array(Math.max(0, t));
					e = b(e, n, 1);
					for (var i = 0; t > i; i++)
							r[i] = e(i);
					return r;
			}), (y.random = function(t, e) {
					return null == e && ((e = t), (t = 0)), t +
							Math.floor(Math.random() * (e - t + 1));
			}), (y.now =
					Date.now ||
					function() {
							return new Date().getTime();
					});
	var z = {
					"&": "&amp;",
					"<": "&lt;",
					">": "&gt;",
					'"': "&quot;",
					"'": "&#x27;",
					"`": "&#x60;"
			},
			O = y.invert(z),
			L = function(t) {
					var e = function(e) {
									return t[e];
							},
							n = "(?:" + y.keys(t).join("|") + ")",
							r = RegExp(n),
							i = RegExp(n, "g");
					return function(t) {
							return (t = null == t ? "" : "" + t), r.test(t) ? t.replace(i, e) : t;
					};
			};
	(y.escape = L(z)), (y.unescape = L(O)), (y.result = function(t, e, n) {
			var r = null == t ? void 0 : t[e];
			return void 0 === r && (r = n), y.isFunction(r) ? r.call(t) : r;
	});
	var P = 0;
	(y.uniqueId = function(t) {
			var e = ++P + "";
			return t ? t + e : e;
	}), (y.templateSettings = {
			evaluate: /<%([\s\S]+?)%>/g,
			interpolate: /<%=([\s\S]+?)%>/g,
			escape: /<%-([\s\S]+?)%>/g
	});
	var M = /(.)^/,
			D = {
					"'": "'",
					"\\": "\\",
					"\r": "r",
					"\n": "n",
					"\u2028": "u2028",
					"\u2029": "u2029"
			},
			q = /\\|'|\r|\n|\u2028|\u2029/g,
			R = function(t) {
					return "\\" + D[t];
			};
	(y.template = function(t, e, n) {
			!e && n && (e = n), (e = y.defaults({}, e, y.templateSettings));
			var r = RegExp(
							[
									(e.escape || M).source, (e.interpolate || M).source, (e.evaluate || M).source
							].join("|") + "|$",
							"g"
					),
					i = 0,
					o = "__p+='";
			t.replace(r, function(e, n, r, a, s) {
					return (o += t
							.slice(i, s)
							.replace(
									q,
									R
							)), (i = s + e.length), n ? (o += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'") : r ? (o += "'+\n((__t=(" + r + "))==null?'':__t)+\n'") : a && (o += "';\n" + a + "\n__p+='"), e;
			}), (o += "';\n"), e.variable || (o = "with(obj||{}){\n" + o + "}\n"), (o =
					"var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" +
					o +
					"return __p;\n");
			try {
					var a = new Function(e.variable || "obj", "_", o);
			} catch (t) {
					throw ((t.source = o), t);
			}
			var s = function(t) {
							return a.call(this, t, y);
					},
					c = e.variable || "obj";
			return (s.source = "function(" + c + "){\n" + o + "}"), s;
	}), (y.chain = function(t) {
			var e = y(t);
			return (e._chain = !0), e;
	});
	var F = function(t, e) {
			return t._chain ? y(e).chain() : e;
	};
	(y.mixin = function(t) {
			y.each(y.functions(t), function(e) {
					var n = (y[e] = t[e]);
					y.prototype[e] = function() {
							var t = [this._wrapped];
							return u.apply(t, arguments), F(this, n.apply(y, t));
					};
			});
	}), y.mixin(y), y.each(
					["pop", "push", "reverse", "shift", "sort", "splice", "unshift"],
					function(t) {
							var e = a[t];
							y.prototype[t] = function() {
									var n = this._wrapped;
									return e.apply(n, arguments), ("shift" !== t && "splice" !== t) ||
											0 !== n.length ||
											delete n[0], F(this, n);
							};
					}
			), y.each(["concat", "join", "slice"], function(t) {
					var e = a[t];
					y.prototype[t] = function() {
							return F(this, e.apply(this._wrapped, arguments));
					};
			}), (y.prototype.value = function() {
					return this._wrapped;
			}), (y.prototype.valueOf = y.prototype.toJSON =
					y.prototype.value), (y.prototype.toString = function() {
					return "" + this._wrapped;
			}), "function" == typeof define &&
			define.amd &&
			define("underscore", [], function() {
					return y;
			});
}.call(this)